var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 431.3 355.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-307,.cls-8{opacity:0.4;}.cls-143,.cls-162,.cls-170,.cls-192,.cls-8{mix-blend-mode:multiply;}.cls-9{opacity:0;}.cls-10{fill:#fff;}.cls-11{opacity:0.03;}.cls-12{fill:#fdfdfe;}.cls-13{opacity:0.06;}.cls-14{fill:#fafbfe;}.cls-15{opacity:0.1;}.cls-16{fill:#f8f9fd;}.cls-17{opacity:0.13;}.cls-18{fill:#f6f7fc;}.cls-19{opacity:0.16;}.cls-20{fill:#f3f5fc;}.cls-21{opacity:0.19;}.cls-22{fill:#f1f3fb;}.cls-23{opacity:0.23;}.cls-24{fill:#eff1fa;}.cls-25{opacity:0.26;}.cls-26{fill:#eceffa;}.cls-27{opacity:0.29;}.cls-28{fill:#eaedf9;}.cls-29{opacity:0.32;}.cls-30{fill:#e8ebf9;}.cls-31{opacity:0.35;}.cls-32{fill:#e5e9f8;}.cls-33{opacity:0.39;}.cls-34{fill:#e3e7f7;}.cls-35{opacity:0.42;}.cls-36{fill:#e1e5f7;}.cls-37{opacity:0.45;}.cls-38{fill:#dee3f6;}.cls-39{opacity:0.48;}.cls-40{fill:#dce1f5;}.cls-41{opacity:0.52;}.cls-42{fill:#dadef5;}.cls-43{opacity:0.55;}.cls-44{fill:#d8dcf4;}.cls-45{opacity:0.58;}.cls-46{fill:#d5daf3;}.cls-47{opacity:0.61;}.cls-48{fill:#d3d8f3;}.cls-49{opacity:0.65;}.cls-50{fill:#d1d6f2;}.cls-51{opacity:0.68;}.cls-52{fill:#ced4f1;}.cls-53{opacity:0.71;}.cls-54{fill:#ccd2f1;}.cls-55{opacity:0.74;}.cls-56{fill:#cad0f0;}.cls-57{opacity:0.77;}.cls-58{fill:#c7cef0;}.cls-59{opacity:0.81;}.cls-60{fill:#c5ccef;}.cls-61{opacity:0.84;}.cls-62{fill:#c3caee;}.cls-63{opacity:0.87;}.cls-64{fill:#c0c8ee;}.cls-65{opacity:0.9;}.cls-66{fill:#bec6ed;}.cls-67{opacity:0.94;}.cls-68{fill:#bcc4ec;}.cls-69{opacity:0.97;}.cls-70{fill:#b9c2ec;}.cls-71{fill:#b7c0eb;}.cls-72{fill:#e4e7fb;}.cls-73{fill:#eff1fe;}.cls-74{fill:url(#linear-gradient-7);}.cls-75{fill:url(#linear-gradient-8);}.cls-76{fill:url(#linear-gradient-9);}.cls-77{fill:url(#linear-gradient-10);}.cls-78{fill:url(#linear-gradient-11);}.cls-79{fill:url(#linear-gradient-12);}.cls-80{fill:url(#linear-gradient-13);}.cls-81{fill:url(#linear-gradient-14);}.cls-82{fill:url(#linear-gradient-15);}.cls-83{fill:url(#linear-gradient-16);}.cls-84{fill:url(#linear-gradient-17);}.cls-85{fill:url(#linear-gradient-18);}.cls-86{fill:url(#linear-gradient-19);}.cls-87{fill:url(#linear-gradient-20);}.cls-88{fill:url(#linear-gradient-21);}.cls-89{fill:url(#linear-gradient-22);}.cls-90{fill:url(#linear-gradient-23);}.cls-91{fill:url(#linear-gradient-24);}.cls-92{fill:url(#linear-gradient-25);}.cls-93{fill:url(#linear-gradient-26);}.cls-94{fill:url(#linear-gradient-27);}.cls-95{fill:url(#linear-gradient-28);}.cls-96{fill:url(#linear-gradient-29);}.cls-97{fill:url(#linear-gradient-30);}.cls-98{fill:url(#linear-gradient-31);}.cls-99{fill:url(#linear-gradient-32);}.cls-100{fill:url(#linear-gradient-33);}.cls-101{fill:url(#linear-gradient-34);}.cls-102{fill:url(#linear-gradient-35);}.cls-103{fill:url(#linear-gradient-36);}.cls-104{fill:url(#linear-gradient-37);}.cls-105{fill:url(#linear-gradient-38);}.cls-106{fill:url(#linear-gradient-39);}.cls-107{opacity:0.05;}.cls-108{fill:#fcfcfe;}.cls-109{opacity:0.1;}.cls-110{opacity:0.14;}.cls-111{fill:#f5f6fc;}.cls-112{opacity:0.19;}.cls-113{opacity:0.24;}.cls-114{fill:#eef0fa;}.cls-115{opacity:0.29;}.cls-116{opacity:0.33;}.cls-117{fill:#e7eaf8;}.cls-118{opacity:0.38;}.cls-119{fill:#e4e7f7;}.cls-120{opacity:0.43;}.cls-121{fill:#e0e4f6;}.cls-122{opacity:0.48;}.cls-123{fill:#dde1f5;}.cls-124{opacity:0.52;}.cls-125{fill:#d9def5;}.cls-126{opacity:0.57;}.cls-127{fill:#d6dbf4;}.cls-128{opacity:0.62;}.cls-129{fill:#d2d8f3;}.cls-130{opacity:0.67;}.cls-131{fill:#cfd5f2;}.cls-132{opacity:0.71;}.cls-133{opacity:0.76;}.cls-134{fill:#c8cff0;}.cls-135{opacity:0.81;}.cls-136{opacity:0.86;}.cls-137{fill:#c1c9ee;}.cls-138{opacity:0.9;}.cls-139{opacity:0.95;}.cls-140{fill:#bac3ec;}.cls-141{fill:url(#linear-gradient-40);}.cls-142{fill:url(#linear-gradient-41);}.cls-143{opacity:0.5;}.cls-144{fill:url(#linear-gradient-42);}.cls-145{fill:url(#linear-gradient-43);}.cls-146{fill:url(#linear-gradient-44);}.cls-147{fill:url(#linear-gradient-45);}.cls-148{fill:#e87087;}.cls-149{fill:url(#linear-gradient-46);}.cls-150{fill:url(#linear-gradient-47);}.cls-151{fill:#1855b2;}.cls-152{fill:#184eae;}.cls-153{fill:url(#linear-gradient-48);}.cls-154{fill:#4d5986;}.cls-155{fill:url(#linear-gradient-49);}.cls-156{fill:url(#linear-gradient-50);}.cls-157{fill:url(#linear-gradient-51);}.cls-158{fill:url(#linear-gradient-52);}.cls-159{fill:#cae6fd;}.cls-160{fill:url(#linear-gradient-53);}.cls-161{fill:url(#linear-gradient-54);}.cls-162{opacity:0.7;}.cls-163{fill:url(#linear-gradient-55);}.cls-164{fill:url(#linear-gradient-56);}.cls-165{fill:url(#linear-gradient-57);}.cls-166{fill:url(#linear-gradient-58);}.cls-167{fill:url(#linear-gradient-59);}.cls-168{fill:url(#linear-gradient-60);}.cls-169{fill:url(#linear-gradient-61);}.cls-171{fill:url(#linear-gradient-62);}.cls-172{fill:url(#linear-gradient-63);}.cls-173{fill:url(#linear-gradient-64);}.cls-174{fill:url(#linear-gradient-65);}.cls-175{fill:url(#linear-gradient-66);}.cls-176{opacity:0.3;}.cls-176,.cls-307{mix-blend-mode:overlay;}.cls-177{fill:url(#linear-gradient-67);}.cls-178{fill:url(#linear-gradient-68);}.cls-179{fill:url(#linear-gradient-69);}.cls-180{fill:url(#linear-gradient-70);}.cls-181{fill:url(#linear-gradient-71);}.cls-182{fill:url(#linear-gradient-72);}.cls-183{fill:url(#linear-gradient-73);}.cls-184{fill:url(#linear-gradient-74);}.cls-185{fill:url(#linear-gradient-75);}.cls-186{fill:url(#linear-gradient-76);}.cls-187{fill:url(#linear-gradient-77);}.cls-188{fill:url(#linear-gradient-78);}.cls-189{fill:url(#linear-gradient-79);}.cls-190{fill:url(#linear-gradient-80);}.cls-191{fill:url(#linear-gradient-81);}.cls-192{opacity:0.8;}.cls-193{opacity:0.02;}.cls-194{fill:#fdfdff;}.cls-195{opacity:0.05;}.cls-196{fill:#fbfcfe;}.cls-197{opacity:0.07;}.cls-198{fill:#fafafe;}.cls-199{opacity:0.1;}.cls-200{opacity:0.12;}.cls-201{fill:#f6f7fd;}.cls-202{opacity:0.15;}.cls-203{fill:#f4f6fc;}.cls-204{opacity:0.17;}.cls-205{fill:#f3f4fc;}.cls-206{opacity:0.2;}.cls-207{opacity:0.22;}.cls-208{fill:#eff1fb;}.cls-209{opacity:0.24;}.cls-210{fill:#edf0fa;}.cls-211{opacity:0.27;}.cls-212{fill:#eceefa;}.cls-213{opacity:0.29;}.cls-214{opacity:0.32;}.cls-215{opacity:0.34;}.cls-216{fill:#e6e9f8;}.cls-217{opacity:0.37;}.cls-218{fill:#e5e8f8;}.cls-219{opacity:0.39;}.cls-220{fill:#e3e6f7;}.cls-221{opacity:0.41;}.cls-222{opacity:0.44;}.cls-223{fill:#dfe3f6;}.cls-224{opacity:0.46;}.cls-225{fill:#dee2f6;}.cls-226{opacity:0.49;}.cls-227{fill:#dce0f5;}.cls-228{opacity:0.51;}.cls-229{fill:#dadff5;}.cls-230{opacity:0.54;}.cls-231{fill:#d8ddf4;}.cls-232{opacity:0.56;}.cls-233{fill:#d7dcf4;}.cls-234{opacity:0.59;}.cls-235{opacity:0.61;}.cls-236{fill:#d3d9f3;}.cls-237{opacity:0.63;}.cls-238{fill:#d1d7f2;}.cls-239{opacity:0.66;}.cls-240{fill:#d0d6f2;}.cls-241{opacity:0.68;}.cls-242{opacity:0.71;}.cls-243{opacity:0.73;}.cls-244{fill:#cad1f0;}.cls-245{opacity:0.76;}.cls-246{fill:#c9cff0;}.cls-247{opacity:0.78;}.cls-248{fill:#c7ceef;}.cls-249{opacity:0.8;}.cls-250{opacity:0.83;}.cls-251{fill:#c3cbee;}.cls-252{opacity:0.85;}.cls-253{fill:#c2c9ee;}.cls-254{opacity:0.88;}.cls-255{fill:#c0c8ed;}.cls-256{opacity:0.9;}.cls-257{opacity:0.93;}.cls-258{fill:#bcc5ec;}.cls-259{opacity:0.95;}.cls-260{fill:#bbc3ec;}.cls-261{opacity:0.98;}.cls-262{fill:#b9c2eb;}.cls-263{fill:url(#linear-gradient-82);}.cls-264{fill:url(#linear-gradient-83);}.cls-265{fill:url(#linear-gradient-84);}.cls-266{fill:url(#linear-gradient-85);}.cls-267{fill:url(#linear-gradient-86);}.cls-268{fill:url(#linear-gradient-87);}.cls-269{fill:url(#linear-gradient-88);}.cls-270{fill:url(#linear-gradient-89);}.cls-271{fill:url(#linear-gradient-90);}.cls-272{fill:url(#linear-gradient-91);}.cls-273{fill:url(#linear-gradient-92);}.cls-274{fill:url(#linear-gradient-93);}.cls-275{fill:url(#linear-gradient-94);}.cls-276{fill:url(#linear-gradient-95);}.cls-277{fill:url(#linear-gradient-96);}.cls-278{fill:url(#linear-gradient-97);}.cls-279{fill:url(#linear-gradient-98);}.cls-280{fill:url(#linear-gradient-99);}.cls-281{fill:url(#linear-gradient-100);}.cls-282{fill:#4cd9ed;}.cls-283{fill:url(#linear-gradient-101);}.cls-284{fill:#fefeff;}.cls-285{fill:#fcfdff;}.cls-286{fill:#f9f9fe;}.cls-287{fill:#f7f8fe;}.cls-288{fill:#f6f7fe;}.cls-289{fill:#f5f6fd;}.cls-290{fill:#f3f5fd;}.cls-291{fill:#f2f4fd;}.cls-292{fill:#f1f2fd;}.cls-293{fill:#f0f1fd;}.cls-294{fill:#eef0fd;}.cls-295{fill:#edeffc;}.cls-296{fill:#eceefc;}.cls-297{fill:#eaedfc;}.cls-298{fill:#e9ecfc;}.cls-299{fill:#e8eafc;}.cls-300{fill:#e7e9fb;}.cls-301{fill:#e5e8fb;}.cls-302{fill:#fdfcff;}.cls-303{fill:url(#linear-gradient-102);}.cls-304{fill:none;}.cls-305{fill:url(#linear-gradient-103);}.cls-306{fill:url(#linear-gradient-104);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 303.59,
    y1: 327.54,
    x2: 330.27,
    y2: 317.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#437fec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#48b2ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cd9ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 299.4,
    y1: 310.81,
    x2: 324.16,
    y2: 301.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 291.86,
    y1: 295.3,
    x2: 318.55,
    y2: 285.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 128.28,
    y1: 292.26,
    x2: 238.61,
    y2: 252.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 104.84,
    y1: 222.77,
    x2: 213.48,
    y2: 183.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 78.1,
    y1: 154.48,
    x2: 188.52,
    y2: 114.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1530.17,
    y1: 7724.82,
    x2: -1530.17,
    y2: 7729.33,
    gradientTransform: "translate(-7359.7 37557) rotate(180) scale(4.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f7f9fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 225.37,
    y1: 2966.98,
    x2: 241.85,
    y2: 2966.98,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -304.45,
    y1: 5264.55,
    x2: -303.89,
    y2: 5264.55,
    gradientTransform: "translate(1998.1 -33672.8) scale(6.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eff1fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 232.02,
    y1: 2966.92,
    x2: 235.22,
    y2: 2966.92,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 232.65,
    y1: 2966.92,
    x2: 234.59,
    y2: 2966.92,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1547.45,
    y1: 7734.92,
    x2: -1547.45,
    y2: 7739.43,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 266.9,
    y1: 2942.71,
    x2: 283.37,
    y2: 2942.71,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -291.46,
    y1: 5256.96,
    x2: -290.91,
    y2: 5256.96,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 273.54,
    y1: 2942.65,
    x2: 276.74,
    y2: 2942.65,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 274.17,
    y1: 2942.65,
    x2: 276.11,
    y2: 2942.65,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 251.11,
    y1: 373.51,
    x2: 74.64,
    y2: 309.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 289.14,
    y1: 263.19,
    x2: 114.59,
    y2: 199.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 330.73,
    y1: 154.16,
    x2: 154.3,
    y2: 89.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1544.4,
    y1: 7692.78,
    x2: -1544.4,
    y2: 7697.29,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 259.56,
    y1: 3043.99,
    x2: 276.04,
    y2: 3043.99,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -293.76,
    y1: 5288.64,
    x2: -293.2,
    y2: 5288.64,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 266.2,
    y1: 3043.93,
    x2: 269.41,
    y2: 3043.93,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 266.84,
    y1: 3043.93,
    x2: 268.78,
    y2: 3043.93,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -1525.56,
    y1: 7703.46,
    x2: -1525.56,
    y2: 7707.97,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 214.29,
    y1: 3018.31,
    x2: 230.77,
    y2: 3018.31,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -307.92,
    y1: 5280.61,
    x2: -307.36,
    y2: 5280.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 220.94,
    y1: 3018.25,
    x2: 224.14,
    y2: 3018.25,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 221.57,
    y1: 3018.25,
    x2: 223.51,
    y2: 3018.25,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -1599.45,
    y1: 7726.19,
    x2: -1599.45,
    y2: 7730.7,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 391.87,
    y1: 2963.7,
    x2: 408.35,
    y2: 2963.7,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -252.37,
    y1: 5263.53,
    x2: -251.81,
    y2: 5263.53,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 398.52,
    y1: 2963.64,
    x2: 401.72,
    y2: 2963.64,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 399.15,
    y1: 2963.64,
    x2: 401.09,
    y2: 2963.64,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -1580.61,
    y1: 7736.87,
    x2: -1580.61,
    y2: 7741.38,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 346.61,
    y1: 2938.02,
    x2: 363.08,
    y2: 2938.02,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -266.53,
    y1: 5255.49,
    x2: -265.97,
    y2: 5255.49,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 353.25,
    y1: 2937.97,
    x2: 356.45,
    y2: 2937.97,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 353.88,
    y1: 2937.97,
    x2: 355.83,
    y2: 2937.97,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -1140.15,
    y1: 8736.85,
    x2: -1140.15,
    y2: 8800.58,
    gradientTransform: "translate(-2479.1 20789.7) rotate(180) scale(2.35)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -601.31,
    y1: 4505.19,
    x2: -593.44,
    y2: 4505.19,
    gradientTransform: "translate(2059.5 -13757.3) scale(3.12)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 720.52,
    y1: -1459.14,
    x2: 728.11,
    y2: -1459.14,
    gradientTransform: "translate(-190.1 1373.3) scale(0.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cd9ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4ac2ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4592ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437fec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 679.62,
    y1: -1443.56,
    x2: 723.86,
    y2: -1443.56,
    gradientTransform: "translate(-190.1 1373.3) scale(0.76)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 683.74,
    y1: -1440.77,
    x2: 722.15,
    y2: -1440.77,
    gradientTransform: "translate(-190.1 1373.3) scale(0.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e4e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 667.81,
    y1: -1445.1,
    x2: 691.41,
    y2: -1421.5,
    gradientTransform: "translate(-190.1 1373.3) scale(0.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cd9ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#47a6ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437fec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 686.08,
    y1: -1421.37,
    x2: 680.88,
    y2: -1431.59,
    gradientTransform: "translate(-190.1 1373.3) scale(0.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cd9ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4bd7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2775c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#184eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437fec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 652.07,
    y1: -1423.57,
    x2: 673.67,
    y2: -1423.57,
    gradientTransform: "translate(-190.1 1373.3) scale(0.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#437fec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#336cd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184eae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 566.72,
    y1: -1397.77,
    x2: 669.95,
    y2: -1397.77,
    gradientTransform: "translate(-190.1 1373.3) scale(0.76)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 285.07,
    y1: 318.57,
    x2: 281.23,
    y2: 311.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 567,
    y1: -1376.61,
    x2: 589.98,
    y2: -1372.56,
    gradientTransform: "translate(-190.1 1373.3) scale(0.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cd9ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4cd4ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4ac7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#48b0ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4591ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437fec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 585.83,
    y1: -1376.64,
    x2: 585.83,
    y2: -1361.02,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 249.16,
    y1: 310.93,
    x2: 284.84,
    y2: 310.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 596.59,
    y1: -1402.37,
    x2: 599.96,
    y2: -1396.02,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 116.4,
    y1: -4648.66,
    x2: 121.75,
    y2: -4648.66,
    gradientTransform: "translate(73.4 2717.8) scale(0.53)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 94.54,
    y1: -4634.77,
    x2: 111.77,
    y2: -4634.77,
    gradientTransform: "translate(73.4 2717.8) scale(0.53)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 94.56,
    y1: -4650.05,
    x2: 212.41,
    y2: -4650.05,
    gradientTransform: "translate(73.4 2717.8) scale(0.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5fefc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5cecc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cd9ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -1591.88,
    y1: 7696.48,
    x2: -1591.88,
    y2: 7700.99,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 373.69,
    y1: 3035.09,
    x2: 390.16,
    y2: 3035.09,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -258.06,
    y1: 5285.86,
    x2: -257.5,
    y2: 5285.86,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 380.33,
    y1: 3035.03,
    x2: 383.53,
    y2: 3035.03,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 380.96,
    y1: 3035.03,
    x2: 382.9,
    y2: 3035.03,
    gradientTransform: "translate(-429 -5786.5) scale(2.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1802.14,
    y1: 4203.97,
    x2: 1806.27,
    y2: 4203.97,
    gradientTransform: "translate(-12338.2 -28638.6) rotate(0) scale(6.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1806.33,
    y1: 4204.91,
    x2: 1805.5,
    y2: 4203.92,
    gradientTransform: "translate(-12338.2 -28638.6) rotate(0) scale(6.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 4.06,
    y1: 3726.73,
    x2: 1.44,
    y2: 3719.53,
    gradientTransform: "translate(73 -17498.5) scale(4.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cfd4f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#dee2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e4e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1807.6,
    y1: 4207.85,
    x2: 1807.6,
    y2: 4204.14,
    gradientTransform: "translate(-12338.2 -28638.6) rotate(0) scale(6.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#eaecfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fafbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -6.52,
    y1: 3721.27,
    x2: 2.05,
    y2: 3721.27,
    gradientTransform: "translate(73 -17498.5) scale(4.78)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -1639.68,
    y1: 8007.87,
    x2: -1639.68,
    y2: 8012.38,
    gradientTransform: "translate(-5680.1 28984) rotate(180) scale(3.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 488.42,
    y1: 2287.27,
    x2: 504.89,
    y2: 2287.27,
    gradientTransform: "translate(-544.7 -3131.6) scale(1.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -222.07,
    y1: 5051.77,
    x2: -221.51,
    y2: 5051.77,
    gradientTransform: "matrix(4.77, 0, 0, 4.77, 1253.12, -23793.12)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 495.06,
    y1: 2287.22,
    x2: 498.26,
    y2: 2287.22,
    gradientTransform: "translate(-544.7 -3131.6) scale(1.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 495.69,
    y1: 2287.22,
    x2: 497.64,
    y2: 2287.22,
    gradientTransform: "translate(-544.7 -3131.6) scale(1.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -1609.77,
    y1: 8024.79,
    x2: -1609.77,
    y2: 8029.3,
    gradientTransform: "translate(-5680.1 28984) rotate(180) scale(3.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 416.54,
    y1: 2246.61,
    x2: 433.02,
    y2: 2246.61,
    gradientTransform: "translate(-544.7 -3131.6) scale(1.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -244.55,
    y1: 5039.05,
    x2: -243.99,
    y2: 5039.05,
    gradientTransform: "matrix(4.77, 0, 0, 4.77, 1253.12, -23793.12)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 423.19,
    y1: 2246.56,
    x2: 426.39,
    y2: 2246.56,
    gradientTransform: "translate(-544.7 -3131.6) scale(1.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 423.82,
    y1: 2246.56,
    x2: 425.76,
    y2: 2246.56,
    gradientTransform: "translate(-544.7 -3131.6) scale(1.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -1669.38,
    y1: 8025.17,
    x2: -1669.38,
    y2: 8029.68,
    gradientTransform: "translate(-5680.1 28984) rotate(180) scale(3.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 559.81,
    y1: 2245.7,
    x2: 576.28,
    y2: 2245.7,
    gradientTransform: "translate(-544.7 -3131.6) scale(1.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -199.74,
    y1: 5038.77,
    x2: -199.18,
    y2: 5038.77,
    gradientTransform: "matrix(4.77, 0, 0, 4.77, 1253.12, -23793.12)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 566.45,
    y1: 2245.64,
    x2: 569.65,
    y2: 2245.64,
    gradientTransform: "translate(-544.7 -3131.6) scale(1.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 567.08,
    y1: 2245.64,
    x2: 569.02,
    y2: 2245.64,
    gradientTransform: "translate(-544.7 -3131.6) scale(1.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 137.58,
    y1: 126.65,
    x2: 313.78,
    y2: 126.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 198.21,
    y1: 228.25,
    x2: 223.15,
    y2: 185.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#e4e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eff1fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 199.83,
    y1: 246.07,
    x2: 199.83,
    y2: 160.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c1c8ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#d4d9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e0e4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 187.43,
    y1: 207.29,
    x2: 255.26,
    y2: 207.29,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 153.52,
    y1: -424.88,
    x2: 153.52,
    y2: -486.69,
    gradientTransform: "translate(72.3 591.6) rotate(2.3) scale(0.86)",
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 181.88,
    y1: 223.58,
    x2: 186.82,
    y2: 215.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#bac3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d7dcf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e9ecfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eff1fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 183.75,
    y1: 213.59,
    x2: 203.79,
    y2: 178.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#eff1fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f5f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 266.01,
    y1: 68.73,
    x2: 266.01,
    y2: 4.86,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 269,
    y1: 253.25,
    x2: 269,
    y2: 49.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 228.1,
    y1: 70.62,
    x2: 256.45,
    y2: 21.52,
    xlinkHref: "#linear-gradient-88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 194.63,
    y1: 116.71,
    x2: 249.83,
    y2: 116.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 194.61,
    y1: 125.44,
    x2: 249.81,
    y2: 125.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 194.58,
    y1: 134.17,
    x2: 249.78,
    y2: 134.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 194.56,
    y1: 142.9,
    x2: 249.76,
    y2: 142.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 194.53,
    y1: 151.63,
    x2: 249.73,
    y2: 151.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 194.51,
    y1: 158.06,
    x2: 241.71,
    y2: 158.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 194.48,
    y1: 164.48,
    x2: 233.69,
    y2: 164.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 49.19,
    y1: 156.75,
    x2: 118.4,
    y2: 156.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 51.86,
    y1: 156.75,
    x2: 115.73,
    y2: 156.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 58.43,
    y1: 142.78,
    x2: 63.94,
    y2: 142.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 288.88,
    y1: 150.67,
    x2: 371.12,
    y2: 150.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 307.35,
    y1: 157.4,
    x2: 329.77,
    y2: 157.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 314.98,
    y1: 97.89,
    x2: 374.49,
    y2: 147.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.9,318.6h-.2l-.5-.3c-.2-.1-.2-.3-.1-.5a.5.5,0,0,1,.6-.2l.5.3c.2.1.2.4.1.6A.5.5,0,0,1,329.9,318.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325,315.5h-.2l-.9-.6a.4.4,0,0,1-.2-.5.5.5,0,0,1,.6-.2l.9.6c.2.1.3.3.1.5S325.1,315.5,325,315.5Zm-5.4-3.3h-.2l-.9-.6a.5.5,0,0,1-.2-.6.5.5,0,0,1,.6-.1l.9.6a.4.4,0,0,1,.2.5A.4.4,0,0,1,319.6,312.2Zm-5.4-3.3H314l-.9-.6a.5.5,0,0,1-.2-.6.5.5,0,0,1,.6-.1l.9.5c.2.2.3.4.2.6A.4.4,0,0,1,314.2,308.9Zm-5.4-3.3h-.2l-.9-.5a.4.4,0,0,1-.1-.6c.1-.2.3-.2.5-.1l.9.5a.5.5,0,0,1,.2.6A.5.5,0,0,1,308.8,305.6Zm-5.4-3.3h-.2l-.9-.5c-.2-.1-.2-.4-.1-.6a.4.4,0,0,1,.6-.1l.9.5c.2.1.2.4.1.6A.5.5,0,0,1,303.4,302.3ZM298,299h-.2l-.9-.5a.5.5,0,0,1-.1-.6.5.5,0,0,1,.6-.2l.9.6c.2.1.2.4.1.6A.5.5,0,0,1,298,299Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.7,295.7h-.3l-.4-.3a.5.5,0,0,1-.2-.6c.1-.2.4-.2.6-.1l.5.3c.2.1.2.4.1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M238.3,252.9h-.2l-.5-.3a.5.5,0,0,1-.2-.6.5.5,0,0,1,.6-.1l.5.3a.4.4,0,0,1,.1.6C238.6,252.8,238.4,252.9,238.3,252.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233,249.7h-.2l-.9-.6a.5.5,0,0,1-.2-.6.5.5,0,0,1,.6-.1l1,.6c.2.1.2.4.1.6Zm-5.7-3.6h-.2l-.9-.6a.5.5,0,0,1-.2-.6.5.5,0,0,1,.6-.1l1,.6c.2.1.2.3.1.5S227.5,246.1,227.3,246.1Zm-5.7-3.5h-.2l-.9-.6a.5.5,0,0,1-.2-.6.4.4,0,0,1,.6-.1l1,.6c.2.1.2.3.1.5S221.8,242.6,221.6,242.6Zm-5.7-3.5h-.2l-1-.6c-.2-.1-.2-.4-.1-.6a.4.4,0,0,1,.6-.1l.9.5c.2.2.3.4.2.6S216.1,239.1,215.9,239.1Zm-5.7-3.5H210l-1-.6a.5.5,0,0,1-.1-.6.5.5,0,0,1,.6-.2l.9.6c.2.2.3.4.2.6Zm-5.7-3.5h-.2l-1-.5a.5.5,0,0,1-.1-.6.5.5,0,0,1,.6-.2l.9.6a.5.5,0,0,1,.2.6Zm-5.7-3.5h-.2l-1-.6c-.2-.1-.2-.3-.1-.5a.5.5,0,0,1,.6-.2l.9.6a.5.5,0,0,1,.2.6Zm-5.7-3.5h-.2l-1-.6c-.2-.1-.2-.4-.1-.6s.4-.2.6-.1l.9.6a.4.4,0,0,1,.1.6Zm-5.7-3.5h-.2l-1-.6a.4.4,0,0,1-.1-.6c.1-.2.3-.2.5-.1l1,.6a.4.4,0,0,1,.1.6Zm-5.7-3.5h-.3l-.9-.6a.4.4,0,0,1-.1-.6c.1-.2.3-.2.5-.1l1,.6a.4.4,0,0,1,.1.6Zm-5.7-3.6h-.3l-.9-.6a.5.5,0,0,1-.2-.6.5.5,0,0,1,.6-.1l1,.6c.2.1.2.3.1.5S176.1,214.5,176,214.5Zm-5.7-3.5H170l-.9-.6a.5.5,0,0,1-.2-.6c.2-.2.4-.3.6-.1l1,.5a.5.5,0,0,1,.1.6C170.5,211,170.4,211,170.3,211Zm-5.8-3.5h-.2l-.9-.6c-.2-.2-.3-.4-.2-.6s.4-.3.6-.1l1,.5a.5.5,0,0,1,.1.6Zm-5.7-3.5h-.2l-.9-.5c-.2-.2-.3-.4-.2-.6a.5.5,0,0,1,.6-.2l1,.6c.2.1.2.4.1.6Zm-5.7-3.5h-.2l-.9-.5c-.2-.2-.3-.4-.2-.6a.5.5,0,0,1,.6-.2l.9.6a.5.5,0,0,1,.2.6Zm-5.7-3.5h-.2l-1-.6c-.2-.1-.2-.3-.1-.5a.5.5,0,0,1,.6-.2l.9.6a.5.5,0,0,1,.2.6Zm-5.7-3.5h-.2l-1-.6c-.2-.1-.2-.4-.1-.6s.4-.2.6-.1l.9.6a.5.5,0,0,1,.2.6ZM136,190h-.2l-1-.6c-.2-.1-.2-.4-.1-.6s.4-.2.6-.1l.9.6a.5.5,0,0,1,.2.6Zm-5.7-3.5h-.2l-1-.6c-.2-.1-.2-.4-.1-.6s.4-.2.6-.1l.9.6a.4.4,0,0,1,.1.6Zm-5.7-3.6h-.2l-1-.6a.4.4,0,1,1,.5-.7l.9.6c.2.1.3.3.1.5S124.7,182.9,124.6,182.9Zm-5.7-3.5h-.3l-.9-.6a.4.4,0,0,1-.1-.6c.1-.2.3-.3.5-.1l1,.5c.2.2.3.4.1.6S119,179.4,118.9,179.4Zm-5.7-3.5h-.3l-.9-.6c-.2-.2-.3-.4-.2-.6s.4-.3.6-.2l1,.6a.5.5,0,0,1,.1.6Zm-5.7-3.5h-.3l-.9-.5c-.2-.2-.3-.4-.2-.6s.4-.3.6-.2l1,.6c.2.1.2.4.1.6Zm-5.8-3.5h-.2l-.9-.6a.4.4,0,0,1-.2-.5c.2-.2.4-.3.6-.2l1,.6c.2.1.2.4.1.6A.5.5,0,0,1,101.7,168.9ZM96,165.4h-.2l-.9-.6a.4.4,0,0,1-.2-.5.5.5,0,0,1,.6-.2l1,.6c.2.1.2.4.1.6Zm-5.7-3.5h-.2l-.9-.6a.5.5,0,0,1-.2-.6c.1-.2.4-.2.6-.1l.9.6a.5.5,0,0,1,.2.6Zm-5.7-3.5h-.2l-1-.6c-.2-.1-.2-.4-.1-.6s.4-.2.6-.1l.9.6a.5.5,0,0,1,.2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.9,154.8h-.2l-.5-.3a.4.4,0,0,1-.1-.6c.1-.2.3-.3.5-.1l.5.3a.4.4,0,0,1,.2.5C79.2,154.8,79.1,154.8,78.9,154.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M50.2,190.5c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L70,200.1a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M49.3,190.5a1,1,0,0,1,0-1.9L65.8,179a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M48.4,190.4c-.8-.5-.9-1.3,0-1.8L64.9,179a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1,1,0,0,1,0,1.8L68.2,200a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M47.5,190.4c-.8-.6-.8-1.4,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.9L67.4,200a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M46.7,190.3c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.1,3.1,0,0,1,3.2,0L83,188.5c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M45.8,190.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M44.9,190.2a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.6.9,1.4.1,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M44,190.1a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M43.2,190.1a1,1,0,0,1,0-1.9l16.5-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.9L63,199.7a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M42.3,190c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M41.4,189.9c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.7a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M40.5,189.9a1,1,0,0,1,0-1.8l16.6-9.7a3.4,3.4,0,0,1,3.1,0l16.7,9.7a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M39.7,189.8c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0L76,188c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M38.8,189.8a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M37.9,189.7c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M37,189.7a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M36.1,189.6a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8L56,199.2a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M35.3,189.5c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.1,3.1,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M34.4,189.5c-.9-.5-.9-1.3,0-1.9L50.9,178a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M33.5,189.4c-.9-.5-.9-1.3,0-1.8L50,178a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3.1,1.8L53.3,199a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M32.6,189.4a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0L69,187.5a1.1,1.1,0,0,1,0,1.9L52.4,199a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M31.8,189.3c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M30.9,189.3c-.9-.6-.9-1.4,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M30,189.2c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M29.1,189.1a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M28.3,189.1a1,1,0,0,1-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.6.9,1.4,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M27.4,189c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M26.5,189a1,1,0,0,1,0-1.9L43,177.5a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M25.6,188.9c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0L62,187.1a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M24.7,188.8a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0L61.1,187a1,1,0,0,1,0,1.8l-16.5,9.6a3.1,3.1,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M23.9,188.8c-.9-.5-.9-1.3,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0L60.2,187c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M23,188.7c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M23,188.8c-.9-.5-.9-1.3,0-1.8H39.5a3.6,3.6,0,0,1,3.2,0H59.3c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M60,185h-.4c-.1,0-.1,0-.1.1h-.2l-16.5,9.6v2.1L59.3,188h.6V185Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M23,185.9c-.4-.3-.7-.6-.7-1v2.2a1,1,0,0,0,.7.9l16.6,9.6v-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M59.3,184a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0L23,185.9a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M23,185.1c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.1,3.1,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M41.2,193.9a2.9,2.9,0,0,1-1.4-.4l-14.6-8.4a1,1,0,0,1-.6-.9,1.2,1.2,0,0,1,.6-.9l14.5-8.4a3.4,3.4,0,0,1,2.8,0l14.6,8.4a1.2,1.2,0,0,1,.6.9,1,1,0,0,1-.6.9l-14.5,8.4A2.6,2.6,0,0,1,41.2,193.9Zm-.1-19.1a2.5,2.5,0,0,0-1.3.3l-14.5,8.4a1,1,0,0,0-.5.7c0,.3.2.5.5.7l14.6,8.4a3,3,0,0,0,2.6,0L57,184.9c.3-.2.5-.4.5-.7a1,1,0,0,0-.5-.7l-14.6-8.4A2.5,2.5,0,0,0,41.1,174.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M42.6,197.7l.4-.2v-2.1l-.4.2h-.4a.1.1,0,0,0-.1.1H40.4a.1.1,0,0,1-.1-.1h-.5l-.4-.3v2.2l.4.2h2.7C42.5,197.7,42.5,197.7,42.6,197.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M41.2,186h-.3l-2.8-1.5-.2-.3.2-.2,2.7-1.6a.9.9,0,0,1,.7,0l2.7,1.6.2.2-.2.3-2.7,1.5Zm0-3.6H41l-2.8,1.6h0l2.8,1.5a.3.3,0,0,0,.4,0l2.7-1.5h0l-2.7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M41.2,185.3c-.1,0-.2,0-.2-.1l-1.7-.9c0-.1-.1-.1-.1-.2v-.2l1.6-.9h.5l1.6.9v.4l-1.6.9Zm0-2.1h-.1l-1.7.9,1.7.9h.2l1.6-.9-1.6-.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M133.7,141.7a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.8.6.8,1.4,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M132.9,141.6c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M132,141.6a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M131.1,141.5c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M130.2,141.4c-.8-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1,1,0,0,1,0,1.8L150,151.1a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M129.4,141.4c-.9-.5-.9-1.3-.1-1.8l16.6-9.7a3.4,3.4,0,0,1,3.1,0l16.7,9.7c.9.5.9,1.3,0,1.8L149.2,151a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M128.5,141.3c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M127.6,141.3a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M126.7,141.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3.1,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M125.8,141.2a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M125,141.1c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M124.1,141c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.1,3.1,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M123.2,141c-.9-.5-.9-1.3,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3.1,1.8L143,150.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M122.3,140.9a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M121.5,140.9a1,1,0,0,1-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M120.6,140.8c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M119.7,140.8c-.9-.6-.9-1.4,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M118.8,140.7c-.8-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.7,9.7a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M117.9,140.6a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.8.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M117.1,140.6a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.6.9,1.4,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M116.2,140.5c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L136,150.1a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M115.3,140.5a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,.1,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M114.4,140.4a1,1,0,0,1,0-1.8L131,129a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8L134.2,150a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M113.6,140.3c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L133.4,150a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M112.7,140.3c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M111.8,140.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M110.9,140.2a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M110.1,140.1c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M109.2,140.1a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9L129,149.7a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M108.3,140c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.1,3.1,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M107.4,139.9c-.8-.5-.9-1.3,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a2.9,2.9,0,0,1-3.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M106.5,139.9c-.8-.5-.8-1.3,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.7c.8.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M106.5,140c-.8-.5-.8-1.3,0-1.9l16.6.2a2.9,2.9,0,0,1,3.1,0l16.7-.2c.8.6.9,1.4,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M143.5,136.2h-.2a.1.1,0,0,0-.1.1h-.3l-16.5,9.6v2.2l16.6-9.6h.6v-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M106.5,137a1.1,1.1,0,0,1-.6-.9v2.1a1.2,1.2,0,0,0,.6,1l16.7,9.6v-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M142.9,135.2c.8.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0L106.5,137a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M106.5,136.3a1,1,0,0,1,0-1.8l16.6-9.7a3.4,3.4,0,0,1,3.1,0l16.7,9.7c.8.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M124.8,145a3.3,3.3,0,0,1-1.5-.3l-14.5-8.4c-.4-.3-.7-.6-.7-.9a1.1,1.1,0,0,1,.7-.9l14.4-8.4a2.4,2.4,0,0,1,1.5-.4,2.3,2.3,0,0,1,1.4.4l14.6,8.4a1,1,0,0,1,.6.9,1.2,1.2,0,0,1-.6.9l-14.5,8.4A3.2,3.2,0,0,1,124.8,145Zm-.1-19.1a3.3,3.3,0,0,0-1.4.4l-14.4,8.4c-.4.2-.5.4-.5.7a.8.8,0,0,0,.5.7l14.5,8.4a3.2,3.2,0,0,0,1.4.3,2.8,2.8,0,0,0,1.3-.3l14.5-8.4a1,1,0,0,0,.5-.7c0-.3-.2-.5-.6-.7L126,126.3A2.8,2.8,0,0,0,124.7,125.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M126.1,148.9l.4-.2v-2.2l-.4.2h-2.6a.1.1,0,0,1-.1-.1h-.1l-.4-.2v2.1l.4.3h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M124.7,137.2h-.3l-2.7-1.6-.2-.2c0-.1.1-.2.2-.3l2.7-1.6h.6l2.8,1.6a.4.4,0,0,1,.1.3v.2l-2.8,1.6Zm0-3.6h-.2l-2.7,1.6c-.1,0-.1,0-.1.1h.1l2.7,1.6h.4l2.8-1.6h0l-2.8-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M124.7,136.4h-.2l-1.6-1h-.1c0-.1,0-.2.1-.2l1.6-1h.4l1.7,1a.3.3,0,0,1,.1.2h-.1l-1.7,1Zm0-2.1h-.1l-1.6,1,1.6.9h.2l1.6-.9-1.6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M75,310.1a.5.5,0,0,1-.4-.2c-.1-.2-.1-.5.1-.6l.5-.3c.2-.1.5-.1.6.1s.1.5-.1.6l-.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M80.3,306.8a.5.5,0,0,1-.4-.2c-.1-.2,0-.4.2-.6l.9-.6a.5.5,0,0,1,.6.2.5.5,0,0,1-.1.6l-1,.6Zm5.8-3.5-.4-.2a.5.5,0,0,1,.2-.6l.9-.6c.2-.1.5-.1.6.1s.1.5-.1.6l-1,.6Zm5.8-3.6a.4.4,0,0,1-.4-.2c-.1-.2,0-.4.2-.6l.9-.5a.4.4,0,0,1,.5.7l-1,.6Zm5.8-3.5-.4-.2a.5.5,0,0,1,.2-.6l1-.6a.4.4,0,0,1,.5.2c.2.2.1.4-.1.5l-1,.6Zm5.8-3.6a.4.4,0,0,1-.4-.2.4.4,0,0,1,.2-.5l1-.6c.2-.2.4-.1.5.1a.4.4,0,0,1-.1.6l-1,.6Zm5.8-3.5c-.1,0-.3-.1-.3-.2a.4.4,0,0,1,.1-.6l1-.6a.4.4,0,0,1,.5.2c.2.2.1.4-.1.6l-1,.5C109.5,289.1,109.4,289.1,109.3,289.1Zm5.8-3.5c-.1,0-.3-.1-.3-.2a.4.4,0,0,1,.1-.6l1-.6a.5.5,0,0,1,.6.1.5.5,0,0,1-.2.6l-1,.6Zm5.8-3.6c-.1,0-.3,0-.3-.2s-.1-.4.1-.6l1-.6c.2-.1.4,0,.6.2s0,.4-.2.6l-1,.6Zm5.8-3.5-.3-.2a.4.4,0,0,1,.1-.6l1-.6a.5.5,0,0,1,.6.1.5.5,0,0,1-.2.6l-.9.6Zm5.8-3.6c-.1,0-.2,0-.3-.2s-.1-.4.1-.5l1-.6c.2-.2.4-.1.6.1a.5.5,0,0,1-.2.6l-.9.6Zm5.8-3.5-.3-.2c-.1-.2-.1-.5.1-.6l1-.6a.5.5,0,0,1,.6.2.4.4,0,0,1-.2.5l-.9.6Zm5.8-3.5-.3-.2c-.1-.2-.1-.5.1-.6l1-.6c.2-.1.5-.1.6.1a.5.5,0,0,1-.2.6l-.9.6Zm5.9-3.6-.4-.2a.5.5,0,0,1,.1-.6l1-.6a.5.5,0,0,1,.6.2c.1.2,0,.4-.2.6l-.9.6Zm5.8-3.5a.5.5,0,0,1-.4-.2c-.1-.2-.1-.5.1-.6l1-.6c.2-.1.5-.1.6.1a.5.5,0,0,1-.2.6l-.9.6Zm5.8-3.6c-.2,0-.3,0-.4-.2a.5.5,0,0,1,.1-.6l1-.5a.4.4,0,0,1,.6.1c.1.2.1.5-.1.6l-1,.6Zm5.8-3.5-.4-.2c-.1-.2-.1-.5.1-.6l1-.6a.5.5,0,0,1,.6.2c.1.2.1.4-.1.5l-1,.6Zm5.8-3.5c-.2,0-.3-.1-.4-.3a.4.4,0,0,1,.2-.5l.9-.6c.2-.1.5-.1.6.1s.1.5-.1.6l-1,.6Zm5.8-3.6-.4-.2a.5.5,0,0,1,.2-.6l.9-.6a.5.5,0,0,1,.6.2.5.5,0,0,1-.1.6l-1,.5Zm5.8-3.5-.4-.2a.5.5,0,0,1,.2-.6l.9-.6c.2-.1.5-.1.6.1s.1.5-.1.6l-1,.6Zm5.8-3.6c-.2,0-.3,0-.4-.2s0-.4.2-.6l.9-.6a.5.5,0,0,1,.6.2c.1.2.1.5-.1.6l-1,.6Zm5.8-3.5-.4-.2a.5.5,0,0,1,.2-.6l.9-.6c.2-.1.5-.1.6.1s.1.5-.1.6l-1,.6Zm5.8-3.6a.4.4,0,0,1-.4-.2.4.4,0,0,1,.2-.5l.9-.6a.4.4,0,1,1,.5.7l-1,.6Zm5.8-3.5-.4-.2a.5.5,0,0,1,.2-.6l1-.6a.4.4,0,0,1,.5.2c.2.2.1.4-.1.5l-1,.6Zm5.8-3.5c-.1,0-.3-.1-.3-.2a.4.4,0,0,1,.1-.6l1-.6c.2-.1.4-.1.5.1a.4.4,0,0,1-.1.6l-1,.6Zm5.8-3.6-.3-.2c-.2-.2-.1-.4.1-.6l1-.6a.4.4,0,0,1,.5.2c.2.2.1.4-.1.6l-1,.6Zm5.8-3.5-.3-.2a.4.4,0,0,1,.1-.6l1-.6a.5.5,0,0,1,.6.1.5.5,0,0,1-.2.6l-1,.6C225.6,218.3,225.5,218.3,225.4,218.3Zm5.8-3.6c-.1,0-.3,0-.3-.2s-.1-.4.1-.6l1-.5c.2-.2.4-.1.6.1a.5.5,0,0,1-.2.6l-.9.6Zm5.8-3.5-.3-.2c-.1-.2-.1-.5.1-.6l1-.6c.2-.1.4,0,.6.2a.4.4,0,0,1-.2.5l-.9.6Zm5.8-3.5q-.2,0-.3-.3c-.1-.2-.1-.4.1-.5l1-.6a.5.5,0,0,1,.6.1.5.5,0,0,1-.2.6l-.9.6Zm5.8-3.6-.3-.2c-.1-.2-.1-.5.1-.6l1-.6a.5.5,0,0,1,.6.2c.1.2,0,.4-.2.6l-.9.5Zm5.9-3.5-.4-.2c-.1-.2-.1-.5.1-.6l1-.6c.2-.1.5-.1.6.1a.5.5,0,0,1-.2.6l-.9.6Zm5.8-3.6c-.2,0-.3,0-.4-.2a.5.5,0,0,1,.1-.6l1-.6a.4.4,0,0,1,.4.8l-.9.6Zm5.8-3.5a.5.5,0,0,1-.4-.2c-.1-.2-.1-.5.1-.6l1-.6c.2-.1.5-.1.6.1s.1.5-.1.6l-1,.6Zm5.8-3.6c-.2,0-.3,0-.4-.2s-.1-.4.1-.5l1-.6a.4.4,0,0,1,.6.1c.1.2.1.5-.1.6l-1,.6Zm5.8-3.5-.4-.2a.5.5,0,0,1,.2-.6l.9-.6a.5.5,0,0,1,.6.2c.1.2.1.4-.1.5l-1,.6Zm5.8-3.5-.4-.2a.5.5,0,0,1,.2-.6l.9-.6c.2-.1.5-.1.6.1s.1.5-.1.6l-1,.6Zm5.8-3.6-.4-.2c-.1-.2,0-.4.2-.6l.9-.6a.5.5,0,0,1,.6.2.5.5,0,0,1-.1.6l-1,.6Zm5.8-3.5a.5.5,0,0,1-.4-.2.5.5,0,0,1,.2-.6l.9-.6c.2-.1.5-.1.6.1s.1.5-.1.6l-1,.6Zm5.8-3.6a.4.4,0,0,1-.4-.2c-.1-.2,0-.4.2-.6l.9-.5a.4.4,0,0,1,.6.1c.1.2.1.5-.1.6l-1,.6Zm5.8-3.5-.4-.2a.5.5,0,0,1,.2-.6l.9-.6a.5.5,0,0,1,.6.2c.2.2.1.4-.1.5l-1,.6Zm5.8-3.5a.5.5,0,0,1-.4-.3.4.4,0,0,1,.2-.5l1-.6c.2-.1.4-.1.5.1a.4.4,0,0,1-.1.6l-1,.6Zm5.8-3.6-.3-.2a.4.4,0,0,1,.1-.6l1-.6a.4.4,0,0,1,.5.2c.2.2.1.4-.1.6l-1,.5Zm5.8-3.5-.3-.2a.4.4,0,0,1,.1-.6l1-.6c.2-.1.4-.1.5.1a.4.4,0,0,1-.1.6l-1,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M329.9,154.5c-.1,0-.3,0-.3-.2s-.1-.4.1-.6l.5-.3c.2-.1.4,0,.6.2s0,.4-.2.6l-.5.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M119,345.5c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M118.1,345.4c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L137.9,355a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M117.2,345.4a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9L137,355a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M116.3,345.3a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M115.5,345.3a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M114.6,345.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M113.7,345.1c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3.1,1.8l-16.6,9.6a2.9,2.9,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M112.8,345.1c-.8-.5-.8-1.3,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.7a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M112,345c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M111.1,345a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M110.2,344.9c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L130,354.5a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M109.3,344.9c-.8-.6-.8-1.4,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6c.8.5.8,1.3,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M108.4,344.8a1,1,0,0,1,0-1.8l16.6-9.6a2.9,2.9,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M107.6,344.7c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M106.7,344.7a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.6.9,1.4,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M105.8,344.6c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M104.9,344.6a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M104.1,344.5c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M103.2,344.4c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L123,354.1a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M102.3,344.4c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8L122.1,354a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M101.4,344.3a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M100.6,344.3a1,1,0,0,1-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M99.7,344.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M98.8,344.2a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M97.9,344.1c-.8-.5-.9-1.3,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M97,344a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.8.5.9,1.3,0,1.8l-16.5,9.6a3.1,3.1,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M96.2,344c-.9-.5-.9-1.3,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8L116,353.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M95.3,343.9c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M94.4,343.9a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,.1,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M93.5,343.8a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M92.7,343.8c-.9-.6-.9-1.4,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M91.8,343.7c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M91.8,343.8c-.9-.5-.9-1.3,0-1.8h16.5a3.6,3.6,0,0,1,3.2,0h16.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M128.8,340h-.2a.1.1,0,0,1-.1.1h0c0,.1,0,.1-.1.1h-.3l-16.5,9.6v2.2l16.5-9.6h0a.1.1,0,0,1,.1-.1h.2a.1.1,0,0,1,.1-.1h.1a.1.1,0,0,1,.1-.1h0v-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M91.8,340.8a1,1,0,0,1-.7-.9v2.2a1.2,1.2,0,0,0,.6.9l16.7,9.6v-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M128.1,339c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0l-16.6-9.6c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M91.8,340.1c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M110,348.8a2.9,2.9,0,0,1-1.4-.3L94,340.1a1.2,1.2,0,0,1-.6-.9,1,1,0,0,1,.6-.9l14.5-8.4a2.6,2.6,0,0,1,1.4-.4,2.9,2.9,0,0,1,1.4.4l14.6,8.4a1,1,0,0,1,.6.9,1.2,1.2,0,0,1-.6.9l-14.5,8.4A2.9,2.9,0,0,1,110,348.8Zm-.1-19a2.5,2.5,0,0,0-1.3.3l-14.5,8.4c-.3.2-.5.4-.5.7a1,1,0,0,0,.5.7l14.6,8.4a3,3,0,0,0,2.6,0l14.5-8.4a1,1,0,0,0,.5-.7c0-.3-.2-.5-.5-.7l-14.6-8.4A2.5,2.5,0,0,0,109.9,329.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M111.3,352.7l.5-.2v-2.2l-.4.3h-.5c-.1,0-.1,0-.1.1h-2.2l-.4-.2v2.2l.4.2h2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M110,341c-.1,0-.3,0-.3-.1l-2.8-1.6a.2.2,0,0,1-.2-.2c0-.1.1-.2.2-.3l2.7-1.6h.7l2.7,1.6c.1.1.2.2.2.3l-.2.2-2.7,1.6Zm0-3.6h-.2L107,339h0l2.8,1.6a.3.3,0,0,0,.4,0l2.7-1.6h0l-2.7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M110,340.3h-.2l-1.7-.9a.3.3,0,0,0-.1-.2.3.3,0,0,1,.1-.2l1.6-1h.5l1.6,1c.1,0,.1.1.1.2v.2l-1.6.9Zm-1.7-1.2,1.6.9h.2l1.6-.9-1.6-1h-.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M27.9,293.8c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0L64.2,292c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M27,293.8a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M26.1,293.7c-.8-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M25.2,293.6a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.7a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M24.4,293.6c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M23.5,293.5c-.9-.5-.9-1.3,0-1.8L40,282.1a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M22.6,293.5a1,1,0,0,1,0-1.9L39.1,282a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,.1,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M21.7,293.4a1,1,0,0,1,0-1.8L38.3,282a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8L41.5,303a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M20.9,293.4a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.9L40.7,303a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M20,293.3c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.1,3.1,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M19.1,293.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M18.2,293.2a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.8.6.8,1.4,0,1.9L38,302.8a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M17.4,293.1c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M16.5,293.1a1,1,0,0,1,0-1.9L33,281.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M15.6,293c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M14.7,293c-.8-.6-.9-1.4,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6c.8.5.8,1.3,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M13.8,292.9a1,1,0,0,1,0-1.8l16.6-9.7a3.4,3.4,0,0,1,3.1,0l16.7,9.7c.8.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M13,292.8c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0L49.3,291c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M12.1,292.8a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M11.2,292.7c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3.1,1.8L31,302.3a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M10.3,292.7a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M9.5,292.6c-.9-.5-.9-1.3-.1-1.8L26,281.2a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M8.6,292.5c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.1,3.1,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M7.7,292.5c-.9-.5-.9-1.3,0-1.9L24.2,281a3.6,3.6,0,0,1,3.2,0L44,290.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M6.8,292.4a1,1,0,0,1,0-1.8L23.4,281a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8L26.6,302a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M6,292.4a1,1,0,0,1-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.9L25.8,302a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M5.1,292.3c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M4.2,292.3c-.9-.6-.9-1.4,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.9L24,301.9a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M3.3,292.2c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.7,9.7a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2.4,292.1a1,1,0,0,1,0-1.8L19,280.7a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1.6,292.1a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.6.9,1.4,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M.7,292c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0L37,290.2c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M.7,292.1c-.9-.5-.9-1.3,0-1.8H17.2a3.6,3.6,0,0,1,3.2,0H37c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M37.7,288.3h-.2c0,.1,0,.1-.1.1h-.1c-.1,0-.1,0-.1.1H37l-16.5,9.6v2.1L37,291.3h.1c0-.1,0-.1.1-.1h.3a.1.1,0,0,0,.1-.1h0v-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M.7,289.2c-.5-.3-.7-.6-.7-1v2.2c0,.3.2.6.7.9l16.6,9.6v-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M37,287.3a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0L.7,289.2a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M.7,288.4c-.9-.5-.9-1.3,0-1.8L17.2,277a3.6,3.6,0,0,1,3.2,0L37,286.6c.9.5.9,1.3,0,1.8L20.5,298a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M18.9,297.2a3.3,3.3,0,0,1-1.4-.4L2.9,288.4a1,1,0,0,1-.6-.9,1.1,1.1,0,0,1,.6-.9l14.5-8.4a2.9,2.9,0,0,1,1.4-.3,2.9,2.9,0,0,1,1.4.3l14.6,8.4a1.1,1.1,0,0,1,.6.9,1,1,0,0,1-.6.9l-14.5,8.4A2.6,2.6,0,0,1,18.9,297.2Zm-.1-19.1a2.5,2.5,0,0,0-1.3.3L3,286.8c-.3.2-.5.4-.5.7s.2.5.5.7l14.6,8.4a2.5,2.5,0,0,0,1.3.3,2.5,2.5,0,0,0,1.3-.3l14.5-8.4c.3-.2.5-.4.5-.7a1,1,0,0,0-.5-.7l-14.6-8.4A2.5,2.5,0,0,0,18.8,278.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M20.3,301l.4-.2v-2.1l-.4.2H17.9c-.1,0-.2,0-.2-.1h-.2l-.4-.3v2.2l.4.2h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M18.9,289.3c-.1,0-.3,0-.3-.1l-2.8-1.5c-.1-.1-.2-.2-.2-.3l.2-.3,2.7-1.5a.9.9,0,0,1,.7,0l2.7,1.5.2.3c0,.1-.1.2-.2.3l-2.7,1.5Zm0-3.6c-.1,0-.2,0-.2.1l-2.8,1.5h0l2.8,1.5a.3.3,0,0,0,.4,0l2.7-1.5a.1.1,0,0,1,.1-.1h-.1l-2.7-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M18.9,288.6c-.1,0-.2,0-.2-.1l-1.7-.9c0-.1-.1-.1-.1-.2s.1-.1.1-.2l1.6-.9a.4.4,0,0,1,.5,0l1.6.9c.1,0,.1.1.1.2s0,.1-.1.2l-1.6.9Zm0-2.2a.1.1,0,0,0-.1.1l-1.7.9,1.7.9H19l1.6-.9-1.6-.9A.1.1,0,0,1,18.9,286.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M385.2,183.9a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.8.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M384.4,183.9a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M383.5,183.8c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M382.6,183.7c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3.1,1.8l-16.6,9.7a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M381.7,183.7a1,1,0,0,1,0-1.8l16.6-9.7a3.4,3.4,0,0,1,3.1,0l16.7,9.7a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M380.9,183.6c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M380,183.6a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M379.1,183.5c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M378.2,183.5a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9L398,193.1a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M377.4,183.4c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8L397.2,193a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M376.5,183.3c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.1,3.1,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M375.6,183.3c-.9-.5-.9-1.3,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.6.9,1.4,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M374.7,183.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M373.8,183.2a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M373,183.1c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M372.1,183.1c-.9-.6-.9-1.4,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M371.2,183c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3.1,1.8L391,192.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M370.3,182.9a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M369.5,182.9a1,1,0,0,1-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.6.9,1.4,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M368.6,182.8c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M367.7,182.8a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M366.8,182.7c-.8-.5-.9-1.3,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M365.9,182.6a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.7a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M365.1,182.6c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M364.2,182.5c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L384,192.1a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M363.3,182.5a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M362.4,182.4a1,1,0,0,1,0-1.8L379,171a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8L382.3,192a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M361.6,182.4a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9L381.4,192a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M360.7,182.3c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.1,3.1,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M359.8,182.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a2.9,2.9,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M358.9,182.2c-.8-.5-.8-1.3,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.8.6.8,1.4,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M358.1,182.1c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M358.1,182.2c-.9-.5-.9-1.3-.1-1.8h16.6a3.4,3.4,0,0,1,3.1,0h16.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M395,178.4h-.6l-16.5,9.6V191l16.6-9.6h.1a.1.1,0,0,0,.1-.1h.4v-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M358.1,179.3c-.5-.3-.7-.6-.7-1v2.2a1.1,1.1,0,0,0,.6.9l16.7,9.6v-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M394.4,177.4a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0l-16.6-9.6a1,1,0,0,1-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M358.1,178.5c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M376.3,187.3a3.3,3.3,0,0,1-1.5-.4l-14.5-8.4a1.1,1.1,0,0,1-.7-.9,1.2,1.2,0,0,1,.7-.9l14.4-8.4a3.3,3.3,0,0,1,1.5-.3,3.2,3.2,0,0,1,1.4.3l14.6,8.4a1.2,1.2,0,0,1,.6.9,1,1,0,0,1-.6.9l-14.5,8.4A3.3,3.3,0,0,1,376.3,187.3Zm-.1-19.1a3.2,3.2,0,0,0-1.4.3l-14.4,8.4c-.4.2-.5.4-.5.7s.2.5.5.7l14.5,8.4a3.2,3.2,0,0,0,1.4.3,2.8,2.8,0,0,0,1.3-.3l14.5-8.4c.3-.2.5-.4.5-.7a1,1,0,0,0-.5-.7l-14.6-8.4A2.8,2.8,0,0,0,376.2,168.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M377.6,191.1l.4-.2v-2.1l-.3.2h-2.8l-.5-.3v2.2l.4.2h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M376.2,179.4h-.3l-2.7-1.5-.2-.3.2-.3,2.7-1.5h.6l2.8,1.5.2.3-.2.3-2.7,1.5Zm0-3.6H376l-2.7,1.5h0l2.7,1.5h.4l2.8-1.5h0l-2.8-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M376.2,178.7H376l-1.6-.9v-.4l1.6-.9h.4l1.7.9v.4l-1.6.9Zm-1.7-1.2,1.6.9h.2l1.6-.9-1.6-.9h-.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M294.1,132.2a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8L314,141.9a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M293.3,132.2c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M292.4,132.1c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M291.5,132.1a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,.1,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M290.6,132a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M289.8,132a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M288.9,131.9c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M288,131.8c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a2.9,2.9,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M287.1,131.8a1,1,0,0,1,0-1.8l16.6-9.7a3.4,3.4,0,0,1,3.1,0l16.7,9.7a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M286.3,131.7c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M285.4,131.7a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M284.5,131.6c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M283.6,131.6c-.8-.6-.9-1.4,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6c.8.5.8,1.3,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M282.7,131.5a1,1,0,0,1,0-1.8l16.6-9.6a2.9,2.9,0,0,1,3.1,0l16.7,9.6c.8.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M281.9,131.4c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L301.7,141a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M281,131.4a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.6.9,1.4,0,1.9L300.8,141a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M280.1,131.3c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3.1,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M279.2,131.3a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9L299,140.9a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M278.4,131.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M277.5,131.1c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.7a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M276.6,131.1c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M275.7,131a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M274.9,131a1,1,0,0,1-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M274,130.9c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M273.1,130.9a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M272.2,130.8c-.8-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1,1,0,0,1,0,1.8L292,140.4a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M271.3,130.7a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.5,9.6a3.1,3.1,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M270.5,130.7c-.9-.5-.9-1.3,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M269.6,130.6c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M268.7,130.6a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,.1,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M267.8,130.5a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M267,130.5c-.9-.6-.9-1.4-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M267,130.6c-.9-.6-.9-1.4-.1-1.9h16.6a3.4,3.4,0,0,1,3.1,0h16.7c.9.5.9,1.3,0,1.8l-16.5,9.7a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M303.9,126.8h-.6l-16.5,9.6v2.1l16.6-9.6h.6v-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M267,127.6c-.5-.3-.7-.6-.7-.9v2.1a1.1,1.1,0,0,0,.6.9l16.7,9.6v-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M303.3,125.8c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0L267,127.6c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a2.9,2.9,0,0,1,3.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M267,126.9a1,1,0,0,1-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M285.2,135.6a2.4,2.4,0,0,1-1.5-.4l-14.5-8.4a1.1,1.1,0,0,1-.7-.9c0-.3.3-.6.7-.9l14.4-8.4a3.3,3.3,0,0,1,1.5-.3,3.2,3.2,0,0,1,1.4.3l14.6,8.4a1.2,1.2,0,0,1,.6.9,1,1,0,0,1-.6.9l-14.5,8.4A2.3,2.3,0,0,1,285.2,135.6Zm-.1-19.1a3.2,3.2,0,0,0-1.4.3l-14.4,8.4a1,1,0,0,0-.5.7,1,1,0,0,0,.5.8l14.5,8.4a3.2,3.2,0,0,0,1.4.3,2.5,2.5,0,0,0,1.3-.3l14.5-8.4a1,1,0,0,0,.5-.8,1,1,0,0,0-.5-.7l-14.6-8.4A2.8,2.8,0,0,0,285.1,116.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M286.5,139.4c.1,0,.4-.1.4-.2v-2.1l-.3.2h-2.8l-.5-.2v2.1l.4.2h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M285.1,127.7h-.3l-2.7-1.6c-.1-.1-.2-.2-.2-.3l.2-.2,2.7-1.6h.6l2.8,1.6a.2.2,0,0,1,.2.2c0,.1-.1.2-.2.3l-2.7,1.6Zm0-3.6h-.2l-2.7,1.6h0l2.7,1.6h.4l2.8-1.6h0l-2.8-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M285.1,127h-.2l-1.6-1c-.1,0-.1-.1-.1-.2v-.2l1.6-.9a.3.3,0,0,1,.4,0l1.7.9a.3.3,0,0,0,.1.2c0,.1,0,.2-.1.2l-1.6,1Zm0-2.1H285l-1.6.9,1.6,1h.2l1.6-1-1.6-.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M111.5,238.1c-6-3.5-6-9.2-.1-12.6l113.4-65.9c5.9-3.4,15.7-3.4,21.7,0l114.1,65.9c5.9,3.5,6,9.1,0,12.6L247.3,303.9c-6,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M109.6,238.1c-6-3.5-6.1-9.1-.1-12.6l113.3-65.4c6-3.4,15.7-3.4,21.7,0l114.1,65.4c6,3.5,6,9.1.1,12.6L245.3,303.9c-5.9,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M107.6,238.1c-6-3.5-6-9.1-.1-12.6l113.4-64.9c5.9-3.4,15.7-3.4,21.7,0l114.1,64.9c6,3.5,6,9.1.1,12.6L243.4,304c-5.9,3.4-15.7,3.4-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M105.7,238.1c-6-3.5-6-9.1-.1-12.6L219,161.1c5.9-3.4,15.7-3.4,21.7,0l114.1,64.4c5.9,3.5,6,9.1,0,12.6L241.5,304c-6,3.4-15.7,3.4-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M103.8,238.1c-6-3.5-6.1-9.1-.1-12.6L217,161.6c6-3.4,15.7-3.4,21.7,0l114.1,63.9c6,3.5,6,9.1.1,12.6L239.5,304c-5.9,3.4-15.7,3.4-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M101.8,238.1c-6-3.5-6-9.1-.1-12.6l113.4-63.4c5.9-3.4,15.7-3.4,21.7,0l114.1,63.5c6,3.4,6,9.1.1,12.5L237.6,304c-5.9,3.4-15.7,3.4-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M99.9,238.1c-6-3.4-6-9.1-.1-12.5l113.4-63c5.9-3.4,15.7-3.4,21.7,0l114.1,63c5.9,3.4,6,9.1,0,12.5L235.7,304c-6,3.4-15.7,3.4-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M97.9,238.1c-5.9-3.4-6-9.1,0-12.5l113.3-62.5c6-3.4,15.7-3.4,21.7,0L347,225.6c6,3.4,6,9.1.1,12.5L233.7,304c-5.9,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M96,238.1c-6-3.4-6-9.1-.1-12.5l113.4-62c5.9-3.4,15.7-3.4,21.7,0l114.1,62c6,3.4,6,9.1.1,12.6L231.8,304c-5.9,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M94.1,238.2c-6-3.5-6-9.2-.1-12.6l113.4-61.5c5.9-3.4,15.7-3.4,21.6,0l114.1,61.5c6,3.5,6.1,9.1.1,12.6L229.9,304c-6,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M92.1,238.2c-5.9-3.5-6-9.1,0-12.6l113.3-61c6-3.5,15.7-3.5,21.7,0l114.1,61c6,3.5,6,9.1.1,12.6L227.9,304c-5.9,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M90.2,238.2c-6-3.5-6-9.1-.1-12.6l113.4-60.5c5.9-3.5,15.7-3.5,21.7,0l114.1,60.5c6,3.5,6,9.1,0,12.6L226,304c-6,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M88.3,238.2c-6-3.5-6-9.1-.1-12.6l113.4-60c5.9-3.5,15.7-3.5,21.6,0l114.1,60c6,3.5,6.1,9.1.1,12.6L224.1,304.1c-6,3.4-15.7,3.4-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M86.3,238.2c-6-3.5-6-9.1,0-12.6l113.3-59.5c6-3.5,15.7-3.5,21.7,0l114.1,59.5c6,3.5,6,9.1.1,12.6L222.1,304.1c-5.9,3.4-15.7,3.4-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M84.4,238.2c-6-3.5-6-9.1-.1-12.6l113.4-59c5.9-3.5,15.7-3.5,21.7,0l114.1,59c6,3.5,6,9.2,0,12.6L220.2,304.1c-6,3.4-15.7,3.4-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M82.5,238.2c-6-3.4-6.1-9.1-.1-12.5l113.4-58.6c5.9-3.5,15.7-3.5,21.6,0l114.1,58.6c6,3.4,6,9.1.1,12.5L218.3,304.1c-6,3.4-15.7,3.4-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M80.5,238.2c-6-3.4-6-9.1,0-12.5l113.3-58.1c6-3.5,15.7-3.5,21.7,0l114.1,58.1c6,3.4,6,9.1.1,12.5L216.3,304.1c-5.9,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M78.6,238.2c-6-3.4-6-9.1-.1-12.5l113.4-57.6c5.9-3.5,15.7-3.5,21.7,0l114.1,57.6c6,3.4,6,9.1,0,12.5L214.4,304.1c-6,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M76.7,238.3c-6-3.5-6.1-9.2-.1-12.6L190,168.6c5.9-3.5,15.6-3.5,21.6,0l114.1,57.1c6,3.4,6,9.1.1,12.6L212.4,304.1c-5.9,3.5-15.7,3.5-21.6,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M74.7,238.3c-6-3.5-6-9.2,0-12.6L188,169.1c5.9-3.5,15.7-3.5,21.7,0l114.1,56.6c6,3.5,6,9.1.1,12.6L210.5,304.1c-5.9,3.5-15.7,3.5-21.7,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M72.8,238.3c-6-3.5-6-9.1-.1-12.6l113.4-56.1c5.9-3.5,15.7-3.5,21.7,0l114.1,56.1c5.9,3.5,6,9.1,0,12.6L208.6,304.1c-6,3.5-15.7,3.5-21.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M70.9,238.3c-6-3.5-6.1-9.1-.1-12.6l113.3-55.6c6-3.5,15.7-3.5,21.7,0l114.1,55.6c6,3.5,6,9.1.1,12.6L206.6,304.2c-5.9,3.4-15.7,3.4-21.6,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M70.9,238.3c-6-3.5-6-9.1-.1-12.6l113.4,11c5.9-3.5,15.7-3.5,21.7,0l114.1-11c6,3.5,6,9.1.1,12.6L206.7,304.2c-5.9,3.4-15.7,3.4-21.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M324.5,225.6a.7.7,0,0,0-.1.5v.3a4.3,4.3,0,0,1-.1.5l-.2.4c-.1.1-.1.3-.2.5l-.4.6h-.1l-.5.6v.2l-.6.6-.5.4-.4.3-.6.4-.5.4L206.7,297.2l-.2,4.5,113.3-65.9h.2l.4-.3.6-.4.4-.3.4-.4c.1,0,.1,0,.1-.1l.6-.5v-.2l.3-.3.2-.3h.1l.3-.5a.1.1,0,0,1,.1-.1c0-.2.1-.3.2-.5v-.3h0c.1-.1.1-.3.2-.4a.4.4,0,0,1,.1-.3h0V230c0-.1.1-.2.1-.3v-.2l.2-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M70.9,231.4c-3-1.8-4.5-4.1-4.5-6.4l-.2,4.4c0,2.3,1.5,4.6,4.5,6.4l114.1,65.8.2-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M320,218.8c6,3.4,6,9.1.1,12.6L206.7,297.2c-5.9,3.5-15.7,3.5-21.7,0L70.9,231.4c-6-3.5-6-9.2-.1-12.6l113.4-65.9c5.9-3.4,15.7-3.4,21.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M70.9,226.3c-6-3.4-6-9.1-.1-12.5l113.4-65.9c5.9-3.5,15.7-3.5,21.7,0L320,213.8c6,3.4,6,9.1.1,12.5L206.7,292.2c-5.9,3.4-15.7,3.4-21.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M205,302.4l2.8-1.5v-4.3l-2.5,1.3-.5.2-1.2.5h-.4l-.8.3h-.6l-.9.2h-.5l-1.8.3H191l-.6-.2-.9-.2h-.6l-1.6-.6-.8-.3-.4-.2-2.8-1.6v4.6l2.6,1.4.4.2.7.3h.1l1.6.6h.5l1,.2h8.2l1.7-.3h.6l.9-.2h.6l.7-.2h.5l1.2-.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M369.1,264a76.9,76.9,0,0,0-10.5,1.8,64,64,0,0,0-19.3,7.5l-26.2,15.1L299,296.6c-1.5.8-4.1,3.3-5.7,2.4s-.4-.1-.7.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.8-7.8,7.3-9.2,10.4-13.5C371,267.4,369.9,263.9,369.1,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M368.5,264a76.9,76.9,0,0,0-10.5,1.8,64,64,0,0,0-19.3,7.5l-26.2,15.1-14.1,8.2c-1.5.9-4.1,3.3-5.7,2.4s-.4-.1-.7.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.2,9.5-.3,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.7-7.6l19.4-11.2L332,299.3c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C370.4,267.4,369.3,263.9,368.5,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M367.9,264a76.9,76.9,0,0,0-10.5,1.8,64,64,0,0,0-19.3,7.5l-26.2,15.1-14.1,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.2,9.5-.3,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.8-7.6l19.3-11.2,35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C369.9,267.4,368.8,263.9,367.9,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M367.4,264a71.9,71.9,0,0,0-10.5,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.2,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1L266,313.5l-9.9,5.7c-1.3.7-.7.4-1.7,1.4-3.3,3-2.3,9.5-.4,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.8-7.6l19.4-11.2,35.4-20.6c5.6-2.6,11-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C369.3,267.4,368.2,263.9,367.4,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M366.8,264a71.9,71.9,0,0,0-10.5,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.2,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.7.1l-24.9,14.4-9.8,5.7c-1.4.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.4-20.6c5.7-2.6,11-6.3,16.4-9.4s7.5-4.5,10.8-7.8,7.2-9.2,10.4-13.5C368.7,267.4,367.6,263.9,366.8,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M366.2,264a76.9,76.9,0,0,0-10.5,1.8,65.6,65.6,0,0,0-19.4,7.5l-26.1,15.1-14.1,8.2c-1.5.9-4.1,3.3-5.7,2.4s-.4-.1-.7.1l-24.9,14.4-9.8,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.8-7.8,7.3-9.2,10.4-13.5C368.1,267.4,367,263.9,366.2,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M365.6,264a76.9,76.9,0,0,0-10.5,1.8,64,64,0,0,0-19.3,7.5l-26.2,15.1-14.1,8.2c-1.5.9-4.1,3.3-5.7,2.4s-.4-.1-.7.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.8-7.8,7.3-9.2,10.5-13.5C367.5,267.4,366.4,263.9,365.6,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M365,264a76.9,76.9,0,0,0-10.5,1.8,64,64,0,0,0-19.3,7.5L309,288.4l-14.1,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.2,9.5-.3,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.8-7.6L293,319.9l35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C366.9,267.4,365.8,263.9,365,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M364.4,264a72.9,72.9,0,0,0-10.4,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.2,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.2,3-2.2,9.5-.3,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.8-7.6l19.3-11.2,35.5-20.6c5.6-2.6,11-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C366.4,267.4,365.3,263.9,364.4,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M363.9,264a71.9,71.9,0,0,0-10.5,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.2,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1l-24.8,14.4-9.9,5.7c-1.3.7-.6.4-1.7,1.4-3.3,3-2.3,9.5-.4,12.6s5.4,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.4-20.6c5.6-2.6,11-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C365.8,267.4,364.7,263.9,363.9,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M363.3,264a71.9,71.9,0,0,0-10.5,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.1,8.2c-1.5.9-4.2,3.3-5.7,2.4s-.4-.1-.7.1l-24.9,14.4-9.8,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.4-20.6c5.7-2.6,11-6.3,16.4-9.4s7.6-4.5,10.8-7.8,7.2-9.2,10.4-13.5C365.2,267.4,364.1,263.9,363.3,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M362.7,264a76.9,76.9,0,0,0-10.5,1.8,65.6,65.6,0,0,0-19.4,7.5l-26.1,15.1-14.1,8.2c-1.5.9-4.1,3.3-5.7,2.4s-.4-.1-.7.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.8-7.8,7.3-9.2,10.4-13.5C364.6,267.4,363.5,263.9,362.7,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M362.1,264a76.9,76.9,0,0,0-10.5,1.8,64,64,0,0,0-19.3,7.5l-26.2,15.1L292,296.6c-1.5.9-4.1,3.3-5.7,2.4s-.4-.1-.7.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.3,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.7-7.6l19.4-11.2,35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C364,267.4,362.9,263.9,362.1,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M361.5,264a76.9,76.9,0,0,0-10.5,1.8,64,64,0,0,0-19.3,7.5l-26.2,15.1-14.1,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.2,9.5-.3,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.8-7.6l19.3-11.2L325,299.3c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C363.4,267.4,362.4,263.9,361.5,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M360.9,264a72.9,72.9,0,0,0-10.4,1.8,63.6,63.6,0,0,0-19.4,7.5L305,288.4l-14.2,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.2,3-2.2,9.5-.3,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.8-7.6L289,319.9l35.4-20.6c5.6-2.6,11-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C362.9,267.4,361.8,263.9,360.9,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M360.4,264a71.9,71.9,0,0,0-10.5,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.2,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1L259,313.5l-9.8,5.7c-1.4.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.4-20.6c5.7-2.6,11-6.3,16.4-9.4s7.5-4.5,10.8-7.8,7.2-9.2,10.4-13.5C362.3,267.4,361.2,263.9,360.4,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M359.8,264a76.9,76.9,0,0,0-10.5,1.8,65.6,65.6,0,0,0-19.4,7.5l-26.1,15.1-14.1,8.2c-1.5.9-4.1,3.3-5.7,2.4s-.4-.1-.7.1l-24.9,14.4-9.8,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.8-7.8,7.3-9.2,10.4-13.5C361.7,267.4,360.6,263.9,359.8,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M359.2,264a76.9,76.9,0,0,0-10.5,1.8,64,64,0,0,0-19.3,7.5l-26.2,15.1-14.1,8.2c-1.5.9-4.1,3.3-5.7,2.4s-.4-.1-.7.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.8-7.8,7.3-9.2,10.5-13.5C361.1,267.4,360,263.9,359.2,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M358.6,264a76.9,76.9,0,0,0-10.5,1.8,64,64,0,0,0-19.3,7.5l-26.2,15.1-14.1,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.2,9.5-.3,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.8-7.6l19.3-11.2,35.5-20.6c5.6-2.6,10.9-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C360.5,267.4,359.4,263.9,358.6,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M358,264a72.9,72.9,0,0,0-10.4,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.2,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1l-24.8,14.4-9.9,5.7c-1.3.7-.7.4-1.8,1.4-3.2,3-2.2,9.5-.3,12.6s5.4,6.8,10.2,5.5,9.4-6.2,11.8-7.6L286,319.9l35.5-20.6c5.6-2.6,11-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C360,267.4,358.9,263.9,358,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M357.5,264a71.9,71.9,0,0,0-10.5,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.2,8.2c-1.4.9-4.1,3.3-5.6,2.4s-.4-.1-.8.1l-24.8,14.4-9.9,5.7c-1.3.7-.6.4-1.7,1.4-3.3,3-2.3,9.5-.4,12.6s5.4,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.4-20.6c5.6-2.6,11-6.3,16.3-9.4s7.6-4.5,10.9-7.8,7.2-9.2,10.4-13.5C359.4,267.4,358.3,263.9,357.5,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M356.9,264a71.9,71.9,0,0,0-10.5,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.1,8.2c-1.5.8-4.2,3.3-5.7,2.4s-.4-.1-.7.1l-24.9,14.4-9.8,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.4-20.6c5.7-2.6,11-6.3,16.4-9.4s7.6-4.5,10.8-7.8,7.2-9.2,10.4-13.5C358.8,267.4,357.7,263.9,356.9,264Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M356.9,264a71.9,71.9,0,0,0-10.5,1.8,63.6,63.6,0,0,0-19.4,7.5l-26.1,15.1-14.1,8.2c-1.5.8-4.2,3.3-5.7,2.4s-.4-.1-.7.1l-24.9,14.4-9.8,5.7c-1.3.7-.7.4-1.8,1.4-3.3,3-2.3,9.5-.4,12.6s5.5,6.8,10.3,5.5,9.3-6.2,11.7-7.6l19.4-11.2,35.4-20.6c5.7-2.6,11-6.3,16.4-9.4s7.6-4.5,10.8-7.8,7.2-9.2,10.4-13.5C358.8,267.4,357.7,263.9,356.9,264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M363.7,261.5c-.2-.3-4.5,1.2-4.9,1.4l-.4.3c-.1.1-.3.1-.4.3a.7.7,0,0,0-.1.5,4.2,4.2,0,0,0,.4,1,1.6,1.6,0,0,0,.9.5l.5-.2.5-.3C360.5,264.8,363.9,261.8,363.7,261.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M359,262.6c-5.6-.1-22.5,4-25.2,5.5l-3.3,1.9c-1.1.7-2.3,1.2-3,2.4a6.7,6.7,0,0,0-.7,3.9,14.8,14.8,0,0,0,3.2,7.5c1.5,2.1,4.1,4.4,6.9,4.3s1.3-2.1,2.4-2.7,2.7-.1,4.1-.9,14.4-14.6,16.9-19.7A1.6,1.6,0,0,0,359,262.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M330,283.8c1.5,2.1,4.1,4.4,6.9,4.3s1.3-2.1,2.4-2.7,2.7-.1,4.1-.9,11.8-11.8,15.8-17.7l-29.3,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M344.9,280.2a14.8,14.8,0,0,0-2.2-6.8,12.1,12.1,0,0,0-5.1-4.9,5.5,5.5,0,0,0-2.5-.7c-1.3,0-2.3.8-3.4,1.4l-9.6,5.6-9.7,5.6c-1.1.7-2.3,1.2-3,2.4a6.6,6.6,0,0,0-.6,3.9,13.9,13.9,0,0,0,3.1,7.5c1.6,2.1,4.1,4.4,6.9,4.2s2.2-.8,3.3-1.4l4-2.4,8.1-4.7,8.1-4.7a4.3,4.3,0,0,0,2.2-2.2,8.2,8.2,0,0,0,.4-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M344.9,280.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M344.5,283a8.2,8.2,0,0,0,.4-2.8,11.1,11.1,0,0,0-.9-4c-10.6,6.1-21.2,11.7-31.8,17.9,1.6,1.9,4,4.5,6.6,4.3s2.2-.8,3.3-1.4l4-2.4,8.1-4.7,8.1-4.7A4.3,4.3,0,0,0,344.5,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M322.3,293.3a14.2,14.2,0,0,0-2.1-6.5,12.3,12.3,0,0,0-5-5.1c-1.4-.7-3.2-1.1-4.6-.2l-2.1,1.2a4.5,4.5,0,0,0-1.6,1.2,6.8,6.8,0,0,0-.9,5.2,15.6,15.6,0,0,0,2.1,5.4,13.8,13.8,0,0,0,3.8,4.2c1.5,1.1,3.8,2,5.6.9l2.8-1.6c1.6-.9,2-2.9,2-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M322.3,293.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M311.9,298.7c1.5,1.1,3.8,2,5.6.9l2.8-1.6c1.6-.9,2-2.9,2-4.7a13.4,13.4,0,0,0-1-4.4L309.1,296A14.4,14.4,0,0,0,311.9,298.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M319.5,294.9a13.4,13.4,0,0,0-1.6-5.5,13.1,13.1,0,0,0-4.3-5.3,5.8,5.8,0,0,0-5-1.4l-1.1.5-3.2,1.9-14,8.1-18.8,10.9-17.6,10.3-10.3,5.9-.6.4c-1.7,1-2.1,3-2,4.8a13.8,13.8,0,0,0,2.8,7.6c1.5,2.2,4,4.5,6.8,4.7s2.6-.9,3.9-1.6l4.8-2.8,9.7-5.7,19.4-11.2,18.2-10.6,9.1-5.3c1.3-.7,2.6-1.3,3.2-2.6a6.9,6.9,0,0,0,.6-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M319.5,294.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M315.7,300.6c1.3-.7,2.6-1.3,3.2-2.6a6.9,6.9,0,0,0,.6-3.1,13.6,13.6,0,0,0-1.1-4.4l-17.2,10-30.5,17.7-26.5,15.4c1.5,2,3.8,4,6.4,4.2s2.6-.9,3.9-1.6l4.8-2.8,9.7-5.7,19.4-11.2,18.2-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M247.6,320.4a16.6,16.6,0,0,1,7.4,12.9c0,4.8-3.3,6.7-7.5,4.3a16.6,16.6,0,0,1-7.4-12.9C240.1,320,243.5,318.1,247.6,320.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M258.1,331.2a16.1,16.1,0,0,0-5.2-10.9,8.7,8.7,0,0,0-4.9-2.6c-2.1-.3-4,1.2-5.7,2.2,1.6-1,3.7-.4,5.3.5a17.2,17.2,0,0,1,5.1,5.3,15.8,15.8,0,0,1,2.2,6.3c.3,2.1,0,4.9-2.1,6.1l2.5-1.5a4.1,4.1,0,0,0,1.9-1.5,6.8,6.8,0,0,0,.9-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M258.1,331.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M257.2,335.1a6.8,6.8,0,0,0,.9-3.9,14.5,14.5,0,0,0-1.1-5l-3.2,1.8a11.4,11.4,0,0,1,1.1,4c.3,2.1,0,4.9-2.1,6.1l2.5-1.5A4.1,4.1,0,0,0,257.2,335.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "284.8 300 284.8 301.3 249.2 321.9 249.2 320.6 284.8 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "249.2 321.9 245.1 319.5 245.1 318.2 249.2 320.6 249.2 321.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "249.2 320.6 245.1 318.2 280.7 297.6 284.8 300 249.2 320.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M129.1,231.6v3.5a2.7,2.7,0,0,1,.8,2.2v-3.5A3.1,3.1,0,0,0,129.1,231.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M138.2,235.2c0,.1-.1.2-.1.4l-.2.6c-.1,0-.1.1-.1.2a3.6,3.6,0,0,0-.4.9l-.2.2a7.5,7.5,0,0,1-.7,1.2l-1.1,1.6v3.5l1.1-1.6.7-1.1h0v-.2a3.6,3.6,0,0,0,.4-.9l.2-.2v-.2c.1-.2.1-.3.2-.4s0-.3.1-.4h0c0-.2.1-.4.1-.6h0v-3.5C138.3,234.6,138.2,234.9,138.2,235.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "186.2 241.4 186.2 244.9 186.6 243.6 186.6 240.1 186.2 241.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M183.5,241.9H170.3l-5.7.3h-.9l-3.4.2-4,.3h-1.2l-2.8.3h-1l-2.9.3H147l-2.4.3-1.4.2-2.3.4-1.3.2-2.3.4h-1.1l-3.2.7-3.3-.4-1.6-.2h-4.3v3.6h5.8l3.4.4,3.2-.6,1.1-.2,2.3-.4,1.3-.2,2.3-.3,1.4-.3,2.3-.2,1.5-.2,2.5-.3h1.6l2-.2,1.8-.2,4-.3,3.5-.2h19.7l2.7.2v-3.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M209,244.2l-.3,1.3a164.5,164.5,0,0,0-26,.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.7,3.7,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1,2.7-1,5.8l-1,1.6a178.2,178.2,0,0,1,26.3-1.8A140.7,140.7,0,0,1,209,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M208,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,198.8,198.8,0,0,0-27.4,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1.1,2.7-1,5.8l-1,1.6a179.2,179.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,208,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M206.9,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,197.2,197.2,0,0,0-27.3,3.5l-3.4-.4-5.8-.5a33.2,33.2,0,0,0,2.5-3.2l1-1.4c1.4-2.1,2.3-3.7,2.5-5a3.2,3.2,0,0,0-.7-3.1c4-.1,6.7.3,8.3,1.3s1.1,2.7-.9,5.8l-1.1,1.6a180.6,180.6,0,0,1,26.4-1.8A141.4,141.4,0,0,1,206.9,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M205.8,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.5,3.5,0,0,0-.8-3.1c4-.1,6.8.3,8.4,1.3s1,2.7-1,5.8l-1,1.6a178.2,178.2,0,0,1,26.3-1.8A140.7,140.7,0,0,1,205.8,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M204.8,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,196.8,196.8,0,0,0-27.4,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1,2.7-1,5.8l-1,1.6a179.2,179.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,204.8,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M203.7,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,200.9,200.9,0,0,0-27.4,3.5l-3.3-.4-5.8-.5a33.2,33.2,0,0,0,2.5-3.2l1-1.4c1.4-2.1,2.3-3.7,2.5-5a3.2,3.2,0,0,0-.7-3.1c4-.1,6.7.3,8.3,1.3s1.1,2.7-.9,5.8l-1.1,1.6a180.6,180.6,0,0,1,26.4-1.8A141.4,141.4,0,0,1,203.7,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M202.6,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l.9-1.4a14.9,14.9,0,0,0,2.6-5,3.5,3.5,0,0,0-.8-3.1c4-.1,6.8.3,8.4,1.3s1,2.7-1,5.8l-1,1.6a178.2,178.2,0,0,1,26.3-1.8A140.7,140.7,0,0,1,202.6,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M201.6,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,196.8,196.8,0,0,0-27.4,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1,2.7-1,5.8l-1,1.6a179.2,179.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,201.6,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M200.5,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,200.9,200.9,0,0,0-27.4,3.5l-3.3-.4-5.8-.5a33.2,33.2,0,0,0,2.5-3.2l1-1.4c1.4-2.1,2.3-3.7,2.5-5a3.2,3.2,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1.1,2.7-1,5.8l-1,1.6a180.6,180.6,0,0,1,26.4-1.8A142.1,142.1,0,0,1,200.5,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M199.4,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5c.6-.6,1.4-1.7,2.6-3.2l.9-1.4a17.1,17.1,0,0,0,2.6-5,3.5,3.5,0,0,0-.8-3.1c4-.1,6.8.3,8.4,1.3s1,2.7-1,5.8l-1,1.6a178.2,178.2,0,0,1,26.3-1.8A140.7,140.7,0,0,1,199.4,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M198.4,244.2l-.4,1.3a164.5,164.5,0,0,0-26,.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1,2.7-1,5.8l-1,1.6a179.2,179.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,198.4,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M197.3,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,200.9,200.9,0,0,0-27.4,3.5l-3.3-.4-5.8-.5a33.2,33.2,0,0,0,2.5-3.2l1-1.4c1.4-2.1,2.3-3.7,2.5-5a3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1.1,2.7-1,5.8l-1,1.6a180.6,180.6,0,0,1,26.4-1.8A142.1,142.1,0,0,1,197.3,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M196.2,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5c.6-.6,1.4-1.7,2.6-3.2l.9-1.4a17.1,17.1,0,0,0,2.6-5,3.5,3.5,0,0,0-.8-3.1c4-.1,6.8.3,8.4,1.3s1,2.7-1,5.8l-1.1,1.6a180.6,180.6,0,0,1,26.4-1.8A140.7,140.7,0,0,1,196.2,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M195.2,244.2l-.4,1.3a164.5,164.5,0,0,0-26,.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1,2.7-1,5.8l-1,1.6a178.2,178.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,195.2,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M194.1,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,198.8,198.8,0,0,0-27.4,3.5l-3.3-.4-5.8-.5,2.5-3.2,1-1.4a16.3,16.3,0,0,0,2.5-5,3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1.1,2.7-1,5.8l-1,1.6a180.2,180.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,194.1,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M193,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5c.6-.6,1.4-1.7,2.6-3.2l.9-1.4c1.4-2.1,2.3-3.7,2.5-5a3.2,3.2,0,0,0-.7-3.1c4-.1,6.7.3,8.4,1.3s1,2.7-1,5.8l-1.1,1.6a180.6,180.6,0,0,1,26.4-1.8A140.7,140.7,0,0,1,193,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M192,244.2l-.4,1.3a164.5,164.5,0,0,0-26,.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1,2.7-1,5.8l-1,1.6a178.2,178.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,192,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M190.9,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,198.8,198.8,0,0,0-27.4,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1.1,2.7-1,5.8l-1,1.6a179.2,179.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,190.9,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M189.8,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,197.2,197.2,0,0,0-27.3,3.5l-3.4-.4-5.8-.5a33.2,33.2,0,0,0,2.5-3.2l1-1.4c1.4-2.1,2.3-3.7,2.5-5a3.2,3.2,0,0,0-.7-3.1c4-.1,6.7.3,8.3,1.3s1.1,2.7-.9,5.8l-1.1,1.6a180.6,180.6,0,0,1,26.4-1.8A140.7,140.7,0,0,1,189.8,244.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M188.8,244.2l-.4,1.3a164.5,164.5,0,0,0-26,.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.7,3.7,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1,2.7-1,5.8l-1,1.6a178.2,178.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,188.8,244.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M187.7,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,198.8,198.8,0,0,0-27.4,3.5l-3.3-.4-5.9-.5a30.5,30.5,0,0,0,2.6-3.2l1-1.4a16.3,16.3,0,0,0,2.5-5,3.4,3.4,0,0,0-.7-3.1c3.9-.1,6.7.3,8.3,1.3s1.1,2.7-1,5.8l-1,1.6a179.2,179.2,0,0,1,26.3-1.8A142.6,142.6,0,0,1,187.7,244.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M186.6,244.2l-.4,1.3a163.2,163.2,0,0,0-25.9.3,200.9,200.9,0,0,0-27.4,3.5l-3.3-.4-5.8-.5a33.2,33.2,0,0,0,2.5-3.2l1-1.4c1.4-2.1,2.3-3.7,2.5-5a3.2,3.2,0,0,0-.7-3.1c4-.1,6.7.3,8.3,1.3s1.1,2.7-.9,5.8l-1.1,1.6a180.6,180.6,0,0,1,26.4-1.8A140.7,140.7,0,0,1,186.6,244.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M129.7,244.8h-5.9v3.6h5.8l3.4.4v-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M167.7,244.8h.2l3-.2h12.6l2.7.2v-3.5l-2.7-.2H170.3l-5.7.2h-.9l-3.4.2-4,.3h-1.2l-2.8.3h-1l-2.9.3H147l-2.4.3-1.4.2-2.3.4-1.3.2-2.3.4h-1.1l-3.2.6v3.5l3.2-.6,1.1-.2,2.3-.4,1.3-.2,2.3-.3,1.4-.2,2.3-.3,1.5-.2,2.5-.3h1.6l2-.2,1.8-.2,4-.3,3.5-.2h3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M186.6,240.8l-.4,1.3a191.5,191.5,0,0,0-25.9.3,213.8,213.8,0,0,0-27.3,3.5l-3.3-.4-5.9-.4v-.8l3.5-3.9a18.2,18.2,0,0,0,2.6-4.9c.2-1.3.9-2.3.1-3.2,4-.1,5.9.4,7.5,1.3s1,2.8-1,5.9l-1.1,1.5a180.6,180.6,0,0,1,26.4-1.8c9.2-.1,17.9-.2,24.8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M186.6,240.1l-.4,1.3a163.2,163.2,0,0,0-25.9.3,197.2,197.2,0,0,0-27.3,3.5l-3.3-.4-5.9-.5c.6-.6,1.4-1.7,2.6-3.2l.9-1.4a18.4,18.4,0,0,0,2.6-5,3.5,3.5,0,0,0-.8-3.1c4-.1,6.8.3,8.4,1.3s1,2.7-1,5.8l-1.1,1.6a194.9,194.9,0,0,1,26.4-1.9A150,150,0,0,1,186.6,240.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M348.6,327.6a1,1,0,0,1,0-1.8l16.6-9.7a3.4,3.4,0,0,1,3.1,0l16.7,9.7a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M347.8,327.5c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M346.9,327.5a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M346,327.4c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3.1,1.8L365.8,337a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M345.1,327.4c-.8-.6-.8-1.4,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.8.5.8,1.3,0,1.9L364.9,337a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M344.3,327.3c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a2.9,2.9,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M343.4,327.2c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M342.5,327.2a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.6.9,1.4,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M341.6,327.1c-.8-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M340.8,327.1a1,1,0,0,1-.1-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M339.9,327c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M339,326.9c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.7a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M338.1,326.9c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3.1,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M337.2,326.8a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8L357,336.4a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M336.4,326.8a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M335.5,326.7c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M334.6,326.7a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M333.7,326.6a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M332.9,326.5c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.1,3.1,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M332,326.5c-.9-.5-.9-1.3,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M331.1,326.4c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L350.9,336a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M330.2,326.4a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.7,9.6a1.1,1.1,0,0,1,0,1.9L350,336a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M329.3,326.3a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.8.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M328.5,326.3c-.9-.6-.9-1.4,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M327.6,326.2c-.9-.5-.9-1.3,0-1.8l16.5-9.7a3.6,3.6,0,0,1,3.2,0l16.6,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M326.7,326.1c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3.1,1.8l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M325.8,326.1a1.1,1.1,0,0,1,0-1.9l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6c.8.6.8,1.4,0,1.9l-16.6,9.6a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M325,326c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M324.1,326a1,1,0,0,1,0-1.9l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6a1,1,0,0,1,0,1.9l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M323.2,325.9c-.9-.5-.9-1.3,0-1.8l16.5-9.6a3.6,3.6,0,0,1,3.2,0l16.6,9.6c.9.5.9,1.3,0,1.8L343,335.5a3.4,3.4,0,0,1-3.1,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M322.3,325.8a1,1,0,0,1,0-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0l16.7,9.6a1,1,0,0,1,0,1.8l-16.6,9.7a3.4,3.4,0,0,1-3.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M321.5,325.8c-.9-.5-.9-1.3-.1-1.8l16.6-9.7a3.4,3.4,0,0,1,3.1,0l16.7,9.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M321.5,325.9c-.9-.5-.9-1.3-.1-1.8H338a3.4,3.4,0,0,1,3.1,0h16.7c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M358.4,322.1h-.1a.1.1,0,0,0-.1.1h-.4l-16.5,9.6v2.2l16.6-9.6h.1a.1.1,0,0,1,.1-.1h.4V322Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M321.5,322.9a1,1,0,0,1-.7-.9v2.2a1.2,1.2,0,0,0,.6.9l16.7,9.6v-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M357.8,321.1c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0l-16.6-9.6c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a3.4,3.4,0,0,1,3.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M321.5,322.2c-.9-.5-.9-1.3-.1-1.8l16.6-9.6a2.9,2.9,0,0,1,3.1,0l16.7,9.6c.9.5.9,1.3,0,1.8l-16.5,9.6a3.6,3.6,0,0,1-3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M339.7,330.9a3.3,3.3,0,0,1-1.5-.3l-14.5-8.4c-.4-.3-.7-.6-.7-.9a1.1,1.1,0,0,1,.7-.9l14.4-8.4a3.3,3.3,0,0,1,1.5-.4,3.3,3.3,0,0,1,1.4.4l14.6,8.4a1,1,0,0,1,.6.9,1.2,1.2,0,0,1-.6.9l-14.5,8.4A3.2,3.2,0,0,1,339.7,330.9Zm-.1-19a3.2,3.2,0,0,0-1.4.3l-14.4,8.4c-.4.2-.5.4-.5.7a.8.8,0,0,0,.5.7l14.5,8.4a3.2,3.2,0,0,0,1.4.3,2.8,2.8,0,0,0,1.3-.3l14.5-8.4a1,1,0,0,0,.5-.7c0-.3-.2-.5-.5-.7l-14.6-8.4A2.8,2.8,0,0,0,339.6,311.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M341,334.8l.4-.2v-2.2c0,.1-.3.2-.4.2h-2.7l-.5-.2v2.2c.1,0,.4.1.4.2h1.2a.1.1,0,0,1,.1.1h1a.1.1,0,0,1,.1-.1h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M339.6,323.1h-.3l-2.7-1.6a.2.2,0,0,1-.2-.2l.2-.3,2.7-1.6a.6.6,0,0,1,.6,0l2.8,1.6.2.3a.2.2,0,0,1-.2.2L340,323Zm0-3.6h-.2l-2.7,1.6h0l2.7,1.6h.4l2.8-1.6h0l-2.8-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M339.6,322.3h-.2l-1.6-.9a.3.3,0,0,1-.1-.2c0-.1,0-.2.1-.2l1.6-1h.4l1.7,1v.4l-1.7.9Zm0-2.1h-.1l-1.6,1,1.6.9h.2l1.6-.9-1.6-1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M108.6,284.9a7.7,7.7,0,0,1,2.7,2.4c.3.5,5.6-4.3,10.7-1.4a13.6,13.6,0,0,0,4.5,1.9l.9.3a5.4,5.4,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21,3-21-12V282.4c0-1.9.9-2.6,2.2-1.8a1.6,1.6,0,0,1,.8.6,32.8,32.8,0,0,0,4.5,3.3c5.2,3,10.5-.2,10.8-.3A3.8,3.8,0,0,1,108.6,284.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M107.1,284.8a9.2,9.2,0,0,1,2.7,2.5c.3.4,5.6-3.9,10.7-1a13.6,13.6,0,0,0,4.5,1.9l.9.3a5.2,5.2,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21,2.3-21-12.7V282.4c0-1.9.9-2.6,2.2-1.9a2.7,2.7,0,0,1,.8.7,28.1,28.1,0,0,0,4.5,3.2c5.2,3,10.5-.1,10.8-.3A5.2,5.2,0,0,1,107.1,284.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M105.6,284.8a8.8,8.8,0,0,1,2.7,2.4c.3.5,5.6-3.4,10.7-.5a13.6,13.6,0,0,0,4.5,1.9l.9.3a5.3,5.3,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21,1.5-21-13.5V282.3c0-1.8.9-2.5,2.2-1.8l.8.6a25.5,25.5,0,0,0,4.5,3.3c5.2,3,10.5-.1,10.8-.3A3.8,3.8,0,0,1,105.6,284.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M104.1,284.7a9.2,9.2,0,0,1,2.7,2.5c.3.5,5.6-3,10.7-.1A14.6,14.6,0,0,0,122,289l.9.4a5,5,0,0,1,2.2,4.3V312c0,15-18.8,12.3-21,11s-21,.8-21-14.2V282.3c0-1.9.9-2.6,2.2-1.8a1.6,1.6,0,0,1,.8.6,28.1,28.1,0,0,0,4.5,3.2c5.2,3,10.5-.1,10.8-.2A4.2,4.2,0,0,1,104.1,284.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M102.6,284.7a8.8,8.8,0,0,1,2.7,2.4c.3.5,5.6-2.5,10.7.4a13.6,13.6,0,0,0,4.6,1.9l.8.4a5,5,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21,0-21-15V282.3c0-1.9.9-2.6,2.2-1.9l.9.6a19.4,19.4,0,0,0,4.4,3.3c5.2,3,10.5-.1,10.8-.3A4.4,4.4,0,0,1,102.6,284.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M101.1,284.7a7.7,7.7,0,0,1,2.7,2.4c.3.5,5.6-2.1,10.7.9a22.1,22.1,0,0,0,4.6,1.9l.8.3a5,5,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-.7-21-15.7V282.2c0-1.9,1-2.6,2.2-1.8a2.4,2.4,0,0,1,.9.6,28.4,28.4,0,0,0,4.4,3.3c5.2,3,10.5-.2,10.8-.3A3.8,3.8,0,0,1,101.1,284.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M99.6,284.6a8.8,8.8,0,0,1,2.7,2.4c.3.5,5.6-1.6,10.7,1.4a22.1,22.1,0,0,0,4.6,1.9,1.3,1.3,0,0,1,.8.3,5,5,0,0,1,2.2,4.4v17c0,15-18.7,12.3-21,11s-20.9-1.5-21-16.5V282.2c0-1.9,1-2.6,2.3-1.9l.8.7a24.8,24.8,0,0,0,4.4,3.2c5.2,3,10.5-.1,10.8-.3A4.4,4.4,0,0,1,99.6,284.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M98.1,284.6a7.7,7.7,0,0,1,2.7,2.4c.3.5,5.6-1.2,10.7,1.8a16.9,16.9,0,0,0,4.6,1.9,1.3,1.3,0,0,1,.8.3,5,5,0,0,1,2.2,4.4V312c0,15-18.7,12.3-20.9,11s-21-2.2-21-17.2V282.1c0-1.9,1-2.5,2.3-1.8l.8.6a22.7,22.7,0,0,0,4.4,3.3c5.2,3,10.5-.2,10.8-.3A3.6,3.6,0,0,1,98.1,284.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M96.7,284.5a12.5,12.5,0,0,1,2.7,2.5c.2.4,5.5-.8,10.6,2.2a16.9,16.9,0,0,0,4.6,1.9,1.3,1.3,0,0,1,.8.3,5,5,0,0,1,2.2,4.4V312c.1,15-18.7,12.3-20.9,11s-21-2.9-21-17.9v-23c0-1.9,1-2.6,2.3-1.9l.8.7a24.8,24.8,0,0,0,4.4,3.2c5.2,3,10.5-.1,10.8-.3A5.3,5.3,0,0,1,96.7,284.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M95.2,284.5a12,12,0,0,1,2.7,2.4c.2.5,5.5-.3,10.6,2.7a16.9,16.9,0,0,0,4.6,1.9,1.1,1.1,0,0,1,.8.3,5,5,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-3.7-21-18.7V282c0-1.8,1-2.5,2.3-1.8l.8.6a22.7,22.7,0,0,0,4.4,3.3c5.2,3,10.5-.1,10.8-.3A3.9,3.9,0,0,1,95.2,284.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M93.7,284.4a12.5,12.5,0,0,1,2.7,2.5c.2.5,5.5.1,10.6,3.1a16.9,16.9,0,0,0,4.6,1.9,1.9,1.9,0,0,1,.8.3,5,5,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-4.4-21-19.4V282c0-1.9,1-2.6,2.3-1.8l.8.6a24.8,24.8,0,0,0,4.4,3.2c5.2,3,10.5-.1,10.8-.2A4.3,4.3,0,0,1,93.7,284.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M92.2,284.4a12,12,0,0,1,2.7,2.4c.2.5,5.5.6,10.6,3.6a16.9,16.9,0,0,0,4.6,1.9l.8.3a5.2,5.2,0,0,1,2.2,4.4v15c0,15-18.8,12.3-21,11s-21-5.2-21-20.2V281.9c0-1.8,1-2.5,2.3-1.8l.8.6a22.7,22.7,0,0,0,4.4,3.3c5.2,3,10.5-.1,10.8-.3A4.5,4.5,0,0,1,92.2,284.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M90.7,284.4a8.7,8.7,0,0,1,2.7,2.4c.3.5,5.5,1,10.6,4a14.5,14.5,0,0,0,4.6,1.9l.8.3a5.2,5.2,0,0,1,2.3,4.4V312c0,15-18.8,12.3-21,11s-21-5.9-21-20.9V281.9c0-1.9.9-2.6,2.2-1.8l.8.6a26.6,26.6,0,0,0,4.5,3.3c5.1,3,10.4-.2,10.7-.3A3.9,3.9,0,0,1,90.7,284.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M89.2,284.3a10.1,10.1,0,0,1,2.7,2.4c.3.5,5.5,1.6,10.7,4.5a13.6,13.6,0,0,0,4.5,1.9l.8.3a5.2,5.2,0,0,1,2.3,4.4V312c0,15-18.8,12.3-21,11s-21-6.7-21-21.7V281.9c0-1.9.9-2.6,2.2-1.9l.8.7a29.9,29.9,0,0,0,4.5,3.2c5.2,3,10.5-.1,10.7-.3A4.5,4.5,0,0,1,89.2,284.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M87.7,284.3a8.7,8.7,0,0,1,2.7,2.4c.3.5,5.5,2,10.7,4.9a13.6,13.6,0,0,0,4.5,1.9l.8.3a5.2,5.2,0,0,1,2.3,4.4V312c0,15-18.8,12.3-21,11s-21-7.4-21-22.4V281.8c0-1.9.9-2.5,2.2-1.8s.5.4.8.6a21.6,21.6,0,0,0,4.5,3.3c5.2,3,10.5-.2,10.7-.3A3.9,3.9,0,0,1,87.7,284.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M86.2,284.2a9.2,9.2,0,0,1,2.7,2.5c.3.4,5.5,2.4,10.7,5.3a13.6,13.6,0,0,0,4.5,1.9l.8.3a5.4,5.4,0,0,1,2.3,4.4V312c0,15-18.8,12.3-21,11s-21-8.2-21-23.1V281.8c0-1.9.9-2.6,2.2-1.9l.8.7a23.5,23.5,0,0,0,4.5,3.2c5.2,3,10.5-.1,10.7-.3A5.3,5.3,0,0,1,86.2,284.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M84.7,284.2a8.8,8.8,0,0,1,2.7,2.4c.3.5,5.5,2.9,10.7,5.8a13.6,13.6,0,0,0,4.5,1.9l.9.4a5.2,5.2,0,0,1,2.2,4.3v13c0,15-18.8,12.3-21,11s-21-8.9-21-23.9V281.7c0-1.8.9-2.5,2.2-1.8l.8.6a21.6,21.6,0,0,0,4.5,3.3c5.2,3,10.5-.1,10.7-.3A3.9,3.9,0,0,1,84.7,284.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M83.2,284.1a9.2,9.2,0,0,1,2.7,2.5c.3.5,5.5,3.3,10.7,6.2a13.6,13.6,0,0,0,4.5,1.9l.9.4a5.2,5.2,0,0,1,2.2,4.3V312c0,15-18.8,12.3-21,11s-21-9.6-21-24.6V281.7c0-1.9.9-2.6,2.2-1.8a2.1,2.1,0,0,1,.8.6,23.5,23.5,0,0,0,4.5,3.2c5.2,3,10.5-.1,10.8-.2A4.2,4.2,0,0,1,83.2,284.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M81.7,284.1a8.8,8.8,0,0,1,2.7,2.4c.3.5,5.6,3.8,10.7,6.8a22.8,22.8,0,0,0,4.5,1.9,1.6,1.6,0,0,1,.9.3,5.3,5.3,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-10.4-21-25.4V281.7c0-1.9.9-2.6,2.2-1.9l.8.6a21.6,21.6,0,0,0,4.5,3.3c5.2,3,10.5-.1,10.8-.3A4.4,4.4,0,0,1,81.7,284.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M80.2,284.1a7.7,7.7,0,0,1,2.7,2.4c.3.5,5.6,4.2,10.7,7.2a22.8,22.8,0,0,0,4.5,1.9,1.6,1.6,0,0,1,.9.3,5.3,5.3,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-11.1-21-26.1V281.6c0-1.9.9-2.6,2.2-1.8a1.6,1.6,0,0,1,.8.6,26.6,26.6,0,0,0,4.5,3.3c5.2,3,10.5-.2,10.8-.3A3.8,3.8,0,0,1,80.2,284.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M78.7,284a8.8,8.8,0,0,1,2.7,2.4,68,68,0,0,0,10.7,7.7,22.8,22.8,0,0,0,4.5,1.9,1.6,1.6,0,0,1,.9.3,5,5,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-11.9-21-26.9V281.6c0-1.9.9-2.6,2.2-1.9a2.7,2.7,0,0,1,.8.7,38,38,0,0,0,4.5,3.2c5.2,3,10.5-.1,10.8-.3A4.4,4.4,0,0,1,78.7,284Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M77.2,284a7.7,7.7,0,0,1,2.7,2.4,60.7,60.7,0,0,0,10.7,8.1,18.7,18.7,0,0,0,4.5,1.9,1.6,1.6,0,0,1,.9.3,5,5,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-12.6-21-27.6V281.5c0-1.9.9-2.6,2.2-1.8l.9.6a19.4,19.4,0,0,0,4.4,3.3c5.2,3,10.5-.2,10.8-.3A3.8,3.8,0,0,1,77.2,284Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M75.7,283.9a9.2,9.2,0,0,1,2.7,2.5,60,60,0,0,0,10.7,8.5,16.9,16.9,0,0,0,4.6,1.9l.8.3a5,5,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-13.4-21-28.3V281.5c0-1.9.9-2.6,2.2-1.9l.9.7a20.9,20.9,0,0,0,4.4,3.2c5.2,3,10.5-.1,10.8-.3A5.2,5.2,0,0,1,75.7,283.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M74.2,283.9a8.8,8.8,0,0,1,2.7,2.4,51.2,51.2,0,0,0,10.7,9,16.9,16.9,0,0,0,4.6,1.9l.8.3a5,5,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-14.1-21-29.1V281.4c0-1.8,1-2.5,2.2-1.8l.9.6a22.7,22.7,0,0,0,4.4,3.3c5.2,3,10.5-.1,10.8-.3A3.8,3.8,0,0,1,74.2,283.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M72.7,283.8a9.2,9.2,0,0,1,2.7,2.5,48.7,48.7,0,0,0,10.7,9.4,16.9,16.9,0,0,0,4.6,1.9c.3,0,.5.2.8.3a5.2,5.2,0,0,1,2.2,4.4V312c0,15-18.7,12.3-21,11s-20.9-14.8-21-29.8V281.4c0-1.9,1-2.6,2.3-1.8l.8.6a24.8,24.8,0,0,0,4.4,3.2c5.2,3,10.5-.1,10.8-.2A4.2,4.2,0,0,1,72.7,283.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M71.2,283.8a8.8,8.8,0,0,1,2.7,2.4c.3.5,5.6,6.9,10.7,9.9a13.6,13.6,0,0,0,4.6,1.9l.8.3a5.2,5.2,0,0,1,2.2,4.4V312c0,15-18.7,12.3-20.9,11s-21-15.6-21-30.6V281.3c0-1.8,1-2.5,2.3-1.8l.8.6a22.7,22.7,0,0,0,4.4,3.3c5.2,3,10.5-.1,10.8-.3A4.1,4.1,0,0,1,71.2,283.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M69.8,283.8a9.9,9.9,0,0,1,2.7,2.4c.2.5,5.5,7.4,10.6,10.3a13.6,13.6,0,0,0,4.6,1.9l.8.3a5.2,5.2,0,0,1,2.2,4.4V312c0,15-18.7,12.3-20.9,11s-21-16.3-21-31.3V281.3c0-1.9,1-2.6,2.3-1.8l.8.6a28.4,28.4,0,0,0,4.4,3.3c5.2,2.9,10.5-.2,10.8-.3A3.9,3.9,0,0,1,69.8,283.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M68.3,283.7a12,12,0,0,1,2.7,2.4c.2.5,5.5,7.9,10.6,10.8a13.6,13.6,0,0,0,4.6,1.9l.8.3a5.2,5.2,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-17.1-21-32.1v-9.6c0-1.9,1-2.6,2.3-1.9l.8.7a32.3,32.3,0,0,0,4.4,3.2c5.2,3,10.5-.1,10.8-.3A4.5,4.5,0,0,1,68.3,283.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M66.8,283.7a9.9,9.9,0,0,1,2.7,2.4c.2.5,5.5,8.3,10.6,11.2a13.6,13.6,0,0,0,4.6,1.9l.8.3a5.2,5.2,0,0,1,2.2,4.4V312c0,15-18.8,12.3-21,11s-21-17.8-21-32.8v-9c0-1.9,1-2.6,2.3-1.8l.8.6a28.4,28.4,0,0,0,4.4,3.3c5.2,3,10.5-.2,10.8-.3A3.9,3.9,0,0,1,66.8,283.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M65.3,283.6a12.5,12.5,0,0,1,2.7,2.5c.2.4,5.5,8.7,10.6,11.6a13.6,13.6,0,0,0,4.6,1.9l.8.4a5,5,0,0,1,2.2,4.3V312c0,15-18.8,12.3-21,11s-21-18.6-21-33.6v-8.2c0-1.9,1-2.6,2.3-1.9l.8.7a23.5,23.5,0,0,0,4.5,3.2c5.2,3,10.4-.1,10.7-.3A5.3,5.3,0,0,1,65.3,283.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M63.8,283.6a10.1,10.1,0,0,1,2.7,2.4c.3.5,5.5,9.2,10.6,12.1a14.5,14.5,0,0,0,4.6,1.9l.8.4a5,5,0,0,1,2.2,4.3V312c0,15-18.8,12.3-21,11s-21-19.3-21-34.3v-7.6c0-1.9,1-2.5,2.3-1.8l.8.6a21.6,21.6,0,0,0,4.5,3.3c5.2,3,10.4-.1,10.7-.3A3.9,3.9,0,0,1,63.8,283.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M62.3,283.5A10.6,10.6,0,0,1,65,286c.3.5,5.5,9.6,10.7,12.5a13.6,13.6,0,0,0,4.5,1.9l.8.4a5.1,5.1,0,0,1,2.3,4.4V312c0,15-18.8,12.3-21,11s-21-20-21-35v-6.9c0-1.9.9-2.6,2.2-1.8a2.1,2.1,0,0,1,.8.6,23.5,23.5,0,0,0,4.5,3.2c5.2,3,10.5-.1,10.7-.2A4.3,4.3,0,0,1,62.3,283.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M58,261.9h.2c.1,0,.1,0,.1-.1h1.2l10.9-6.4H62.1c-.1,0-.2,0-.2-.1H61l-.3-.2h-.1l-.4-.2h-.1a.5.5,0,0,1-.4-.2l-.4-.2h-.2l-.4-.3h0l-.4-.2h-.1l-.3-.2h-.2l-.2-.2h-.3l-.3-.2a.1.1,0,0,0-.1-.1h-.3l-.3-.3h0l-.3-.2h-.7c0-.1-.1-.1-.1-.2h-.6a.1.1,0,0,1-.1-.1H52.9L42,257.4h1.3l.2.2h.4l.2.2h0l.2.2h.4a.1.1,0,0,0,.1.1H45l.6.5h.5l.2.2h.2c0,.1.1.1.1.2h.8l.3.2h.1l.4.2h.2c0,.1.1.1.2.1h.2c0,.1.1.1.2.2h.3l.3.2h.1a.1.1,0,0,1,.1.1H50a.1.1,0,0,0,.1.1h7.1l.4-.2H58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M63,262.3h0l.3.3h.1l.3.3h0l.3.3h.1l.3.3h0l.3.3h0l.5.7,10.7-6.7.4.8-.6-1h-.3c0-.1-.1-.1-.1-.2h-.1c0-.1-.1-.1-.1-.2a.1.1,0,0,1-.1-.1h-.1l-.2-.2h-.5l-.3-.2h-.4l-.3-.2H70.4l-10.9,6.4h1.7l.3.2h.8l.3.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M94.1,277.1l-10.8,6.4V312a2.8,2.8,0,0,1-.1.9v1c-.1.3-.1.6-.2.8h0c0,.2-.1.4-.1.6a.4.4,0,0,1-.1.3c0,.1-.1.3-.1.4a.8.8,0,0,1-.2.5.4.4,0,0,1-.1.3,1.4,1.4,0,0,1-.2.6h-.1c0,.1,0,.2-.1.2a.5.5,0,0,1-.2.4c0,.1-.1.2-.1.3s-.2.2-.2.3-.1.2-.2.2-.1.3-.2.4-.1.1-.2.2l-.2.3a.2.2,0,0,0-.2.2l-.3.2-.2.2c0,.1-.1.2-.2.3h-.2l-.3.3h-.2l-.4.3h-.1l-.6.3,10.9-6.3.6-.4a.1.1,0,0,0,.1-.1l.4-.2c0-.1.1-.1.2-.2l.3-.2c0-.1.1-.1.2-.2l.2-.2c.1-.1.2-.1.2-.2l.3-.3.2-.2c0-.1.1-.2.2-.3s.1-.1.2-.2l.2-.3.2-.2h0l.2-.3a.3.3,0,0,0,.1-.2.8.8,0,0,0,.2-.4v-.2h.1a1.4,1.4,0,0,0,.2-.6h.1v-.2l.2-.5h0c.1-.1.1-.2.1-.4v-.2h0a1.3,1.3,0,0,0,.1-.6h0a1.7,1.7,0,0,0,.1-.7h.1v-1h0a2,2,0,0,0,.1-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M81.5,279.4h0l.2.2h0c.1.1.2.1.2.2h0l.2.2h0l.2.2h0l.2.2h0a.3.3,0,0,1,.1.2h0l.2.3h0a.4.4,0,0,0,.1.3h0c.1.2.1.5.2.7h0a.4.4,0,0,0,.1.3h0v.4h0v.3h0c.1.1.1.2.1.4l10.8-6.4h0v-.2h0v-.4h0v-.2h0c-.1-.1-.1-.1-.1-.2h-.1v-.2h-.1c-.1,0-.1,0-.1-.1h0a.1.1,0,0,1-.1-.1h-.1c-.1,0-.1-.1-.1-.2h0l-.2-.2h-.3a.1.1,0,0,0-.1-.1H91.6a.1.1,0,0,1-.1-.1H89.8c0-.1-.1-.1-.2-.1h-2a.1.1,0,0,1-.1-.1.5.5,0,0,1-.4-.2l-.6-.3-.4-.3H86l-.3-.2-.2-.2-.3-.2h-.1l-.3-.2-.2-.2a.2.2,0,0,1-.2-.2l-.3-.2H84l-.4-.3a.3.3,0,0,0-.1-.2.8.8,0,0,1-.4-.4h-.2l-.3-.4c-.1-.1-.1-.2-.2-.2l-.6-.6h0l-.5-.7-.2-.2-.6-.8-.2-.2-.3-.3V264l-.3-.4c0-.1-.1-.1-.1-.2l-.2-.3c-.1-.1-.2-.1-.2-.2l-.2-.3c-.1-.1-.1-.2-.2-.2l-.2-.3c0-.1-.1-.1-.1-.2l-.2-.3c-.1-.1-.1-.1-.1-.2H78c-.1-.1-.2-.2-.2-.3a.1.1,0,0,0-.1-.1c-.1-.2-.2-.3-.2-.4a.1.1,0,0,1-.1-.1l-.2-.3h0c-.1-.1-.2-.2-.2-.3h-.1a.3.3,0,0,1-.1-.2h-.1l-.2-.3h0a.3.3,0,0,0-.1-.2h-.1c0-.1-.1-.1-.1-.2h0c0-.1-.1-.1-.1-.2h0c-.1-.2-.2-.3-.2-.4L65,264.3h0c.1,0,.1.1.2.2h0c.1.1.1.3.2.5h.1v.3h0c.1,0,.1.1.2.2h0c.1.1.2.2.2.3h.1a.8.8,0,0,0,.2.4h0c.1.1.1.2.2.4h.1a.5.5,0,0,0,.2.4.1.1,0,0,0,.1.1l.2.3h0a.1.1,0,0,1,.1.1.3.3,0,0,1,.1.2c.1,0,.1.1.2.2a.3.3,0,0,0,.1.2l.2.3.2.2c0,.1.1.2.2.3s.1.1.1.2l.3.3h.1l.3.4.2.2c0,.1.1.2.2.4a.1.1,0,0,1,.1.1h0c.1,0,.1,0,.1.1l.6.8h.1c0,.1,0,.1.1.1l1.1,1.3h.1a.1.1,0,0,0,.1.1l.3.4a.1.1,0,0,1,.1.1c.1,0,.1,0,.1.1l.4.3a.1.1,0,0,0,.1.1h0l.4.3a.1.1,0,0,0,.1.1h0l.3.3h.4c.1.1.2.1.2.2h.2l.2.2h.6a.1.1,0,0,1,.1.1h0l.3.2h.2l.5.3h0l.4.3h.3a.1.1,0,0,1,.1.1h.2l.2.2h.5c.1,0,.2,0,.2.1h.3c.1,0,.2,0,.2.1h2c.1,0,.2,0,.2.1h0c.1,0,.2,0,.2.1h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M62.3,261.8a10.6,10.6,0,0,1,2.7,2.5c.3.5,5.5,9.6,10.7,12.5a13.6,13.6,0,0,0,4.5,1.9,2,2,0,0,1,.8.4,5.1,5.1,0,0,1,2.3,4.4V312c0,15-18.8,12.3-21,11s-21-20-21-35V259.4c0-1.9.9-2.6,2.2-1.8a2.1,2.1,0,0,1,.8.6,23.5,23.5,0,0,0,4.5,3.2c5.2,3,10.5-.1,10.7-.2A4.3,4.3,0,0,1,62.3,261.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M69,323.6a18.7,18.7,0,0,1-6.5-1c-2.2-1.3-20.7-19.8-20.7-34.6V259.4a2,2,0,0,1,.4-1.5h.3l.7.2a2.1,2.1,0,0,1,.8.6,25.2,25.2,0,0,0,4.5,3.3,10.2,10.2,0,0,0,5.1,1.3h0a12.2,12.2,0,0,0,6.1-1.6H60a4.4,4.4,0,0,1,2,.7,6.1,6.1,0,0,1,2.5,2.3c1,1.7,6,9.9,10.9,12.7a21.5,21.5,0,0,0,4.7,2l.7.2a4.8,4.8,0,0,1,1.9,4V312c0,4.2-1.6,7.4-4.6,9.3S71.6,323.6,69,323.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M60.7,273.1a5.5,5.5,0,0,1,1.8,1.6c.2.3,3.7,6.4,7.1,8.4a25.5,25.5,0,0,0,3,1.3l.6.2a3.5,3.5,0,0,1,1.5,2.9v19c0,10-12.5,8.2-14,7.3s-14-13.3-14-23.3v-19c0-1.3.7-1.7,1.5-1.3l.6.5a19,19,0,0,0,2.9,2.1c3.5,2,7-.1,7.2-.2A2.8,2.8,0,0,1,60.7,273.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M59.5,278.8a5.3,5.3,0,0,1,1.4,1.2c.1.2,2.7,4.8,5.3,6.3a7.9,7.9,0,0,0,2.3.9l.4.2a2.5,2.5,0,0,1,1.1,2.1v14.3c0,7.4-9.4,6.1-10.5,5.5s-10.4-10-10.4-17.5V277.6c0-.9.4-1.3,1.1-.9l.4.3a10.5,10.5,0,0,0,2.2,1.6c2.6,1.5,5.2-.1,5.4-.1A1.7,1.7,0,0,1,59.5,278.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M202.6,283.6c-.7-.4-.7-1,0-1.4l12.2-7.1a3.3,3.3,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M201.9,283.6a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M201.3,283.5c-.7-.4-.7-1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2c.6.3.6.9,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M200.6,283.5a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M200,283.4a.7.7,0,0,1,0-1.3l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.7.7,0,0,1,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M199.3,283.4a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4L214,290.5a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M198.7,283.3c-.7-.3-.7-.9,0-1.3l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.6.4.6,1,0,1.3l-12.3,7.2a3,3,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M198,283.3a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M197.4,283.3c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4L212,290.4a3,3,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M196.7,283.2c-.6-.4-.6-1,0-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.3,7.2c.7.3.7.9,0,1.3l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M196.1,283.2c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M195.4,283.1a.7.7,0,0,1,0-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.3,7.2a.7.7,0,0,1,0,1.3l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M194.8,283.1c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M194.1,283c-.6-.3-.6-.9,0-1.3l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.3l-12.2,7.2a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M193.5,283c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M192.8,283a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M192.2,282.9c-.7-.4-.7-1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2c.6.3.6.9,0,1.3L206.8,290a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M191.5,282.9a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4L206.2,290a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M190.9,282.8a.7.7,0,0,1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2a.7.7,0,0,1,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M190.2,282.8a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M189.6,282.7c-.7-.3-.7-.9,0-1.3l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1c.6.4.6,1,0,1.3l-12.2,7.2a3.3,3.3,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M188.9,282.7a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M188.3,282.7c-.7-.4-.7-1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4L203,289.8a3.3,3.3,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M187.6,282.6c-.6-.4-.6-1,0-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.3,7.2c.7.3.7.9,0,1.3l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M187,282.6c-.7-.4-.7-1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M186.3,282.5a.7.7,0,0,1,0-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.3,7.2a.7.7,0,0,1,0,1.3L201,289.6a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M185.7,282.5c-.7-.4-.7-1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M185,282.4c-.6-.3-.6-.9,0-1.3l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.3l-12.2,7.2a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M184.4,282.4c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.2,7.1a2.6,2.6,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M183.7,282.4a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M183.1,282.3c-.7-.4-.7-1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0L210,281c.6.3.6.9,0,1.3l-12.2,7.1a2.6,2.6,0,0,1-2.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M182.4,282.3a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M182.4,282.3c-.6-.3-.6-.9,0-1.3h12.3a2.4,2.4,0,0,1,2.3,0h12.3c.7.4.7,1,0,1.3l-12.2,7.2a3.1,3.1,0,0,1-2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M209.8,279.5h-.5l-12.2,7.1v1.6l12.2-7.2h.5v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M182.4,280.2a1,1,0,0,1-.5-.7v1.6c0,.2.2.4.5.6l12.3,7.2v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M209.3,278.8c.7.4.7,1,0,1.4l-12.2,7.1a3.1,3.1,0,0,1-2.3,0l-12.4-7.1a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M182.4,279.6c-.6-.4-.6-1,0-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.3,7.2c.7.3.7.9,0,1.3l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M195.9,286.1a1.5,1.5,0,0,1-1-.3l-10.8-6.2c-.3-.2-.5-.4-.5-.7a.7.7,0,0,1,.5-.6l10.7-6.3,1-.2,1.1.2,10.8,6.3a.7.7,0,0,1,.5.6c0,.3-.2.5-.5.7L197,285.8A2,2,0,0,1,195.9,286.1Zm-.1-14.2a1.4,1.4,0,0,0-.9.3l-10.8,6.2a.5.5,0,0,0-.3.5.7.7,0,0,0,.4.6l10.7,6.2,1,.2,1-.2,10.7-6.2a.7.7,0,0,0,.4-.6c0-.2-.1-.3-.4-.5l-10.8-6.2A1.5,1.5,0,0,0,195.8,271.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M196.9,288.9h.3v-1.6l-.3.2h-.2a.1.1,0,0,1-.1.1h-.7a.1.1,0,0,1-.1-.1h-1.2v1.6h.3c0,.1,0,.1.1.1h1.5a.1.1,0,0,0,.1-.1h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M195.9,280.3h-.2l-2.1-1.2c-.1,0-.1-.1-.1-.2h.1l2.1-1.2a.3.3,0,0,1,.4,0l2.1,1.2h.1v.2l-2.1,1.2Zm0-2.7h-.2l-2,1.2h0l2.1,1.2h.3l2-1.2h0l-2.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M195.9,279.7h-.2l-1.2-.7c0-.1-.1-.1-.1-.2h.1l1.2-.7h.3l1.3.7h0v.2l-1.2.7Zm0-1.6h-.1l-1.2.6,1.2.7c.1.1.1.1.2,0l1.2-.7-1.2-.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M95.4,223a.8.8,0,0,1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.6,2.6,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M94.8,222.9c-.7-.3-.7-1-.1-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.4,7.2a.7.7,0,0,1,0,1.3L109.4,230a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M94.1,222.9a.8.8,0,0,1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4L108.8,230a2.6,2.6,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M93.5,222.8c-.7-.3-.7-.9-.1-1.3l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1c.6.4.6,1,0,1.3L108.1,230a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M92.8,222.8a.8.8,0,0,1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M92.2,222.8c-.7-.4-.7-1-.1-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M91.5,222.7c-.6-.4-.6-1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2c.7.3.7.9,0,1.3l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M90.9,222.7c-.7-.4-.7-1-.1-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M90.2,222.6a.7.7,0,0,1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2a.7.7,0,0,1,0,1.3l-12.2,7.1a2.6,2.6,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M89.6,222.6c-.7-.4-.7-1-.1-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M88.9,222.5c-.6-.3-.6-.9,0-1.3l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.3l-12.2,7.2a3.3,3.3,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M88.3,222.5c-.7-.4-.7-1-.1-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M87.6,222.5a.8.8,0,0,1,0-1.4L99.8,214a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a3.3,3.3,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M87,222.4c-.7-.4-.7-1-.1-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.4,7.2c.6.3.6.9,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M86.3,222.4a.8.8,0,0,1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4L101,229.5a2.6,2.6,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M85.7,222.3c-.7-.3-.7-1-.1-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.4,7.2a.7.7,0,0,1,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M85,222.3a.8.8,0,0,1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M84.4,222.2c-.7-.3-.7-.9-.1-1.3l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1c.6.4.6,1,0,1.3L99,229.4a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M83.7,222.2a.8.8,0,0,1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M83.1,222.2c-.7-.4-.7-1-.1-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M82.4,222.1c-.6-.4-.6-1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2c.7.3.7.9,0,1.3l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M81.8,222.1c-.7-.4-.7-1-.1-1.4L94,213.6a2.4,2.4,0,0,1,2.3,0l12.4,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M81.1,222a.7.7,0,0,1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2a.7.7,0,0,1,0,1.3l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M80.5,222c-.7-.4-.7-1-.1-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M79.8,221.9c-.6-.3-.6-.9,0-1.3L92,213.5a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.3l-12.2,7.2a3.3,3.3,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M79.2,221.9c-.7-.4-.7-1-.1-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1a.8.8,0,0,1,0,1.4L93.8,229a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M78.5,221.9a.8.8,0,0,1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4L93.2,229a3.3,3.3,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M77.9,221.8c-.7-.4-.7-1-.1-1.4l12.3-7.1a3.1,3.1,0,0,1,2.3,0l12.4,7.2c.6.3.6.9,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M77.2,221.8a.8.8,0,0,1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M76.6,221.7c-.7-.3-.7-1-.1-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.4,7.2a.7.7,0,0,1,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M75.9,221.7a.8.8,0,0,1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.6,2.6,0,0,1-2.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M75.3,221.6c-.7-.3-.7-.9-.1-1.3l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1c.6.4.6,1,0,1.3l-12.3,7.2a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M75.3,221.7c-.7-.4-.7-1-.1-1.3H87.5a3.1,3.1,0,0,1,2.3,0h12.4c.6.3.6.9,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M102.7,218.9h-.5l-12.3,7.1v1.6l12.3-7.1h.4v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M75.3,219.5c-.4-.2-.5-.4-.5-.7v1.6c0,.3.2.5.5.7l12.4,7.1v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.2,218.2c.6.3.6.9,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0l-12.3-7.1c-.7-.4-.7-1-.1-1.3L87.5,211a3.1,3.1,0,0,1,2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M75.3,219c-.7-.4-.7-1-.1-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.4,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M88.8,225.4a1.8,1.8,0,0,1-1.1-.2L76.9,219c-.3-.2-.5-.4-.5-.7s.2-.5.5-.7l10.7-6.2a2,2,0,0,1,1.1-.3,1.5,1.5,0,0,1,1,.3l10.8,6.2c.3.2.5.4.5.7s-.2.5-.5.7l-10.7,6.2A1.6,1.6,0,0,1,88.8,225.4Zm-.1-14.1-1,.2L77,217.8a.5.5,0,0,0,0,1L87.8,225a1.5,1.5,0,0,0,1,.3,1.4,1.4,0,0,0,.9-.3l10.8-6.2a.5.5,0,0,0,.3-.5.5.5,0,0,0-.4-.5l-10.7-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M89.7,228.3l.3-.2v-1.5h-.3a.1.1,0,0,1-.1.1H87.7l-.3-.2v1.6l.3.2h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M88.7,219.6h-.2l-2-1.2a.2.2,0,0,1-.2-.2l.2-.2,2-1.1H89l2,1.1v.2c0,.1,0,.2-.1.2l-2,1.2Zm0-2.6h-.1l-2.1,1.2h0l2.1,1.1h.3l2-1.1h0l-2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M88.7,219.1h-.1l-1.2-.6c-.1-.1-.1-.1-.1-.2h.1l1.2-.7h.3l1.2.7h.1c0,.1-.1.1-.1.2l-1.2.6Zm0-1.6h-.1l-1.2.7,1.3.7h.1l1.2-.7-1.2-.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M309,221.6a.8.8,0,0,1,0-1.4l12.3-7.1a3.1,3.1,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M308.4,221.6c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4L323,228.7a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M307.7,221.5a.7.7,0,0,1,0-1.3L320,213a3.1,3.1,0,0,1,2.3,0l12.3,7.2c.7.3.7.9,0,1.3l-12.2,7.1a2.6,2.6,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M307.1,221.5c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M306.4,221.4a.7.7,0,0,1,0-1.3l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.3l-12.2,7.2a3.3,3.3,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M305.8,221.4c-.7-.4-.7-1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M305.1,221.4a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0L332,220c.7.4.7,1,0,1.4l-12.2,7.1a3.3,3.3,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M304.5,221.3c-.7-.4-.7-1,0-1.4l12.2-7.1a3.3,3.3,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M303.8,221.3a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.5,2.5,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M303.2,221.2c-.7-.4-.7-1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2c.6.3.6.9,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M302.5,221.2a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.6,2.6,0,0,1-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M301.9,221.1a.7.7,0,0,1,0-1.3l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.6.4.6,1,0,1.3l-12.3,7.2a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M301.2,221.1a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M300.6,221.1c-.7-.4-.7-1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M299.9,221a.8.8,0,0,1,0-1.4l12.3-7.1a3.1,3.1,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M299.3,221c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M298.6,220.9c-.6-.4-.6-1,0-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.3,7.2c.7.3.7.9,0,1.3L313.3,228a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M298,220.9c-.7-.4-.7-1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4L312.6,228a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M297.3,220.8a.7.7,0,0,1,0-1.3l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.3L312,228a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M296.7,220.8c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M296,220.8a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M295.4,220.7c-.7-.4-.7-1,0-1.4l12.2-7.1a3.3,3.3,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4L310,227.8a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M294.7,220.7a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M294.1,220.6c-.7-.4-.7-1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2c.6.3.6.9,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M293.4,220.6a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M292.8,220.5a.7.7,0,0,1,0-1.3l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.6.4.6,1,0,1.3l-12.3,7.2a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M292.1,220.5a.8.8,0,0,1,0-1.4l12.3-7.1a2.4,2.4,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M291.5,220.4c-.7-.3-.7-.9,0-1.3l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1c.6.4.6,1,0,1.3l-12.3,7.2a3.1,3.1,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M290.8,220.4a.8.8,0,0,1,0-1.4l12.3-7.1a3.1,3.1,0,0,1,2.3,0l12.3,7.1c.7.4.7,1,0,1.4l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M290.2,220.4c-.7-.4-.7-1,0-1.4l12.2-7.1a2.5,2.5,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M289.5,220.3c-.6-.4-.6-1,0-1.3l12.3-7.2a3.1,3.1,0,0,1,2.3,0l12.3,7.2c.7.3.7.9,0,1.3l-12.2,7.1a2.4,2.4,0,0,1-2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M288.9,220.3c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0l12.3,7.1a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M288.9,220.3c-.7-.3-.7-.9,0-1.3h12.2a2.5,2.5,0,0,1,2.4,0h12.3c.6.4.6,1,0,1.3l-12.3,7.2a3.1,3.1,0,0,1-2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M316.3,217.5h-.5l-12.3,7.1v1.6l12.3-7.2h.5v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M288.9,218.2a.8.8,0,0,1-.5-.7v1.6a.6.6,0,0,0,.4.6l12.4,7.2v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M315.8,216.8a.8.8,0,0,1,0,1.4l-12.3,7.1a2.4,2.4,0,0,1-2.3,0l-12.3-7.1c-.7-.4-.7-1,0-1.4l12.2-7.1a2.6,2.6,0,0,1,2.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M288.9,217.6c-.7-.4-.7-1,0-1.3l12.2-7.2a3.3,3.3,0,0,1,2.4,0l12.3,7.2c.6.3.6.9,0,1.3l-12.3,7.1a2.4,2.4,0,0,1-2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M302.4,224.1a2,2,0,0,1-1.1-.3l-10.8-6.2c-.3-.2-.5-.4-.5-.7a.7.7,0,0,1,.5-.6l10.7-6.3,1.1-.2,1.1.2,10.7,6.3a.7.7,0,0,1,.5.6.8.8,0,0,1-.4.7l-10.8,6.2A1.5,1.5,0,0,1,302.4,224.1Zm-.1-14.1a1.6,1.6,0,0,0-1,.2l-10.7,6.2c-.3.2-.4.3-.4.5a.7.7,0,0,0,.4.6l10.8,6.2,1,.2.9-.2,10.8-6.2a.9.9,0,0,0,.3-.6c0-.2-.1-.3-.3-.5l-10.8-6.2A1.6,1.6,0,0,0,302.3,210Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M303.4,226.9h.3v-1.6l-.3.2H301v1.6h2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M302.3,218.3h-.2l-2-1.2c-.1,0-.1-.1-.1-.2a.1.1,0,0,1,.1-.1l2-1.2h.5l2,1.2a.1.1,0,0,1,.1.1c0,.1,0,.2-.1.2l-2,1.2Zm0-2.7h-.1l-2,1.2h0l2,1.2h.3l2-1.2h0l-2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M302.3,217.7h-.1L301,217c-.1,0-.1-.1-.1-.2a.1.1,0,0,1,.1-.1l1.2-.7h.3l1.2.7a.1.1,0,0,1,.1.1c0,.1,0,.2-.1.2l-1.2.7Zm0-1.6h0l-1.2.7,1.2.6h.1l1.2-.6-1.2-.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M320.8,224.3c-2.6-1.5-2.6-3.9,0-5.4l49.3-48.7a10,10,0,0,1,9.5,0l49.7,48.7c2.6,1.5,2.6,3.9,0,5.4L379.9,253a10.4,10.4,0,0,1-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M317.5,224.3c-2.7-1.5-2.7-3.9-.1-5.4l49.4-48.7a10.4,10.4,0,0,1,9.4,0l49.2,48.7c2.6,1.5,2.6,3.9,0,5.4,0,0-48.2,28.5-48.8,28.7a10.4,10.4,0,0,1-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M314.1,224.4c-2.6-1.6-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l48.5,48.7c2.6,1.5,2.6,4,0,5.5,0,0-47,28.2-48.1,28.6a10.3,10.3,0,0,1-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M310.8,224.4c-2.6-1.5-2.6-4-.1-5.5l49.4-48.7a10.6,10.6,0,0,1,9.5,0l47.9,48.7c2.6,1.5,2.6,4,0,5.5,0,0-45.8,28.1-47.6,28.7a10.7,10.7,0,0,1-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M307.4,224.4c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l47.4,48.7c2.6,1.5,2.6,4,0,5.5,0,0-44.7,27.9-47,28.7s-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-200"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M304.1,224.4c-2.6-1.5-2.6-4,0-5.5l49.3-48.7a10.6,10.6,0,0,1,9.5,0l46.7,48.7c2.6,1.6,2.6,4,0,5.5,0,0-43.4,27.7-46.4,28.7a11,11,0,0,1-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M300.8,224.4c-2.7-1.5-2.7-3.9-.1-5.4l49.4-48.7a10.6,10.6,0,0,1,9.5,0L405.7,219c2.6,1.5,2.6,3.9,0,5.4,0,0-42.3,27.5-45.8,28.7a11,11,0,0,1-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M297.4,224.4c-2.6-1.5-2.6-3.9,0-5.4l49.4-48.7a10.4,10.4,0,0,1,9.4,0L401.8,219c2.6,1.5,2.6,3.9,0,5.4,0,0-41.1,27.3-45.2,28.7a11.3,11.3,0,0,1-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294.1,224.5c-2.6-1.6-2.6-4-.1-5.5l49.4-48.7a10.6,10.6,0,0,1,9.5,0L397.8,219c2.6,1.5,2.6,4,0,5.5,0,0-39.9,27-44.6,28.7-2.1,1.2-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M290.7,224.5c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0L393.9,219c2.6,1.5,2.6,4,0,5.5,0,0-38.8,26.8-44,28.7-2,1.1-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M287.4,224.5c-2.6-1.5-2.6-4,0-5.5l49.3-48.7a10.6,10.6,0,0,1,9.5,0L390,219c2.6,1.5,2.6,4,0,5.5,0,0-37.6,26.7-43.5,28.7-1.9,1.1-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M284.1,224.5c-2.6-1.5-2.7-4-.1-5.5l49.4-48.7a10.6,10.6,0,0,1,9.5,0L386,219c2.6,1.6,2.6,4,0,5.5,0,0-36.4,26.5-42.8,28.7-1.9,1.1-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-213"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M280.7,224.5c-2.6-1.5-2.6-3.9,0-5.4l49.4-48.7a10.4,10.4,0,0,1,9.4,0l42.6,48.7c2.6,1.5,2.6,3.9,0,5.4,0,0-35.2,26.3-42.2,28.7-1.9,1.1-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M277.4,224.5c-2.6-1.5-2.6-3.9-.1-5.4l49.4-48.7a10.6,10.6,0,0,1,9.5,0l42,48.7c2.6,1.5,2.6,3.9,0,5.4,0,0-34.1,26.1-41.7,28.7-1.7,1.1-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-215"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M274,224.6c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l41.4,48.7c2.6,1.5,2.6,4,0,5.5,0,0-32.8,25.8-41,28.7-1.7.9-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-217"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M270.7,224.6c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l40.8,48.7c2.6,1.5,2.6,4,0,5.5,0,0-31.7,25.6-40.4,28.7-1.7.9-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-219"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M267.4,224.6c-2.6-1.5-2.7-4-.1-5.5l49.4-48.7a10.6,10.6,0,0,1,9.5,0l40.2,48.7c2.6,1.5,2.6,4,0,5.5,0,0-30.5,25.4-39.9,28.7-1.6.9-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M264,224.6c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l39.6,48.7c2.6,1.6,2.6,4,0,5.5,0,0-29.3,25.3-39.2,28.7-1.5.9-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-222"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M260.7,224.6c-2.6-1.5-2.6-3.9,0-5.4L310,170.5a10.6,10.6,0,0,1,9.5,0l39,48.7c2.6,1.5,2.6,3.9,0,5.4,0,0-28.2,25.1-38.7,28.7-1.4.9-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M257.3,224.6c-2.6-1.5-2.6-3.9,0-5.4l49.4-48.7a10.4,10.4,0,0,1,9.4,0l38.5,48.7c2.6,1.5,2.6,3.9,0,5.5,0,0-27,24.8-38.1,28.6-1.4.8-6.8,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-226"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M254,224.7c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l37.8,48.7c2.6,1.5,2.6,4,0,5.5,0,0-25.8,24.6-37.4,28.7-1.4.7-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-228"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M250.7,224.7c-2.6-1.5-2.7-4-.1-5.5L300,170.5a10.6,10.6,0,0,1,9.5,0l37.2,48.7c2.6,1.5,2.6,4,0,5.5,0,0-24.6,24.4-36.9,28.7-1.2.7-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-230"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M247.3,224.7c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l36.7,48.7c2.6,1.5,2.6,4,0,5.5,0,0-23.5,24.2-36.3,28.7-1.2.7-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M244,224.7c-2.6-1.5-2.6-4,0-5.5l49.3-48.7a10.6,10.6,0,0,1,9.5,0l36,48.7c2.6,1.6,2.6,4,0,5.5,0,0-22.2,24-35.7,28.7-1.1.7-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M240.7,224.7c-2.7-1.5-2.7-3.9-.1-5.4L290,170.6a10.4,10.4,0,0,1,9.4,0l35.5,48.7c2.6,1.5,2.6,3.9,0,5.4,0,0-21.1,23.9-35.1,28.7-1.1.7-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M237.3,224.8c-2.6-1.6-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0L331,219.3c2.6,1.5,2.6,3.9,0,5.5,0,0-19.9,23.6-34.5,28.6-1.1.6-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M234,224.8c-2.6-1.5-2.7-4-.1-5.5l49.4-48.7a10.6,10.6,0,0,1,9.5,0L327,219.3c2.6,1.5,2.6,4,0,5.5,0,0-18.7,23.4-33.9,28.7-.9.5-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-239"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M230.6,224.8c-2.6-1.5-2.6-4,0-5.5L280,170.6a10.4,10.4,0,0,1,9.4,0l33.7,48.7c2.6,1.5,2.6,4,0,5.5,0,0-17.6,23.2-33.3,28.7-.9.5-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-241"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M227.3,224.8c-2.6-1.5-2.6-4,0-5.5l49.3-48.7a10.6,10.6,0,0,1,9.5,0l33.1,48.7c2.6,1.5,2.6,4,0,5.5,0,0-16.4,23-32.8,28.7-.8.5-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M224,224.8c-2.7-1.5-2.7-4-.1-5.5l49.4-48.6a9.8,9.8,0,0,1,9.4,0l32.5,48.6c2.6,1.6,2.6,4,0,5.5,0,0-15.2,22.8-32.1,28.7-.8.5-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-243"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M220.6,224.8c-2.6-1.5-2.6-3.9,0-5.4L270,170.7a10.4,10.4,0,0,1,9.4,0l31.9,48.7c2.6,1.5,2.6,3.9,0,5.4,0,0-14,22.6-31.5,28.7-.7.4-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M217.3,224.9c-2.6-1.6-2.6-4-.1-5.5l49.4-48.7a10.6,10.6,0,0,1,9.5,0l31.3,48.7c2.6,1.5,2.6,4,0,5.5,0,0-12.9,22.3-31,28.6-.6.4-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-247"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M213.9,224.9c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l30.7,48.7c2.6,1.5,2.6,4,0,5.5,0,0-11.6,22.2-30.3,28.7-.6.3-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M210.6,224.9c-2.6-1.5-2.6-4,0-5.5l49.3-48.7a10.6,10.6,0,0,1,9.5,0l30.1,48.7c2.6,1.5,2.6,4,0,5.5,0,0-10.5,22-29.8,28.7-.5.3-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M207.3,224.9c-2.7-1.5-2.7-4-.1-5.5l49.4-48.7a10.6,10.6,0,0,1,9.5,0l29.5,48.7c2.6,1.5,2.6,4,0,5.5,0,0-9.3,21.8-29.2,28.7-.4.3-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-252"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M203.9,224.9c-2.6-1.5-2.6-4,0-5.5l49.4-48.6a9.8,9.8,0,0,1,9.4,0l28.9,48.6c2.6,1.6,2.6,4,0,5.5,0,0-8.1,21.6-28.5,28.7-.4.2-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-254"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M200.6,224.9c-2.6-1.5-2.6-3.9-.1-5.4l49.4-48.7a10.6,10.6,0,0,1,9.5,0l28.3,48.7c2.6,1.5,2.6,3.9,0,5.4,0,0-7,21.4-28,28.7-.3.2-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-256"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M197.2,225c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l27.8,48.7c2.6,1.5,2.6,4,0,5.5,0,0-5.8,21.1-27.4,28.7-.3.1-6.9,1.5-9.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-257"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M193.9,225c-2.6-1.5-2.6-4,0-5.5l49.3-48.7a10.6,10.6,0,0,1,9.5,0l27.1,48.7c2.6,1.5,2.6,4,0,5.5A42.4,42.4,0,0,1,253,253.7c-.1.1-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M190.6,225c-2.6-1.5-2.7-4-.1-5.5l49.4-48.7a10.6,10.6,0,0,1,9.5,0l26.5,48.7c2.6,1.5,2.6,4,0,5.5,0,0-3.4,20.8-26.2,28.7-.1.1-6.8,1.5-9.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M187.2,225c-2.6-1.5-2.6-4,0-5.5l49.4-48.7a10.4,10.4,0,0,1,9.4,0l25.9,48.7c2.7,1.5,2.7,4,.1,5.5,0,0-2.3,20.6-25.6,28.7-.1,0-6.9,1.5-9.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M183.9,225c-2.6-1.5-2.6-4-.1-5.5l49.4-48.6a10,10,0,0,1,9.5,0L268,219.5c2.6,1.6,2.6,4,0,5.5,0,0-1,20.4-25,28.7,0,0-6.8,1.5-9.4,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M308.2,52.8h0L222.7,3.1h-.2a.1.1,0,0,1-.1-.1l-.9-.4a.1.1,0,0,1-.1-.1h-.2l-1-.4h-.1l-1.2-.3h-4.8l-1.1.2h-1l-1.3.4h-.3l-1,.4a.1.1,0,0,1-.1.1H209l-1.1.5-.4.2-1.5.8-1.1.7-.4.2-.7.5-.4.3-.7.5-.4.3-.7.6-.4.3-.8.7-.3.2-1,.9-.2.2-.7.7h-.1l-2.4,2.5h-.2l-1.7,2.1h0l-.2.2-1.3,1.8h-.1a.1.1,0,0,1-.1.1l-1.2,1.8v.4l-.9,1.5-.2.2h0a16.2,16.2,0,0,0-1,1.8h-.1c0,.1-.1.2-.1.3a9.1,9.1,0,0,0-.7,1.4l-.2.3c0,.1,0,.1-.1.2l-.8,1.8h0a.4.4,0,0,0-.1.3c-.2.5-.5,1-.7,1.6s-.1.2-.1.3v.2l-.7,1.9h0l-.6,2a.4.4,0,0,0-.1.3.3.3,0,0,0-.1.2c0,.2-.1.4-.1.6a1.9,1.9,0,0,0-.2.8c-.1.2-.1.4-.2.6a.6.6,0,0,1-.1.4v.3c-.1.3-.1.6-.2.9s-.1.5-.1.7-.1.6-.2.9v.5h0a13.6,13.6,0,0,0-.2,2c0,.1-.1.3-.1.4V54.4l.3,108.5a12.8,12.8,0,0,1-.1,1.9v.3c0,.6-.1,1.2-.1,1.8a.7.7,0,0,0-.1.5c0,.1-.1.3-.1.4l-14.9-8.7h-.2l-.7-.3h-.2l-.8-.3h0l-.8-.2h-4.3c0,.1-.1.1-.2.1H160l-.9.3h-.3l-.7.3h-.3l-.8.4h-.3l-1,.6-1.6,1-.5.3-1,.8-.6.5-.9.7-.6.6-.4.4-.6.6-.2.2-1.1,1.2h-.1l-.6.8-.6.7c0,.1-.1.1-.1.2l-.5.6-.5.7-.3.4a2.1,2.1,0,0,1-.4.6l-.3.5-.4.7-.3.5-.2.2-.7,1.4h-.1v.3l-.6,1.1-.2.4-.2.5-.3.5-.3.9-.2.5v.2l-.6,1.6h0c0,.1-.1.2-.1.3s-.3.9-.4,1.4h0v.2c-.1.3-.1.6-.2.9a2.9,2.9,0,0,0-.2.9v.6a11.3,11.3,0,0,0-.3,1.8h0a15,15,0,0,0-.2,2v1a17.3,17.3,0,0,0,.6,4.7c1,4.4,3.1,7.6,6.3,9.4l85.5,49.7c4.5,2.5,10.4,2,16.6-1.7s12.2-9.8,16.6-17.4,6.8-15.8,6.8-23v-9.3l-.3-108.5c0-13,9.1-28.8,20.4-35.6l21.5,12.5h-.1a.9.9,0,0,0,1,0,3,3,0,0,0,1.4-2.4C315.1,60.4,312.4,55.2,308.2,52.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M306.9,51.3h0L221.4,1.6h-.3l-.9-.5h-.3l-1-.4h-.1L217.7.2h-4.9l-1,.2h-.4l-.7.2h0l-1.3.4h-.2l-1.1.3a.1.1,0,0,1-.1.1h-.3l-1.1.5-.4.2-1.5.8-1.1.7a.5.5,0,0,1-.4.2l-.7.5-.4.3-.7.5-.4.3-.7.6-.4.3-.8.7-.3.2-1,.9-.2.2a4.6,4.6,0,0,0-.7.7h-.1a27.3,27.3,0,0,0-2.3,2.5h-.3l-1.7,2.2h0l-.2.2L191,16.3h-.1c0,.1,0,.1-.1.1l-1.2,1.8v.4l-.9,1.5c-.1.1-.1.2-.2.2h0a16.2,16.2,0,0,0-1,1.8h-.1c0,.1-.1.2-.1.3l-.7,1.4-.2.3c0,.1,0,.1-.1.2l-.8,1.8h0c-.1,0-.1.1-.1.2l-.7,1.6a.4.4,0,0,1-.1.3v.2a14.6,14.6,0,0,1-.7,1.9h0l-.6,2a.4.4,0,0,0-.1.3v.2c0,.2-.1.4-.1.6a2.4,2.4,0,0,0-.2.8c-.1.2-.1.4-.2.6a.6.6,0,0,1-.1.4v.4c-.1.3-.1.6-.2.9s-.1.4-.1.6-.1.6-.2.9v.5h0a13.6,13.6,0,0,0-.2,2,.6.6,0,0,1-.1.4V52.9l.3,108.6v2.1c0,.6-.1,1.2-.1,1.8a.9.9,0,0,0-.1.5.6.6,0,0,1-.1.4l-14.9-8.7h-.2l-.6-.3h-.3l-.8-.3h0l-.8-.2h-3.5l-.8.2h-.7l-.9.3h-.2l-.8.3h-.3l-.7.4h-.4l-1,.6-1.6,1-.5.3-1,.8-.6.5-.9.7-.6.6-.4.4-.5.6-.3.2-1,1.2-.2.2-.6.7-.6.7c0,.1-.1.1-.1.2l-.5.6-.5.7-.3.4a2.1,2.1,0,0,1-.4.6l-.3.5-.4.7-.3.5v.2a10,10,0,0,0-.8,1.4h-.1v.3l-.6,1.1-.2.4c0,.2-.1.3-.2.5a1.4,1.4,0,0,0-.2.6,2,2,0,0,0-.4.8l-.2.5v.2l-.6,1.6h0a.4.4,0,0,1-.1.3c-.1.5-.3.9-.4,1.4h0v.2a4.4,4.4,0,0,1-.2,1c-.1.2-.1.5-.2.8a.4.4,0,0,1-.1.3v.3l-.3,1.8h0a15,15,0,0,0-.2,2v1a16.8,16.8,0,0,0,.6,4.7c1,4.4,3.1,7.6,6.3,9.4l85.6,49.7c4.4,2.6,10.3,2,16.5-1.6s12.2-9.9,16.6-17.5,6.8-15.8,6.8-23v-9.2l-.4-108.6c0-13,9.1-28.8,20.4-35.6l21.5,12.6h-.1a.9.9,0,0,0,1,0,3,3,0,0,0,1.4-2.4C313.8,58.9,311.1,53.7,306.9,51.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M267.4,216.4c0-.3.1-.6.1-.8s0-.3.1-.4h0c0-.6.1-1.2.1-1.8s.1-.2.1-.3v-1.8l-85.6-49.8a10.8,10.8,0,0,1,0,1.8v.4c-.1.6-.1,1.2-.2,1.8a.6.6,0,0,1-.1.4c0,.3-.1.6-.1.9a4.3,4.3,0,0,1-.1.5,2.9,2.9,0,0,1-.2.9,1.1,1.1,0,0,1-.1.5,19.4,19.4,0,0,1-.5,2,.6.6,0,0,1-.1.4,12.1,12.1,0,0,1-.5,1.8v.2a7.5,7.5,0,0,0-.5,1.6.5.5,0,0,0-.2.4,11.1,11.1,0,0,1-.7,1.6h0c-.2.6-.5,1.1-.7,1.6s-.2.3-.2.5a7.5,7.5,0,0,1-.7,1.2.5.5,0,0,1-.2.4,10.9,10.9,0,0,1-.8,1.5l-.2.4-.8,1.3-.3.4a9.1,9.1,0,0,1-1.1,1.6v.2l-1.1,1.5-.2.3-1.5,1.8-.3.3-.7.8-.3.3-1,1.1h-.1l-1.5,1.4-.2.2-1.5,1.3-.3.2-1.5,1.1-.3.2-1.6,1-1.6.8-.5.3-1.1.5H158l-1.1.4h-.4l-1.4.4h-.2l-1.3.2h-3.1l-1.2-.2,85.5,49.7,1,.2h4.9l1.1-.3h.3l.4-.2,1.1-.4h.6l.8-.4.6-.2,1.6-.9,1.6-1c.1-.1.2-.1.2-.2a9.1,9.1,0,0,0,1.6-1.1l.3-.2,1.5-1.2.2-.2,1.5-1.5h0l1.1-1.1.3-.3.7-.8h.2V239l1.4-1.8h.2l1.2-1.6h.1l1.1-1.5v-.2c0-.1.1-.2.1-.3a5.7,5.7,0,0,0,.8-1.3c.1,0,.1-.1.2-.2v-.2c.3-.5.5-1,.8-1.4v-.4l.6-1.3c.1-.1.1-.2.2-.2s0-.2.1-.2l1.4-3.3v-.4l.6-1.5v-.2h0a12.7,12.7,0,0,0,.6-1.8v-.4a14.6,14.6,0,0,0,.5-2v-.2a.4.4,0,0,0,.1-.3c.1-.3.1-.6.2-.8A1.3,1.3,0,0,1,267.4,216.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M254.5,222.4a1.5,1.5,0,0,0,.1-.7v-.5a7.6,7.6,0,0,0,.1-1.5c0-4.5-1.6-7.6-4.1-9.1L165,160.9c2.5,1.5,4.1,4.6,4.1,9.1v1.5c0,.2-.1.3-.1.5a3.1,3.1,0,0,1-.1,1c-.1.4-.1.8-.2,1.2s-.1.5-.1.7a2.4,2.4,0,0,0-.2.8l-.3,1a1.4,1.4,0,0,1-.2.6l-.3,1.1a.8.8,0,0,0-.2.5l-.6,1.5v.2a9.1,9.1,0,0,1-.7,1.4l-.2.4-.7,1.3v.2l-.9,1.5-.3.4a6.1,6.1,0,0,1-.7,1l-.4.5-.6.8-.6.7-.5.6-1,1-.6.6-.4.5a2.7,2.7,0,0,0-.8.7,1,1,0,0,0-.5.4l-.9.6-.4.4-1.4.8-.9.5h-.2l-.7.3h-.3l-.6.3h-.1l-.8.3h-.1l-1.2.2h-2.9l-.7-.2h0l-.7-.2h-.2l-.5-.2h-.2l85.6,49.7h.2l.5.3h.2l.6.3h3.7l1.2-.3h.1l.7-.3h.2l.6-.2h.2l.7-.4h.3l.9-.5,1.3-.8.5-.3.9-.7.4-.4.8-.7.5-.4.3-.3.3-.3.9-1,.3-.4.3-.3.5-.6.4-.5.3-.4.4-.5a.5.5,0,0,0,.2-.4l.5-.6.3-.4v-.2l.7-1.2h0l.2-.2.5-.9.2-.4.2-.4c.1-.1.1-.3.2-.4a10.4,10.4,0,0,0,.4-1c.1,0,.1-.1.1-.2h0l.6-1.3v-.2c.1-.2.2-.3.2-.5a1.4,1.4,0,0,0,.2-.6c.1-.2.1-.4.2-.5s.1-.4.2-.6V226c0-.2.1-.4.1-.6a2.5,2.5,0,0,0,.2-.7v-.3c.1-.4.1-.8.2-1.2V223A1.3,1.3,0,0,0,254.5,222.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M255.1,220.5v-.4c0-.1.1-.2.1-.4a2.8,2.8,0,0,1,.1-.9c.1-2.8-.8-4.8-2.4-5.8l-52.1-33.1c1.5.9,2.5,2.9,2.4,5.7a3.4,3.4,0,0,0-.1,1v.3a1.3,1.3,0,0,1-.1.6c0,.3-.1.5-.1.7a.9.9,0,0,0-.1.5l-.2.5a1.4,1.4,0,0,1-.2.6.4.4,0,0,1-.1.3,2.5,2.5,0,0,0-.2.7l-.2.3a4.2,4.2,0,0,1-.4,1h-.1l-.4.8c0,.1-.1.2-.1.3l-.5.8h-.1l-.6.9a.2.2,0,0,1-.2.2,4.3,4.3,0,0,1-.4.7l-.3.3-.4.5-.4.4-.3.4-.6.6-.4.3-.3.3-.6.4-.3.2a1,1,0,0,1-.5.4l-.3.2-.9.5-.5.3h-5.3l-.4-.2h-.1L239.5,234h.1l.4.2h.1l.4.2h4c0-.1,0-.1.1-.1h.1l.4-.2h.2l.5-.2.9-.5.3-.2.5-.4.3-.2.6-.5.3-.2.2-.2.2-.2.6-.6.2-.2v-.2l.4-.4a.2.2,0,0,0,.2-.2l.2-.3.3-.3.2-.2.2-.4.2-.2a.1.1,0,0,1,.1-.1l.5-.8h0c0-.1.1-.1.1-.2l.3-.5.2-.3a.3.3,0,0,0,.1-.2V226l.3-.7c.1,0,.1,0,.1-.1h0l.4-.8h0l.2-.3v-.4a.4.4,0,0,0,.1-.3c.1-.1.1-.2.1-.4s.1-.1.1-.2a.6.6,0,0,0,.1-.4c.1-.1.1-.3.2-.4v-.2c.1-.2.1-.5.2-.7v-.2C255,220.7,255.1,220.6,255.1,220.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M253.7,218.4a.9.9,0,0,1,.1-.5v-.3c0-.3.1-.6.1-.9.1-2.8-.8-4.8-2.4-5.8l-52.1-33.2c1.6,1,2.5,3,2.4,5.8,0,.3-.1.6-.1,1a.4.4,0,0,1-.1.3,1.3,1.3,0,0,1-.1.6,1.7,1.7,0,0,1-.1.7c0,.2-.1.3-.1.5a.6.6,0,0,0-.1.4,1.4,1.4,0,0,0-.2.7l-.2.3a1.9,1.9,0,0,1-.2.7.4.4,0,0,0-.1.3l-.5,1h0l-.5.8v.3l-.5.7v.2l-.6.9v.2l-.5.6-.3.4-.4.5-.3.4-.4.3-.6.6-.4.4-.3.3a1,1,0,0,0-.5.4l-.3.2-.6.4-.3.2-.8.5-.6.3h-.2l-.4.2h-.7l-.4.2H187l-.4-.2h-.1l-.3-.2H186l52.2,33.2h.5l.4.2h2.3l.7-.2h.6l.4-.2h.2l.4-.2h.2l.6-.3.8-.5h.3l.6-.4.3-.3.5-.4.3-.2.2-.2.2-.2.6-.6.2-.2.2-.2.3-.4.2-.2.2-.3.3-.3.2-.2.3-.4v-.3h.1l.5-.7h0v-.2l.3-.5.2-.3a.3.3,0,0,1,.1-.2l.2-.3.3-.6h0a3,3,0,0,0,.4-.8.1.1,0,0,1,.1-.1.4.4,0,0,1,.1-.3c0-.2.1-.3.1-.4a.4.4,0,0,0,.1-.3l.2-.4v-.2c.1-.1.1-.3.2-.4a.9.9,0,0,1,.1-.5h0a6.4,6.4,0,0,1,.2-.7v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M224.3,242.3a16.8,16.8,0,0,1-.6-4.7v-1l-85.6-49.7v1a17.3,17.3,0,0,0,.6,4.7c1,4.3,3.2,7.6,6.3,9.4l85.6,49.7C227.4,249.9,225.3,246.7,224.3,242.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M224.2,232.8v-.4l.3-1.1a4.4,4.4,0,0,0,.2-1c.2-.6.3-1.1.5-1.6a.4.4,0,0,0,.1-.3c.2-.7.5-1.3.7-1.9l.2-.5.6-1.4c.1-.2.2-.3.2-.5l.8-1.5v-.3l1-1.7.3-.5.7-1.2.4-.6.8-1.1.5-.6.7-.9.6-.7,1.2-1.4.3-.2.9-1,.6-.6.9-.7.6-.5,1-.8.5-.3,1.6-1,1.1-.6h.3l.7-.4h.3l.8-.3h.2l.9-.3h.7l.8-.2h3.5l.8.2h0l.8.3h.3l.6.3h.2l-85.6-49.7h-.2l-.6-.3h-.2l-.8-.3h0l-.9-.2h-5l-.9.3h-.2l-.7.2h-.3l-.8.3-.3.2-1.1.6-1.5.9-.6.4-1,.8a1.2,1.2,0,0,0-.5.5l-.9.7-.6.6-.5.4-.5.5-.3.3-1,1.1-.2.2-.6.8a1.8,1.8,0,0,0-.5.7.2.2,0,0,0-.2.2l-.5.6-.5.7c-.1.1-.1.3-.2.4l-.4.6-.3.4-.5.8-.3.5v.2a6.4,6.4,0,0,0-.8,1.4h0l-.2.3-.5,1c-.1.2-.2.3-.2.5l-.3.5c-.1.2-.1.4-.2.5a3.6,3.6,0,0,1-.4.9l-.2.5v.2a4.4,4.4,0,0,0-.6,1.6h0a.6.6,0,0,0-.1.4c-.2.4-.3.9-.5,1.4h0v.2l-.3.9a2.9,2.9,0,0,1-.2.9v.3a.4.4,0,0,0-.1.3l-.3,1.8h0a15,15,0,0,0-.2,2l85.6,49.7a15,15,0,0,1,.2-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M311.6,67.9c0-6.6-2.3-11.2-6-13.3L220,4.9c3.7,2.1,6,6.7,6.1,13.2q0,.8.3.9L312,68.7A.9.9,0,0,1,311.6,67.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "267.5 102.6 267.5 93.4 181.9 43.6 181.9 52.9 182.2 161.4 267.8 211.2 267.5 102.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M290.8,52.9c12.9-7.4,23.5-1.4,23.5,13.4a2.9,2.9,0,0,1-1.3,2.3c-.8.5-1.4.1-1.4-.7,0-13.2-9.3-18.5-20.8-11.9s-20.7,22.7-20.6,35.8l.3,108.5v9.3c0,7.2-2.4,15.3-6.8,23s-10.3,13.8-16.5,17.4-12.2,4.2-16.6,1.7-5.3-5-6.3-9.4a16.8,16.8,0,0,1-.6-4.7v-1c.6-10.8,7.9-23,16.8-28.1s16.9-1.1,16.9,9.6-7.5,23.8-16.8,29.1a16.7,16.7,0,0,1-5.8,2.2c3.6,1,7.9.1,12.4-2.5s10.7-8.6,14.6-15.4,6-14,6-20.3l-.3-108.6V93.4C267.4,78.5,277.9,60.4,290.8,52.9ZM226.9,240.1c1.7,5.9,7.2,7.8,13.7,4s14.1-15.4,14.1-24.4-6.4-12.6-14.2-8.1-13.9,15.1-14.1,24a21.4,21.4,0,0,0,.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M267.8,88.9v-.6c.1-.3.1-.6.2-.9s.1-.4.1-.6.1-.6.2-1,.1-.4.1-.7.1-.4.2-.6a1.9,1.9,0,0,1,.2-.8c0-.2.1-.4.1-.6l.2-.5.6-2v-.2a14.6,14.6,0,0,0,.7-1.9c.1-.2.2-.3.2-.5l.7-1.6c0-.1.1-.2.1-.3l.8-1.8.3-.5c.2-.4.4-.9.7-1.4s.1-.3.2-.4a16.2,16.2,0,0,1,1-1.8c0-.1.1-.2.2-.3l.9-1.5a.8.8,0,0,0,.2-.4l1.2-1.8.2-.2,1.3-1.8.2-.2,1.7-2.2.3-.2a27.3,27.3,0,0,1,2.3-2.5l.8-.8.2-.2,1-.9.3-.2.8-.7.4-.3.7-.6.4-.3.7-.5.4-.3.7-.5.4-.2,1.1-.7,1.5-.8.4-.2,1.1-.5a.5.5,0,0,0,.4-.2l1-.3h.3l1.3-.4.7-.2h.3l1.1-.2h4.9l1.1.3h.1l1,.4h.3l.9.5h.3L221.9,1.6h-.3l-.8-.4h-.3L219.4.5h0L218.2.2h-.3L216.8,0h-3.5l-1,.2h-1.1l-1.3.4c0,.1-.1.1-.2.1l-1,.4h-.4l-1.1.5-.5.2-1.4.8-1.2.7-.3.2-.8.5-.4.3-.7.5-.4.3-.7.6-.4.3-.8.6-.2.3-1.1.9-.2.2-.6.6-.2.2L195,11.9h-.2L193,14.2h0c-.1,0-.1.1-.1.2s-.9,1.1-1.4,1.7,0,.2-.1.2h0l-1.2,1.8h-.1l-.2.3-.9,1.5c0,.1-.1.1-.1.2a.1.1,0,0,0-.1.1,9.5,9.5,0,0,1-1,1.7v.2l-.2.3c-.2.5-.5.9-.7,1.4l-.2.3v.2l-.9,1.8h0c0,.1,0,.2-.1.2l-.6,1.7c-.1.1-.1.1-.1.2a.4.4,0,0,0-.1.3,14.6,14.6,0,0,0-.7,1.9h0v.2l-.6,2c0,.1,0,.2-.1.2v.3c-.1.2-.1.4-.2.6s-.1.5-.2.8-.1.4-.1.6a.6.6,0,0,0-.1.4.4.4,0,0,0-.1.3c-.1.3-.1.6-.2.9a1.7,1.7,0,0,1-.1.7c0,.3-.1.6-.1.9s-.1.3-.1.5h0c-.1.6-.1,1.3-.2,2v.4a14.1,14.1,0,0,0-.1,2l85.6,49.8V91.3a.6.6,0,0,0,.1-.4A13.6,13.6,0,0,1,267.8,88.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M249,131.3l-53.6-31a.5.5,0,0,0-.8.5,2,2,0,0,0,.8,1.4L249,133.1c.5.3.8.1.8-.5a1.4,1.4,0,0,0-.8-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M249,140l-53.6-31a.5.5,0,0,0-.8.5,2,2,0,0,0,.8,1.4L249,141.8a.5.5,0,0,0,.8-.4,1.8,1.8,0,0,0-.8-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M249,148.7l-53.6-30.9c-.5-.3-.8-.1-.8.4a1.6,1.6,0,0,0,.8,1.4l53.6,31a.5.5,0,0,0,.8-.5,2,2,0,0,0-.8-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M249,157.4l-53.6-30.9c-.5-.3-.8,0-.8.5a1.7,1.7,0,0,0,.8,1.4L249,159.3c.4.3.8,0,.8-.5a2,2,0,0,0-.8-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M248.9,166.2l-53.6-31a.5.5,0,0,0-.8.5,2,2,0,0,0,.8,1.4L248.9,168c.5.3.8.1.8-.4a1.6,1.6,0,0,0-.8-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M240.9,170.3,195.3,144a.5.5,0,0,0-.8.4,1.8,1.8,0,0,0,.8,1.4l45.6,26.3a.5.5,0,0,0,.8-.4,1.6,1.6,0,0,0-.8-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M232.9,174.4l-37.6-21.7c-.5-.3-.8-.1-.8.5a1.7,1.7,0,0,0,.8,1.4l37.6,21.7a.5.5,0,0,0,.8-.5,2,2,0,0,0-.8-1.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M124.5,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L78.9,137.5a5.2,5.2,0,0,0-2.3-.6,5.7,5.7,0,0,0-2.4.6L55.8,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.3l.2.2h.2c.1,0,.1,0,.1.1l.2-.3v.3h.1l44.5,25.9.4.2h3.8l.5-.2h.1l18.3-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M124.2,166.3v-1.4h0a1.9,1.9,0,0,0-1-1.5L78.7,137.5a5.1,5.1,0,0,0-4.8,0L55.5,148.1a1.8,1.8,0,0,0-1,1.6h0v1.7h0v.2h.3l.2.2h.4v0h.1L100,178.7l.5.2h3.7l.5-.2h.2l18.2-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M123.9,166.3v-1.4h0a1.7,1.7,0,0,0-1-1.5L78.4,137.5a5.7,5.7,0,0,0-2.4-.6,5.2,5.2,0,0,0-2.3.6L55.2,148.1a2,2,0,0,0-1,1.6h0v1.7h0v.2h.4v.2H55a.1.1,0,0,1,.1.1l.2-.3-.2.3h.1l44.5,25.9.5.2h2.4c0-.1,0-.1.1-.1H104l.5-.2h.1l18.3-10.5a1.8,1.8,0,0,0,1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M123.7,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L78.1,137.5a5.7,5.7,0,0,0-2.4-.6,5.6,5.6,0,0,0-2.3.6L55,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.4v.2h.3a.1.1,0,0,1,.1.1l.2-.3v.3h0l44.5,25.9.5.2h2.4a.1.1,0,0,1,.1-.1h1.3l.5-.2h.1l18.3-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M123.4,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L77.8,137.5a5.2,5.2,0,0,0-2.3-.6,5.7,5.7,0,0,0-2.4.6L54.7,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2H54l.2.2h.2c.1,0,.1,0,.1.1l.2-.3v.3h.1l44.5,25.9.4.2H102a.1.1,0,0,1,.1-.1h1.3l.5-.2h.1l18.3-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M123.1,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L77.6,137.5a5.1,5.1,0,0,0-4.8,0L54.4,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.3l.2.2h.4v0h.1l44.5,25.9.5.2h3.7l.5-.2h.2L122,168.1a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M122.8,166.3v-1.4h0a1.9,1.9,0,0,0-1-1.5L77.3,137.5a5.1,5.1,0,0,0-4.8,0L54.1,148.1a1.8,1.8,0,0,0-1,1.6h0v1.7h0v.2h.4v.2H54l.2-.3-.2.3h.1l44.5,25.9.5.2h3.8l.4-.2h.2l18.3-10.5a1.8,1.8,0,0,0,1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M122.5,166.3v-1.4h0a1.7,1.7,0,0,0-1-1.5L77,137.5a5.7,5.7,0,0,0-2.4-.6,5.6,5.6,0,0,0-2.3.6L53.9,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.4v.2h.3a.1.1,0,0,1,.1.1l.2-.3-.2.3h.1l44.5,25.9.5.2h2.4a.1.1,0,0,1,.1-.1h1.3l.5-.2h.1l18.3-10.5a1.6,1.6,0,0,0,1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M122.3,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L76.7,137.5a5.2,5.2,0,0,0-2.3-.6,5.7,5.7,0,0,0-2.4.6L53.6,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.4l.2.2h.2c.1,0,.1,0,.1.1l.2-.3v.3h0l44.6,25.9.4.2h2.4a.1.1,0,0,1,.1-.1h1.3l.5-.2h.1l18.3-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M122,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L76.5,137.5a5.1,5.1,0,0,0-4.8,0L53.3,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h.1v.2h.3l.2.2h.4v0h.1l44.5,25.9.5.2H102l.5-.2h.2l18.2-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M121.7,166.3v-1.4h0a1.9,1.9,0,0,0-1-1.5L76.2,137.5a5.1,5.1,0,0,0-4.8,0L53,148.1a1.8,1.8,0,0,0-1,1.6h0v1.7h0v.2h.3l.2.2h.4v0H53l44.5,25.9.5.2h3.8l.4-.2h.2l18.3-10.5a2,2,0,0,0,1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M121.4,166.3v-1.4h0a1.7,1.7,0,0,0-1-1.5L75.9,137.5a5.7,5.7,0,0,0-2.4-.6,5.2,5.2,0,0,0-2.3.6L52.8,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h0a.1.1,0,0,1,.1.1h.3v.2h.3a.1.1,0,0,1,.1.1l.2-.3-.2.3h.1l44.5,25.9.5.2h2.4a.1.1,0,0,1,.1-.1h1.3l.5-.2h.1l18.3-10.5a1.8,1.8,0,0,0,1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M121.2,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L75.6,137.5a5.6,5.6,0,0,0-2.3-.6,5.7,5.7,0,0,0-2.4.6L52.5,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.4l.2.2h.2c.1,0,.1,0,.1.1l.2-.3v.3h0L97,178.7l.4.2h2.4a.1.1,0,0,1,.1-.1h1.3l.5-.2h.1l18.3-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M120.9,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L75.3,137.5a5.2,5.2,0,0,0-2.3-.6,5.7,5.7,0,0,0-2.4.6L52.2,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.3l.2.2h.4v0h.1l44.5,25.9.4.2h3.8l.5-.2h.2l18.2-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M120.6,166.3v-1.4h0a1.9,1.9,0,0,0-1-1.5L75.1,137.5a5.1,5.1,0,0,0-4.8,0L51.9,148.1a1.8,1.8,0,0,0-1,1.6h0v1.7h0v.2h.3l.2.2h.4v0h.1l44.5,25.9.5.2h3.7l.5-.2h.2l18.2-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M120.3,166.3v-1.4h0a1.7,1.7,0,0,0-1-1.5L74.8,137.5a5.7,5.7,0,0,0-2.4-.6,5.2,5.2,0,0,0-2.3.6L51.6,148.1a2,2,0,0,0-1,1.6h0v1.7h0v.2h0a.1.1,0,0,1,.1.1H51v.2h.3a.1.1,0,0,1,.1.1l.2-.3-.2.3h.1l44.5,25.9.5.2H99c0-.1,0-.1.1-.1h1.3l.5-.2h.1l18.3-10.5a1.8,1.8,0,0,0,1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M120.1,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L74.5,137.5a5.7,5.7,0,0,0-2.4-.6,5.6,5.6,0,0,0-2.3.6L51.4,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.4v.2h.3a.1.1,0,0,1,.1.1l.2-.3v.3h0l44.5,25.9.5.2h2.4a.1.1,0,0,1,.1-.1h1.3l.5-.2h.1L119,168.1a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M119.8,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L74.2,137.5a5.2,5.2,0,0,0-2.3-.6,5.7,5.7,0,0,0-2.4.6L51.1,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.3l.2.2h.2c.1,0,.1,0,.1.1l.2-.3v.3h.1l44.5,25.9.4.2h2.4a.1.1,0,0,1,.1-.1h1.3l.5-.2h.1l18.3-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M119.5,166.3v-1.4h0a1.9,1.9,0,0,0-1-1.5L74,137.5a5.1,5.1,0,0,0-4.8,0L50.8,148.1a1.8,1.8,0,0,0-1,1.6h0v1.7h0v.2h.3l.2.2h.4v0h.1l44.5,25.9.5.2h3.7l.5-.2h.2l18.2-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M119.2,166.3v-1.4h0a1.7,1.7,0,0,0-1-1.5L73.7,137.5a5.7,5.7,0,0,0-2.4-.6,5.2,5.2,0,0,0-2.3.6L50.5,148.1a2,2,0,0,0-1,1.6h0v1.7h0v.2h.4v.2h.3a.1.1,0,0,1,.1.1l.2-.3-.2.3h.1L95,178.7l.5.2h2.4c0-.1,0-.1.1-.1h1.3l.5-.2h.1l18.3-10.5a1.8,1.8,0,0,0,1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M119,166.3c0-.5-.1-.9-.1-1.4h0a1.7,1.7,0,0,0-1-1.5L73.4,137.5a5.7,5.7,0,0,0-2.4-.6,5.6,5.6,0,0,0-2.3.6L50.3,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h0a.1.1,0,0,1,.1.1h.3v.2H50a.1.1,0,0,1,.1.1l.2-.3v.3h0l44.5,25.9.5.2h2.4a.1.1,0,0,1,.1-.1H99l.5-.2h.1l18.3-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M118.7,166.3v-1.4h0a1.8,1.8,0,0,0-1.1-1.5L73.1,137.5a5.2,5.2,0,0,0-2.3-.6,5.7,5.7,0,0,0-2.4.6L50,148.1a1.9,1.9,0,0,0-1.1,1.6h0v1.7h0v.2h.4l.2.2h.2c.1,0,.1,0,.1.1l.2-.3v.3H50l44.5,25.9.4.2h2.4a.1.1,0,0,1,.1-.1h1.3l.5-.2h.1l18.3-10.5a1.9,1.9,0,0,0,1.1-1.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M117.5,166.4a1.5,1.5,0,0,0,.9-1.3v1.7c0,.5-.3.9-.9,1.3L99.1,178.7v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M49.2,150h0a.1.1,0,0,0,.1.1h.1v.2h0c0,.1.1.1.1.2h.5l44.5,25.9.4.2h3.1l.4-.2h.1l.5-.2v1.6l-.5.2H95l-.4-.2L50.1,152.9h-.6a.1.1,0,0,1-.1-.1h-.2v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M96.7,178.7H94.9l-.4-.2L50,152.3c-.1,0-.1,0-.1-.1h-.7v-.2h-.1v-.2h-.1v-1.7h1.3L94.7,176l.4.2h3.4l.4-.3.4-.2v2.3h-.1l-.5.2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M96.8,177.1a4.1,4.1,0,0,1-2.3-.6L50,150.7a1.9,1.9,0,0,1-1.1-1.6,1.8,1.8,0,0,1,1.1-1.5L68.4,137a4.5,4.5,0,0,1,2.4-.6,4.1,4.1,0,0,1,2.3.6l44.5,25.8a1.6,1.6,0,0,1,0,3.1L99.2,176.5A4.5,4.5,0,0,1,96.8,177.1ZM71.9,138.5l-1,.2L52.5,149.4c-.2.1-.4.2-.4.4l.4.4,42.3,24.6.9.2,1-.2,18.4-10.7c.2-.1.4-.2.4-.4l-.4-.4L72.8,138.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M68.5,137.2a5.1,5.1,0,0,1,4.5,0l44.5,25.9c1.2.7,1.2,1.8,0,2.6L99.1,176.3a5.1,5.1,0,0,1-4.5,0L50.1,150.4c-1.2-.7-1.2-1.8,0-2.6ZM94.6,175a2.4,2.4,0,0,0,2.3,0l18.4-10.6c.6-.4.6-1,0-1.3L73,138.5a2.4,2.4,0,0,0-2.3,0L52.3,149.1c-.6.4-.6,1,0,1.3L94.6,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M52.3,149.1c-.6.4-.6,1,0,1.3L94.6,175a2.4,2.4,0,0,0,2.3,0l18.4-10.6c.6-.4.6-1,0-1.3L73,138.5a2.4,2.4,0,0,0-2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M72.8,162.3l-9.3-5.4,5.1-17.2,2.1-1.2a2.4,2.4,0,0,1,2.3,0l5.9,3.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "76.7 164.6 74.5 163.3 80.6 142.9 82.8 144.2 76.7 164.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M98.8,176.1l18.5-10.7a1.4,1.4,0,0,0,.8-1h.6V166a1.8,1.8,0,0,1-1.1,1.5L99.2,178.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M63.8,141.2h-.5L58.5,144a.2.2,0,0,0,0,.3H59l4.8-2.8c.2,0,.2-.2,0-.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M117.5,165.7a1.7,1.7,0,0,0,.9-1.3V166c0,.5-.3.9-.9,1.3L99.1,177.9v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M49.2,149.2h.1a.1.1,0,0,1,.1.1h.1v.2h.2a.1.1,0,0,0,.1.1h.2l44.5,25.9.4.2h3.1l.4-.2h.1l.5-.2v1.6l-.5.2H95l-.4-.2L50.1,152.1h-.4c0-.1,0-.1-.1-.1h-.4v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M321,127.5,289.2,146c-.5.3-.7.6-.7,1h0v2.1a1.3,1.3,0,0,0,.7,1l47.4,27.4h3.6L371.9,159v-2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M359.9,127.5l-20.8,12.1-10.2,5.9a2.8,2.8,0,0,0-1.7,2.7c.1,1.6,1.2,2.1,2.5,2.8,13.7,8,43.1,26.5,45.8,26.5s3.1.2,4.6-.6l10.2-5.9,20.5-12c.3-.1.1-1.7,0-2s-1.5-.9-1.9-1.1l-2.8-1.7-10.2-5.9-20.7-11.9-15.3-8.9C349.8,133.4,360.3,127.8,359.9,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M358,127.5l-20.7,12.1-10.2,5.9-.6.4a2.3,2.3,0,0,0-1,1.2,3.1,3.1,0,0,0-.1,1c0,1.6,1.1,2.1,2.4,2.9l3.5,2,19.3,11.6c10.8,6.6,20.9,12.5,22.7,12.7a13.4,13.4,0,0,0,2.8.1h1.1l1-.4,1.6-.8c2.9-1.6,6.3-3.8,9.4-5.6l14.3-8.3,5.4-3.2h.1a3.9,3.9,0,0,0-.1-1.9c-.1-.4-1.5-.9-1.8-1.1l-2.8-1.7-10.2-5.8-3-1.8-17.4-10-15.3-8.9c-8,4.6-2.7,1.7-.9.4S358.1,127.6,358,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M356.2,127.5l-20.7,12-10.2,6-.6.3a3.1,3.1,0,0,0-1,1.3,2.5,2.5,0,0,0-.1.9c-.1,1.6,1,2.2,2.2,2.9l3.5,2.1,19.2,11.5c10.6,6.4,20.5,12.3,22.5,12.6l3,.3h1.3l1-.3,1.7-.8c3-1.5,6.8-4.2,10.1-6.1l13.8-8,5.2-3.2h0a3.6,3.6,0,0,0-.1-1.8c-.1-.4-1.4-.9-1.7-1.1l-2.8-1.6-10.1-5.8-3-1.8c-5.8-3.3-11.6-6.6-17.3-10L356.9,128c-7.7,4.2-2.8,1.4-1.2.1S356.3,127.6,356.2,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M354.3,127.5l-20.6,12-10.2,5.9-.6.4a2.3,2.3,0,0,0-1,1.2,3,3,0,0,0-.2,1c0,1.5,1,2.2,2.2,2.9l3.5,2,19,11.4c10.5,6.3,20.2,12.1,22.4,12.5a13.2,13.2,0,0,0,3.2.5h1.3l1.1-.3,1.9-.7c3-1.4,7.3-4.7,10.7-6.7l13.3-7.7,4.9-3.1a.1.1,0,0,1,.1-.1,5.5,5.5,0,0,0-.1-1.8,9.5,9.5,0,0,0-1.7-1l-2.8-1.6-10-5.8-3-1.7-17.2-9.9-15.1-8.7c-7.4,3.9-2.9,1.2-1.4-.1S354.4,127.6,354.3,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M352.5,127.5l-20.6,12-10.2,5.9-.6.4a2.9,2.9,0,0,0-1,1.2,2,2,0,0,0-.2.9c-.1,1.5.9,2.2,2.1,3l3.4,2,19,11.3c10.2,6.1,19.7,11.8,22.2,12.4l3.3.7a3.3,3.3,0,0,0,1.4.1l1.2-.3,2-.7c3-1.3,7.8-5.1,11.4-7.2l12.8-7.5c1.6-.9,3.2-2,4.7-3h0a3.3,3.3,0,0,0-.1-1.7,5.1,5.1,0,0,0-1.6-.9l-2.8-1.7-9.9-5.7-3-1.7L368.9,137l-15-8.6c-7.1,3.7-2.9,1.1-1.7-.3S352.6,127.6,352.5,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M350.6,127.5l-20.5,12-10.2,5.9-.6.3a3.8,3.8,0,0,0-1,1.2,3.2,3.2,0,0,0-.3.9c-.1,1.5.8,2.3,2.1,3l3.4,2L342.3,164c10,6,19.3,11.6,22,12.4l3.6.9a6.1,6.1,0,0,0,1.4.1l1.3-.3,2.2-.6c3-1.3,8.3-5.6,12-7.7l12.3-7.2a48.4,48.4,0,0,0,4.4-3h.1a4.1,4.1,0,0,0-.2-1.6c-.1-.3-1.2-.7-1.5-.9l-2.8-1.6-9.9-5.7-2.9-1.7-17-9.8-14.9-8.6c-6.8,3.4-3,.9-1.9-.5S350.8,127.6,350.6,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M348.8,127.5l-20.6,11.9-10.1,5.9-.6.4a3.5,3.5,0,0,0-1,1.1,1.6,1.6,0,0,0-.3.9,3.2,3.2,0,0,0,1.9,3.1l3.5,2,18.7,11.1c9.7,5.8,18.8,11.4,21.8,12.3l3.7,1a4.1,4.1,0,0,0,1.6.2l1.3-.2,2.3-.6c3.1-1.2,8.8-6,12.7-8.3l11.9-6.9a38.1,38.1,0,0,0,4.1-2.9h0a2.5,2.5,0,0,0-.2-1.5c-.1-.3-1.2-.7-1.5-.9l-2.7-1.6-9.8-5.6-3-1.7-16.8-9.8-14.8-8.5c-6.5,3.1-3,.7-2.2-.6S348.9,127.6,348.8,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M346.9,127.5c-6.8,4-13.6,8-20.5,11.9l-10.1,5.9-.5.3a4.6,4.6,0,0,0-1.2,1.2,2,2,0,0,0-.2.9c-.2,1.4.6,2.3,1.8,3l3.4,2,18.6,11c9.5,5.7,18.5,11.2,21.7,12.3l3.8,1.2a10.1,10.1,0,0,0,1.7.3l1.4-.3,2.5-.5c3.1-1.1,9.2-6.5,13.3-8.8l11.4-6.6a27.2,27.2,0,0,0,3.8-2.9h0a3.2,3.2,0,0,0-.1-1.4c-.2-.3-1.2-.7-1.5-.9l-2.7-1.5-9.7-5.7-3-1.7-16.7-9.6L349.5,129c-6.3,2.8-3.2.5-2.6-.8S347.1,127.7,346.9,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M345,127.5l-20.4,11.9-10.1,5.9-.5.3a4.3,4.3,0,0,0-1.2,1.1l-.3.9a3,3,0,0,0,1.8,3.1l3.4,2c5.6,3.2,12.1,7.1,18.4,10.9,9.3,5.6,18.1,10.9,21.6,12.1a38.4,38.4,0,0,0,4,1.4,4.7,4.7,0,0,0,1.7.4l1.5-.2,2.6-.6c3.1-.9,9.8-6.8,14-9.3l10.9-6.3c1.2-.7,2.4-2,3.6-2.8h0a3,3,0,0,0-.2-1.3,6.7,6.7,0,0,0-1.4-.9l-2.7-1.5-9.7-5.6-2.9-1.7-16.6-9.6L348,129.2c-6,2.5-3.3.3-2.8-1S345.3,127.7,345,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M343.2,127.5l-20.4,11.9-10.1,5.8-.5.4a3.2,3.2,0,0,0-1.2,1.1l-.3.8a2.9,2.9,0,0,0,1.6,3.1l3.4,2,18.4,10.9c9.1,5.4,17.6,10.6,21.3,12l4.2,1.6a5.8,5.8,0,0,0,1.8.4H363l2.8-.6c3.1-.9,10.2-7.2,14.6-9.8s7-4,10.4-6.1c1.2-.6,2.3-2,3.3-2.7h0a3,3,0,0,0-.2-1.3l-1.3-.7-2.7-1.6-9.6-5.5-2.9-1.7-16.5-9.5-14.4-8.4c-5.7,2.3-3.3.1-3.1-1.2A.6.6,0,0,0,343.2,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M341.3,127.5c-6.7,4-13.5,7.9-20.3,11.8l-10.1,5.9-.5.3a6.5,6.5,0,0,0-1.2,1.1,1.1,1.1,0,0,0-.3.8,3,3,0,0,0,1.5,3.2l3.4,1.9L332,163.3c8.9,5.3,17.3,10.4,21.2,12l4.4,1.7a3.8,3.8,0,0,0,1.9.5,4.8,4.8,0,0,0,1.6-.1l2.9-.5c3.2-.8,10.8-7.7,15.3-10.4l10-5.7c1-.6,2-2,3-2.7h0a2.7,2.7,0,0,0-.3-1.2,3.5,3.5,0,0,0-1.2-.7l-2.7-1.5-9.5-5.5-2.9-1.7-16.3-9.5L345,129.6c-5.3,2-3.4-.1-3.3-1.4A.8.8,0,0,0,341.3,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M339.5,127.5l-20.3,11.8-10.1,5.9-.5.3a4,4,0,0,0-1.2,1l-.4.8a2.9,2.9,0,0,0,1.5,3.2l3.3,2,18.1,10.7c8.7,5.1,16.9,10.1,21.1,11.9l4.5,1.9a6.6,6.6,0,0,0,2,.6h1.7l3.1-.5c3.2-.7,11.2-8.1,16-10.9l9.4-5.5c1-.5,1.9-2,2.7-2.6h0a2.2,2.2,0,0,0-.2-1.1l-1.2-.7-2.7-1.5-9.4-5.5-2.9-1.6-16.2-9.4-14.3-8.2c-5,1.6-3.4-.4-3.6-1.7A.8.8,0,0,0,339.5,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M337.6,127.5l-20.2,11.8-10,5.8-.6.4a4,4,0,0,0-1.2,1,2,2,0,0,0-.4.8,2.9,2.9,0,0,0,1.4,3.2l3.3,1.9,18,10.6c8.4,5,16.4,9.9,20.8,11.9l4.7,2a5.8,5.8,0,0,0,2.1.7h1.8l3.2-.4c3.2-.7,11.7-8.6,16.7-11.4,2.9-1.8,5.9-3.5,8.9-5.2.9-.5,1.7-2,2.5-2.6h0a3.8,3.8,0,0,0-.3-1l-1.1-.7-2.7-1.5-9.4-5.4-2.8-1.6-16.1-9.4L342,130.1c-4.7,1.3-3.5-.6-3.8-1.9A1.3,1.3,0,0,0,337.6,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M335.8,127.5l-20.2,11.8-10,5.8-.6.3a6.3,6.3,0,0,0-1.2,1,1.2,1.2,0,0,0-.4.8,3,3,0,0,0,1.2,3.3l3.3,1.9,17.9,10.5c8.2,4.8,16.1,9.6,20.7,11.8l4.9,2.2a5.2,5.2,0,0,0,2.1.7h1.9l3.3-.4c3.3-.6,12.3-9,17.4-12l8.4-4.9a17.1,17.1,0,0,0,2.2-2.5h0a2.4,2.4,0,0,0-.3-.9l-1.1-.6-2.6-1.5-9.3-5.4-2.8-1.7-16-9.2-14.1-8.1c-4.4,1.1-3.6-.8-4.1-2.1A1.9,1.9,0,0,0,335.8,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M333.9,127.5l-20.1,11.8-10,5.8-.6.3-1.3,1a4.3,4.3,0,0,0-.4.7,2.8,2.8,0,0,0,1.2,3.3l3.3,1.9,17.7,10.4c8,4.7,15.7,9.4,20.6,11.7l5,2.4a10.2,10.2,0,0,0,2.2.9h2l3.5-.3c3.3-.5,12.7-9.5,18-12.5l7.9-4.6c.8-.5,1.4-2,2-2.5h0c-.1-.2-.2-.7-.4-.8l-1-.6-2.6-1.5-9.2-5.4-2.8-1.6L353,138.6l-13.9-8.1c-4.2.8-3.7-1-4.5-2.3A1.5,1.5,0,0,0,333.9,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M332.1,127.5l-20.2,11.7L302,145l-.6.3-1.3,1a1.6,1.6,0,0,0-.4.7,2.9,2.9,0,0,0,1.1,3.4l3.2,1.9c5.7,3.2,11.7,6.8,17.7,10.3,7.8,4.6,15.2,9,20.3,11.6l5.3,2.6a9.2,9.2,0,0,0,2.3.9h2l3.6-.3c3.4-.5,13.3-9.9,18.7-13.1l7.5-4.3c.6-.4,1.2-1.9,1.6-2.4h0a1.5,1.5,0,0,0-.4-.8l-.9-.5-2.6-1.5-9.1-5.3-2.8-1.6-15.8-9.1-13.8-8c-3.9.5-3.8-1.2-4.7-2.4A3,3,0,0,0,332.1,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M330.2,127.5l-20.1,11.7-9.9,5.8-.6.3-1.3,1c-.2.1-.3.4-.5.7a2.8,2.8,0,0,0,1.1,3.3l3.2,1.9,17.5,10.2c7.6,4.5,14.9,8.8,20.2,11.6l5.4,2.7a5.1,5.1,0,0,0,2.4,1,7.2,7.2,0,0,0,2.1,0l3.8-.2c3.3-.4,13.7-10.4,19.3-13.6l7-4.1c.5-.3,1-1.8,1.4-2.3h-.1l-.3-.7-.9-.5-2.5-1.4-9.2-5.3-2.7-1.6-15.7-9-13.7-8c-3.6.2-3.9-1.4-5-2.6A2.4,2.4,0,0,0,330.2,127.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M328.4,127.5l-20.1,11.7-9.9,5.8-.5.3-1.4.9a1.8,1.8,0,0,0-.5.7,2.9,2.9,0,0,0,.9,3.4,33.7,33.7,0,0,1,3.2,1.9c5.7,3.2,11.6,6.7,17.4,10.1,7.4,4.3,14.5,8.5,20.1,11.5l5.5,2.9a6,6,0,0,0,2.5,1h2.2l3.9-.3c3.4-.2,14.3-10.7,20-14l6.5-3.8c.5-.3.8-1.9,1.1-2.3h0l-.4-.6-.8-.5a20.1,20.1,0,0,1-2.5-1.4l-9.1-5.2-2.7-1.6-15.6-9-13.6-7.9c-3.3,0-3.9-1.6-5.2-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M326.5,127.5l-20,11.7-9.9,5.7-.5.3-1.4.9a1.8,1.8,0,0,0-.5.7c-.5,1.2-.2,2.9.8,3.4l3.2,1.9,17.3,10c7.1,4.2,14.1,8.3,19.9,11.5l5.7,3a7.2,7.2,0,0,0,2.5,1.2h2.3l4.1-.3c3.4-.2,14.7-11.2,20.6-14.6l6-3.5c.4-.2.7-1.8.9-2.2a.1.1,0,0,1-.1-.1c-.1-.1-.2-.4-.4-.5l-.7-.4-2.5-1.5-9-5.2-2.7-1.5-15.4-8.9-13.6-7.9c-3-.3-4-1.8-5.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M324.7,127.5l-20,11.6-9.9,5.8-.5.3-1.4.9c-.3.1-.4.4-.6.6a3,3,0,0,0,.8,3.5l3.2,1.8,17.1,10c6.9,4,13.7,8,19.7,11.3l5.9,3.3a8.3,8.3,0,0,0,2.7,1.2H344l4.2-.2c3.5-.1,15.2-11.6,21.3-15.1l5.5-3.2c.3-.2.5-1.9.6-2.2h0l-.5-.4-.6-.4-2.5-1.4-8.9-5.2-2.7-1.5-15.3-8.9c-4.5-2.6-8.7-5.8-13.5-7.7a29.6,29.6,0,0,1-5.7-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M322.8,127.5l-19.9,11.6-9.9,5.7-.5.4-1.4.8a1.3,1.3,0,0,0-.6.7,2.9,2.9,0,0,0,.7,3.5l3.1,1.8,17,9.8,19.6,11.3,6,3.4a7.9,7.9,0,0,0,2.8,1.3l2.4.2,4.4-.2c3.4-.1,15.7-12,21.9-15.7l5.1-2.9a6.6,6.6,0,0,0,.3-2.1h-.1l-.4-.3-.6-.4-2.5-1.4-8.9-5.1-2.6-1.6-15.2-8.7c-4.5-2.6-8.7-5.5-13.4-7.7a55.9,55.9,0,0,1-6-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M321,127.5l-30.3,17.6-1.4.9c-1.3.7-1.3,3.4-.1,4.1l3.2,1.8,16.9,9.8,19.4,11.2,6.2,3.6a7.2,7.2,0,0,0,2.8,1.3c1.3.4,5.8.1,7,.1,3.5,0,16.2-12.5,22.6-16.2l4.6-2.7a7.4,7.4,0,0,0,0-2.1l-1.1-.6-13.8-8-34.7-20Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M289.2,147a1.3,1.3,0,0,1-.7-1v2a1.3,1.3,0,0,0,.7,1.1l47.4,27.3v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M338.4,175a3.8,3.8,0,0,1-1.9-.4l-47.4-27.4a1.3,1.3,0,0,1,0-2.5L321,126.2l51.4,29.7-32.1,18.7A3.8,3.8,0,0,1,338.4,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M321,126.5l50.9,29.4-31.7,18.5a4.5,4.5,0,0,1-3.6,0L289.2,147c-1-.6-1-1.5,0-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M338.4,174.4a3.8,3.8,0,0,1-1.6-.4l-47.4-27.4c-.3-.2-.5-.4-.5-.6s.2-.5.5-.7L321,127h0l50.1,28.9H371l-31,18A3.8,3.8,0,0,1,338.4,174.4ZM321,127.1l-31.5,18.3c-.3.2-.5.4-.5.6s.2.4.5.5l47.4,27.4a3,3,0,0,0,3,0l31-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M340.2,174.4h-2.4c0-.1,0-.1-.1-.1h-1.1v2h2.6a.1.1,0,0,0,.1-.1h.9L371.9,158v-2.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "322.1 132.5 320.8 133.2 318.2 131.7 319.5 131 322.1 132.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "322.1 132.5 322.1 132.9 320.8 133.7 320.8 133.2 322.1 132.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "320.8 133.2 320.8 133.7 318.2 132.1 318.2 131.7 320.8 133.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "319.9 133.8 317.3 135.3 314.6 133.8 317.2 132.3 319.9 133.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "319.9 133.8 319.9 134.2 317.3 135.7 317.3 135.3 319.9 133.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "317.3 135.3 317.3 135.7 314.6 134.2 314.6 133.8 317.3 135.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "325.2 134.3 323.9 135 321.2 133.5 322.5 132.8 325.2 134.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "325.2 134.3 325.2 134.7 323.9 135.4 323.9 135 325.2 134.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "323.9 135 323.9 135.4 321.2 133.9 321.2 133.5 323.9 135"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "322.9 135.6 320.3 137.1 317.7 135.6 320.3 134.1 322.9 135.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "322.9 135.6 322.9 136 320.3 137.5 320.3 137.1 322.9 135.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "320.3 137.1 320.3 137.5 317.7 136 317.7 135.6 320.3 137.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "328.3 136.1 327 136.8 324.3 135.3 325.6 134.5 328.3 136.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "328.3 136.1 328.3 136.5 327 137.2 327 136.8 328.3 136.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "327 136.8 327 137.2 324.3 135.7 324.3 135.3 327 136.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "326 137.3 323.4 138.9 320.8 137.3 323.4 135.8 326 137.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "326 137.3 326 137.8 323.4 139.3 323.4 138.9 326 137.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "323.4 138.9 323.4 139.3 320.8 137.8 320.8 137.3 323.4 138.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "331.3 137.8 330 138.6 327.4 137.1 328.7 136.3 331.3 137.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "331.3 137.8 331.3 138.3 330 139 330 138.6 331.3 137.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "330 138.6 330 139 327.4 137.5 327.4 137.1 330 138.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "329.1 139.1 326.5 140.6 323.9 139.1 326.5 137.6 329.1 139.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "329.1 139.1 329.1 139.5 326.5 141.1 326.5 140.6 329.1 139.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "326.5 140.6 326.5 141.1 323.9 139.5 323.9 139.1 326.5 140.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "334.4 139.6 333.1 140.4 330.5 138.9 331.8 138.1 334.4 139.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "334.4 139.6 334.4 140 333.1 140.8 333.1 140.4 334.4 139.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "333.1 140.4 333.1 140.8 330.5 139.3 330.5 138.9 333.1 140.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "332.2 140.9 329.6 142.4 327 140.9 329.6 139.4 332.2 140.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "332.2 140.9 332.2 141.3 329.6 142.8 329.6 142.4 332.2 140.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "329.6 142.4 329.6 142.8 327 141.3 327 140.9 329.6 142.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "337.5 141.4 336.2 142.2 333.6 140.6 334.9 139.9 337.5 141.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "337.5 141.4 337.5 141.8 336.2 142.6 336.2 142.2 337.5 141.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "336.2 142.2 336.2 142.6 333.6 141.1 333.6 140.6 336.2 142.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "335.3 142.7 332.7 144.2 330.1 142.7 332.7 141.2 335.3 142.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "335.3 142.7 335.3 143.1 332.7 144.6 332.7 144.2 335.3 142.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "332.7 144.2 332.7 144.6 330.1 143.1 330.1 142.7 332.7 144.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "340.6 143.2 339.3 143.9 336.7 142.4 338 141.7 340.6 143.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "340.6 143.2 340.6 143.6 339.3 144.3 339.3 143.9 340.6 143.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "339.3 143.9 339.3 144.3 336.7 142.8 336.7 142.4 339.3 143.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "338.4 144.5 335.8 146 333.1 144.5 335.8 143 338.4 144.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "338.4 144.5 338.4 144.9 335.8 146.4 335.8 146 338.4 144.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "335.8 146 335.8 146.4 333.1 144.9 333.1 144.5 335.8 146"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "318.3 136.5 315.7 138 311.5 135.6 314.2 134 318.3 136.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "318.3 136.5 318.3 136.9 315.7 138.4 315.7 138 318.3 136.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "315.7 138 315.7 138.4 311.5 136 311.5 135.6 315.7 138"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "321.4 138.2 318.8 139.8 316.2 138.2 318.8 136.7 321.4 138.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "321.4 138.2 321.4 138.6 318.8 140.2 318.8 139.8 321.4 138.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "318.8 139.8 318.8 140.2 316.2 138.6 316.2 138.2 318.8 139.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "324.5 140 321.9 141.5 319.3 140 321.9 138.5 324.5 140"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "324.5 140 324.5 140.4 321.9 141.9 321.9 141.5 324.5 140"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "321.9 141.5 321.9 141.9 319.3 140.4 319.3 140 321.9 141.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "327.6 141.8 325 143.3 322.4 141.8 325 140.3 327.6 141.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "327.6 141.8 327.6 142.2 325 143.7 325 143.3 327.6 141.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "325 143.3 325 143.7 322.4 142.2 322.4 141.8 325 143.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "330.7 143.6 328.1 145.1 325.4 143.6 328.1 142.1 330.7 143.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "330.7 143.6 330.7 144 328.1 145.5 328.1 145.1 330.7 143.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "328.1 145.1 328.1 145.5 325.4 144 325.4 143.6 328.1 145.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "333.8 145.4 331.2 146.9 328.5 145.4 331.1 143.8 333.8 145.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "333.8 145.4 333.8 145.8 331.2 147.3 331.2 146.9 333.8 145.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "331.2 146.9 331.2 147.3 328.5 145.8 328.5 145.4 331.2 146.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "316.8 139.1 314.2 140.6 308.5 137.3 311.1 135.8 316.8 139.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "316.8 139.1 316.8 139.5 314.2 141.1 314.2 140.6 316.8 139.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "314.2 140.6 314.2 141.1 308.5 137.8 308.5 137.3 314.2 140.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "312.2 140 309.6 141.5 305.4 139.1 308 137.6 312.2 140"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "312.2 140 312.2 140.4 309.6 141.9 309.6 141.5 312.2 140"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "309.6 141.5 309.6 141.9 305.4 139.5 305.4 139.1 309.6 141.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "319.9 140.9 317.3 142.4 314.7 140.9 317.3 139.4 319.9 140.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "319.9 140.9 319.9 141.3 317.3 142.8 317.3 142.4 319.9 140.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "317.3 142.4 317.3 142.8 314.7 141.3 314.7 140.9 317.3 142.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "315.3 141.8 312.7 143.3 310.1 141.8 312.7 140.3 315.3 141.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "315.3 141.8 315.3 142.2 312.7 143.7 312.7 143.3 315.3 141.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "312.7 143.3 312.7 143.7 310.1 142.2 310.1 141.8 312.7 143.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "323 142.7 320.4 144.2 317.8 142.7 320.4 141.2 323 142.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "323 142.7 323 143.1 320.4 144.6 320.4 144.2 323 142.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "320.4 144.2 320.4 144.6 317.8 143.1 317.8 142.7 320.4 144.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "318.4 143.6 315.8 145.1 313.1 143.6 315.8 142.1 318.4 143.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "318.4 143.6 318.4 144 315.8 145.5 315.8 145.1 318.4 143.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "315.8 145.1 315.8 145.5 313.1 144 313.1 143.6 315.8 145.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "326.1 144.5 323.5 146 320.8 144.5 323.4 143 326.1 144.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "326.1 144.5 326.1 144.9 323.5 146.4 323.5 146 326.1 144.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "323.5 146 323.5 146.4 320.8 144.9 320.8 144.5 323.5 146"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "321.5 145.4 318.9 146.9 316.2 145.4 318.8 143.8 321.5 145.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "321.5 145.4 321.5 145.8 318.9 147.3 318.9 146.9 321.5 145.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "318.9 146.9 318.9 147.3 316.2 145.8 316.2 145.4 318.9 146.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "329.2 146.3 326.5 147.8 323.9 146.3 326.5 144.7 329.2 146.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "329.2 146.3 329.2 146.7 326.5 148.2 326.5 147.8 329.2 146.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "326.5 147.8 326.5 148.2 323.9 146.7 323.9 146.3 326.5 147.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "324.5 147.1 321.9 148.7 319.3 147.1 321.9 145.6 324.5 147.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "324.5 147.1 324.5 147.6 321.9 149.1 321.9 148.7 324.5 147.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "321.9 148.7 321.9 149.1 319.3 147.6 319.3 147.1 321.9 148.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "343.7 145 342.4 145.7 339.8 144.2 341.1 143.4 343.7 145"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "343.7 145 343.7 145.4 342.4 146.1 342.4 145.7 343.7 145"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "342.4 145.7 342.4 146.1 339.8 144.6 339.8 144.2 342.4 145.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "341.5 146.3 338.9 147.8 336.2 146.3 338.8 144.7 341.5 146.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "341.5 146.3 341.5 146.7 338.9 148.2 338.9 147.8 341.5 146.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "338.9 147.8 338.9 148.2 336.2 146.7 336.2 146.3 338.9 147.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "333.2 148 333.2 148.4 331.6 147.6 331.6 147.1 333.2 148"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "338.4 148 338.4 148.4 335.8 150 335.8 149.6 338.4 148"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "329.6 149.6 329.6 150 327 148.4 327 148 329.6 149.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "332.2 148 329.6 149.6 327 148 329.6 146.5 332.2 148"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "332.2 148 332.2 148.4 329.6 150 329.6 149.6 332.2 148"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "338.4 148 335.8 149.6 332.7 151.3 330.1 149.8 333.2 148 331.6 147.1 334.2 145.6 335.8 146.5 337.1 147.3 338.4 148"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "335.8 149.6 335.8 150 332.7 151.7 332.7 151.3 335.8 149.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "332.7 151.3 332.7 151.7 330.1 150.2 330.1 149.8 332.7 151.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "327.6 148.9 325 150.4 322.4 148.9 325 147.4 327.6 148.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "327.6 148.9 327.6 149.3 325 150.8 325 150.4 327.6 148.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "325 150.4 325 150.8 322.4 149.3 322.4 148.9 325 150.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "332.2 151.6 329.6 153.1 325.5 150.7 328.1 149.2 332.2 151.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "332.2 151.6 332.2 152 329.6 153.5 329.6 153.1 332.2 151.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "329.6 153.1 329.6 153.5 325.5 151.1 325.5 150.7 329.6 153.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "310.7 142.7 308.1 144.2 302.4 140.9 305 139.4 310.7 142.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "310.7 142.7 310.7 143.1 308.1 144.6 308.1 144.2 310.7 142.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "308.1 144.2 308.1 144.6 302.4 141.3 302.4 140.9 308.1 144.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "326.1 151.6 323.5 153.1 308.5 144.5 311.1 143 326.1 151.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "326.1 151.6 326.1 152 323.5 153.5 323.5 153.1 326.1 151.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "323.5 153.1 323.5 153.5 308.5 144.9 308.5 144.5 323.5 153.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "329.2 153.4 326.6 154.9 324 153.4 326.6 151.9 329.2 153.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "329.2 153.4 329.2 153.8 326.6 155.3 326.6 154.9 329.2 153.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "326.6 154.9 326.6 155.3 324 153.8 324 153.4 326.6 154.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "349.5 148.3 348.2 149.1 345.6 147.6 346.9 146.8 349.5 148.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "349.5 148.3 349.5 148.8 348.2 149.5 348.2 149.1 349.5 148.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "348.2 149.1 348.2 149.5 345.6 148 345.6 147.6 348.2 149.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "347.3 149.6 344.7 151.2 342.1 149.6 344.7 148.1 347.3 149.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "347.3 149.6 347.3 150.1 344.7 151.6 344.7 151.2 347.3 149.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "344.7 151.2 344.7 151.6 342.1 150.1 342.1 149.6 344.7 151.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "352.6 150.1 351.3 150.9 348.7 149.4 350 148.6 352.6 150.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "352.6 150.1 352.6 150.5 351.3 151.3 351.3 150.9 352.6 150.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "351.3 150.9 351.3 151.3 348.7 149.8 348.7 149.4 351.3 150.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "350.4 151.4 347.8 152.9 345.2 151.4 347.8 149.9 350.4 151.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "350.4 151.4 350.4 151.8 347.8 153.3 347.8 152.9 350.4 151.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "347.8 152.9 347.8 153.3 345.2 151.8 345.2 151.4 347.8 152.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "344.3 151.4 341.6 152.9 339 151.4 341.6 149.9 344.3 151.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "344.3 151.4 344.3 151.8 341.6 153.3 341.6 152.9 344.3 151.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "341.6 152.9 341.6 153.3 339 151.8 339 151.4 341.6 152.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "347.3 153.2 344.7 154.7 342.1 153.2 344.7 151.7 347.3 153.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "347.3 153.2 347.3 153.6 344.7 155.1 344.7 154.7 347.3 153.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "344.7 154.7 344.7 155.1 342.1 153.6 342.1 153.2 344.7 154.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "357.7 153.1 356.4 153.8 353.8 152.3 355.1 151.6 357.7 153.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "357.7 153.1 357.7 153.5 356.4 154.2 356.4 153.8 357.7 153.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "356.4 153.8 356.4 154.2 353.8 152.7 353.8 152.3 356.4 153.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "355.5 154.4 352.9 155.9 350.3 154.4 352.9 152.8 355.5 154.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "355.5 154.4 355.5 154.8 352.9 156.3 352.9 155.9 355.5 154.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "352.9 155.9 352.9 156.3 350.3 154.8 350.3 154.4 352.9 155.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "360.8 154.9 359.5 155.6 356.9 154.1 358.2 153.3 360.8 154.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "360.8 154.9 360.8 155.3 359.5 156 359.5 155.6 360.8 154.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "359.5 155.6 359.5 156 356.9 154.5 356.9 154.1 359.5 155.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "358.6 156.1 356 157.7 353.4 156.1 356 154.6 358.6 156.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "358.6 156.1 358.6 156.6 356 158.1 356 157.7 358.6 156.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "356 157.7 356 158.1 353.3 156.6 353.4 156.1 356 157.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "363.9 156.6 362.6 157.4 360 155.9 361.3 155.1 363.9 156.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "363.9 156.6 363.9 157 362.6 157.8 362.6 157.4 363.9 156.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "362.6 157.4 362.6 157.8 360 156.3 360 155.9 362.6 157.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "361.7 157.9 359.1 159.4 356.4 157.9 359 156.4 361.7 157.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "361.7 157.9 361.7 158.3 359.1 159.8 359.1 159.4 361.7 157.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "359.1 159.4 359.1 159.8 356.4 158.3 356.4 157.9 359.1 159.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "352.4 156.1 349.8 157.7 347.2 156.1 349.8 154.6 352.4 156.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "352.4 156.1 352.4 156.6 349.8 158.1 349.8 157.7 352.4 156.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "349.8 157.7 349.8 158.1 347.2 156.6 347.2 156.1 349.8 157.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "355.5 157.9 352.9 159.4 350.3 157.9 352.9 156.4 355.5 157.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "355.5 157.9 355.5 158.3 352.9 159.8 352.9 159.4 355.5 157.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "352.9 159.4 352.9 159.8 350.3 158.3 350.3 157.9 352.9 159.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "358.6 159.7 356 161.2 353.4 159.7 356 158.2 358.6 159.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "358.6 159.7 358.6 160.1 356 161.6 356 161.2 358.6 159.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "356 161.2 356 161.6 353.4 160.1 353.4 159.7 356 161.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "349.4 157.9 346.8 159.4 344.1 157.9 346.7 156.4 349.4 157.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "349.4 157.9 349.4 158.3 346.8 159.8 346.8 159.4 349.4 157.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "346.8 159.4 346.8 159.8 344.1 158.3 344.1 157.9 346.8 159.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "352.4 159.7 349.8 161.2 347.2 159.7 349.8 158.2 352.4 159.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "352.4 159.7 352.4 160.1 349.8 161.6 349.8 161.2 352.4 159.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "349.8 161.2 349.8 161.6 347.2 160.1 347.2 159.7 349.8 161.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "355.5 161.5 352.9 163 350.3 161.5 352.9 160 355.5 161.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "355.5 161.5 355.5 161.9 352.9 163.4 352.9 163 355.5 161.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "352.9 163 352.9 163.4 350.3 161.9 350.3 161.5 352.9 163"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "346.3 159.7 343.7 161.2 341.1 159.7 343.7 158.2 346.3 159.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "346.3 159.7 346.3 160.1 343.7 161.6 343.7 161.2 346.3 159.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "343.7 161.2 343.7 161.6 341.1 160.1 341.1 159.7 343.7 161.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "349.4 161.5 346.8 163 344.1 161.5 346.8 160 349.4 161.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "349.4 161.5 349.4 161.9 346.8 163.4 346.8 163 349.4 161.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "346.8 163 346.8 163.4 344.1 161.9 344.1 161.5 346.8 163"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "346.3 163.3 343.7 164.8 338 161.5 340.6 160 346.3 163.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "346.3 163.3 346.3 163.7 343.7 165.2 343.7 164.8 346.3 163.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "343.7 164.8 343.7 165.2 338 161.9 338 161.5 343.7 164.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "352.4 163.3 346.8 166.6 344.2 165.1 349.8 161.8 352.4 163.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "352.4 163.3 352.4 163.7 346.8 167 346.8 166.6 352.4 163.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "346.8 166.6 346.8 167 344.2 165.5 344.2 165.1 346.8 166.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "330.6 160 323 164.4 306.5 154.8 314.1 150.4 330.6 160"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M323,163.9h0l-15.7-9.1h.1l6.7-3.9h0l15.7,9.1h-.1Zm-15.4-9.1,15.4,8.9,6.5-3.7-15.4-8.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "330.6 160 330.6 160 323 164.4 323 164.4 330.6 160"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "323 164.4 323 164.4 306.5 154.9 306.5 154.8 323 164.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M322.9,88.7h-.1a.1.1,0,0,1-.1-.1h-1.1l-1.8,1.1h1a.1.1,0,0,1,.1.1h.2l47.4,27.3,1.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M368.5,118.5a1.5,1.5,0,0,1,.6,1.1v34.6c0,.4-.3.5-.6.4L321,127.2a1.5,1.5,0,0,1-.6-1V91.5c0-.4.3-.5.6-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M372.1,119.1h-.7a.1.1,0,0,1-.1-.1h-.2c0-.1,0-.1-.1-.1h0a.1.1,0,0,1-.1-.1h-.5a.1.1,0,0,1-.1-.1h0l-1.8,1,.2.2h0a.1.1,0,0,1,.1.1h.4c0,.1.1.1.1.2h0l.2.2h0v.2a.1.1,0,0,1,.1.1h.1v.2h0v.2h0c0,.1,0,.2.1.2h0v.3h0c.1,0,.1.1.1.2h0v.2h0v.2h0v.2l-.2,36.8,1.8-1.1.2-36.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M319,127.7V90.8c0-.9.5-1.5,1.2-1.5a1.6,1.6,0,0,1,.9.3l47.4,27.3a4.2,4.2,0,0,1,1.9,3.3v37.2Zm1.8-36.4v34.9a1,1,0,0,0,.5.8l47.4,27.4h.1c.1,0,.1-.1.1-.2V119.6a1.5,1.5,0,0,0-.4-.9L321,91.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M368.5,117.1a4,4,0,0,1,1.8,3.1l-.2,36.8-50.9-29.5V90.8c0-1.1.8-1.6,1.8-1Zm.5,37.1V119.6a1.5,1.5,0,0,0-.6-1.1L321.1,91.2c-.3-.2-.6-.1-.6.3v34.7a1.5,1.5,0,0,0,.6,1l47.4,27.4c.3.1.6,0,.6-.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 5,
    transform: "translate(359.5 133.2) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAZElEQVQIWwXBsRHCMBBE0S/mhnFID9RBQjm0QVnuA1JnRAyBA4R0t8t7zTbXdXP2RKOoUcQSHAA0hFMgsGHukwD4PN94FJWFp3jcLy3Ot9XH00KNBIN6AhCa4vvayZ9ohuwFwB/8IT3JOD7BtQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 7,
    transform: "translate(359 132.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAHCAYAAAAvZezQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVElEQVQIWzWNuxFAQAAF141ErAiNGAF9iRWjBy2owZzY+K7AeeHOzj66OdpOURWVnLRmWHWHAPAsiT4Q3MAD3MAbQlaAZzKEMFZl9ne8hL9e99/TC9sKLiocYa1HAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 3,
    transform: "translate(359 132.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAU0lEQVQIWzXBwQ1AQBRF0ftnviBMKMCChQ50pS91acBCIlYyz0KcY5JY91NjGehCZK6dFI2lKQwgAEQ+yeFRBuDKUpZkkvhtx62hcKYq0HukNXgB6acY8w0x6eYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 7,
    transform: "translate(350.3 133.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAkUlEQVQIWz3OPQ4BQQBH8bdj4xhUGqUDSDQa7sAd1O7gFE5g2200CqVSQ0hkIxGxH7NmZ/6q9brX/ZCEJCbpRePdWe0bgOnhLjWe8PW0mdkpkyscasBbz3C9F4BRgLgb462jftUA9BaJ4upREHUMLne4t8U+K3zpiSQx2hwVgrBZSX79cNvOI1rFYJWqv0z+qh8xSGDN3EAA/wAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 5,
    transform: "translate(349.6 134.6) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAZ0lEQVQIWy3MsQnCQBhA4e+CCJYSnMjyZnAHN3AuM0E6F7AQwUYSgoVW3v0W52sf76V8maLcqQuxMBz7BJ2Nxpr6Yn+aAlJEyOMc9Ul9U67EN5qAPM4RH8qDcmP1H0nbVnQ7zoc+/QCSYyxSgYgh3gAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 5,
    transform: "translate(349.6 133.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAYUlEQVQIW13IMQqDQBgF4dlf3UpbwdJTeIt0OUxuk2tJ0MZSURAJW+z6rISQga8ZJ4nfhhBVZUZ+j/f8VeON1mcAGMBr2uUN1niyJVEX5uz5WSVgDIkjia70DoBHv0gS/y4vQjAml6dRGQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 7,
    transform: "translate(362.1 120.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAjklEQVQIWz3OPw7BYBzH4U+bxjFwBDFbJDbuwOA+nMJoIyaLtaPJJsrQqUn/edv316+pxmd7kIQk5tenZseHeocAi9tLXeMBMdnFAgiX91TWGHQBdVqDCYCwLVqiQYQ5T5N9KZOc4fqkyJzROaPJHJjwlccXnkAS030sCap3TvkpSQ6rgH4x3l402pz/qx9zUWSgginQZAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 5,
    transform: "translate(361.4 121.4) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAZUlEQVQIWz3LMQ5BQRRA0fOGKChJFBZgITrsSexJawvqr9GIQjJKjfjzNChucpob61PNdqU9eXfpuJ8FlBgDZUIMw2pXEyIzbc+PbDf6O/2FfKUCh+U0yoLB/HuOgsz8t+lq/vwBnzMvsxmDgKEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 4,
    transform: "translate(361.4 120.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUUlEQVQIWzXKQQ5AMBgF4fnbii2ROJozOYMbOYhIJGywqeqz0Vl+GZNEab6iWm80weMKTtutJHj+zwGM6ymAJb7sKdNXzgLAkUTKGcMYutoAPv0mHeysC73LAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 7,
    transform: "translate(343.9 135.8) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAl0lEQVQIWz3OoQrCUABG4bMxfAajYPQVLBYRg+I7+CC+jkWxmQSDYLLbFBQmExnD7d7dbfc3iMYDJ3xIQhKD3VX91Vm/DgGGx7vq3OFr0VscBBCOTrGqvMKbBpdafNkAEHrXELUifOMxj4Iqc7Sna0Xl63vZxOBSi30WxJtZEO7H3eB9ybBJQZkYbstJAMBP0Zlv/yJJfABC3mZqpDwOTgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 4,
    transform: "translate(343.1 136.5) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVklEQVQIWyXLIQ7CQBAAwNkNDQIJgSfwEGT5E+FPWP7BGTxJGxTy2IqOnxhfU/VGf9O/5Xk/BCQYiBO5DZfbVBBV5drm6o3/j/qsM+Fx3kceyd06YxMW0lwdtOcTalQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 4,
    transform: "translate(343.1 135.8) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAXUlEQVQIWwXBsQ3CMBCG0e9sfAVtREEYjCGySxZiExraNMiCgLBQzn/eM0kA3N5NR0ucS+LkmQQwLx9J8Ouihli3TpoeL/0l7i14bsE3xOjZDjWC3sTFoZC5Dm4AO7wLKp0mvFMhAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 6,
    transform: "translate(325.6 123.1) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAb0lEQVQIWzXDsQ3CMBRF0WvHQggLCgQdQjS0yVJswBoZiIoBYBIWCMT+3y8VRzpcbg9d709J4j/JnG6VGMa39v2BfNoSbW54MVQc+xrTZyJqdmTCzVFptJ8TQxdQdVQbVp2UE0ESAMP4Uj7vWB83LCoZP+78JlORAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 4,
    transform: "translate(325.6 122.6) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUklEQVQIWy3JsQ2CYBQGwHt/1MSEjh10Dxsb93QBwi50LEBvMPBZ4LVXScBrWuKLM8O9L6gknu8l1agr1aHQOME+w5Eu/7jRIOuR2bDiw/jo6wcPKxcH4obuQAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 7,
    transform: "translate(326.6 122.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAHCAYAAADNufepAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUUlEQVQIWwXBOw5EUABA0fs+sQGNwtasxVosa4rpRKOQECTePHfOCSoAw3czqIzz4U8J03p6VzBI7ptEeaUCuc2RCCylwl5fP9ejSkxA1yQA/klXKNoEe2o2AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 6,
    transform: "translate(328.7 118.3) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAlUlEQVQIWzXNPw7BcABH8ddqtdoaDJImDOxicANcwOYCOI+jiMQgkTBL3EE6EYmtf8Sv/RqkL/nMz5IEwPR0lxu5uFGTw6hrAdgAk+1NVEIVfN4FdfZwfZQk8kdG8cowqWF+SQTgyJTkz5QyN/gmwOv4lF/D7JzIkkR/uVfQa+OEDq04pOE5XFdjC0lIIl7sNNj8F7UfHMVLLcNe/LEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 6,
    transform: "translate(328.7 117.6) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUUlEQVQIWz2JMQ5AQBQF56+9gHArDuMKriXRu4KKRkGy0dDxn0KYaiZjkgCoxySA+IUvoANiNST5Bn6CVojX9Mq9iyw3gs/8dE1hAd7bt6UBPBKNI+bRvm5gAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 7,
    transform: "translate(329.5 117.6) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAHCAYAAAAvZezQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAXklEQVQIWzXKMQrCQBRF0fvfn0kzSIJddGVZShaURbgWS9sERESsfBaaC7c7TNfNttmXIphvD/NPpy4Za7KsLwPoXMWQsQPCNpf7230RxwwKwNglTcEh9RMAz4/dAr4shCF42aA4jAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 6,
    transform: "translate(324.4 107.3) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAl0lEQVQIWzXHsQ7BUACG0e+W27RIIxHSgcVs6hswmM0Go8XLeBQJBha7pM8gMZAuEgNt2vT+Jmc7RhIA0/NNNvKxHctxMjAAHkCyTYVnUCXyLGd+fQjAG69Pcs6RPz8UrxxXOqp3CUDTVTVF9sUVNbYbEPQCvLDB7HKXkcRwuVfQb+FHPmHcJt0kBgBJSCJe7DRaHfS/JH4EI0lHPQXt4QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 6,
    transform: "translate(324.4 106.5) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVklEQVQIWyXMoQ3CQAAF0HflFiCwFR2GFViLBI/C19WW5FIDGMJ9RN1TryQB49QCFU73lnzIizpOLf1Jf5OF+n1s+K2x2xdDn9kWrudDGaCvcbscC/wBMGYk5hOOs9IAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 7,
    transform: "translate(325.1 106.5) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAHCAYAAAAvZezQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAWklEQVQIW0XIMQ5AUBQF0Xnv+4JGK3ZmKTZkFXaikagVFETBVSAmmebQDLMk8e3RjHZaxZvXaSB36OZNAEkdnTI4mRkAJol+OVQGo4rhAYDxOFW4/bBfUmZwA9+eKBnLmhDSAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 5,
    transform: "translate(339.5 110.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAYUlEQVQIWyXKsQ2DQAxA0Y8xggOkSElFB2UWYZIMSUeZSTID6LDPKXj1q+bPFmkaeLyfdK/Evi6V2GH4acQVaGpYv7/QuJySC34alg1xQTwHOjb3zgGAaF+DB9IqxR2phT8QpyrDHPlyggAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 4,
    transform: "translate(339.5 110.4) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAWElEQVQIWzXIMQ4BYRQGwHnW3xCFUKqcQr8qlxKt+yg50W6rENlPsTHlVBKX15iExZramn2o831INayozfzV6A4sfUmj3kwjmeiOPE67qiT++usQeN72BT+vdhsO/561gwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 7,
    transform: "translate(340.5 110.4) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAHCAYAAADNufepAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAU0lEQVQIWwXBwQmDQBRAwffXjbbgRazJOtKNNVmFJw+CN8EQxIXE50yoAAzzbqi8l8MExLh9vbyRIHdNotwJgdzmij9yKqzl5/QpqqRXBH1dAfAAhx0mnblSlKgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 6,
    transform: "translate(346 116.6) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAmElEQVQIW03NMQ4BQRhA4TdrZBgUEhKiUaklDqCicAxncAgn0DrGliqVQquQEBGyhYhszCS7zK8QieIVX/UQEX6NNxf5txIRBout2HaFUsOia5q431IAUW+2EskCIQ+8XI6/ekbrswDo7ObxRvP2OeVOFdO0EAAgOi4nKt3fcYnDJ47nKSU9PAC+T4DuNBZVLGDqht18qAA+f0FLwbW7DzAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 6,
    transform: "translate(346 115.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAACXBIWXMAAC4jAAAuIwF4pT92AAAATklEQVQIWz2MsQ2AMBDEHPQjMFaWYjAG+QYhIQqKiCqIgvxRoODKheUkiU72IuuiE3SBZS+KHdrxVdYcokKsELcY2gLUf4MBPJuYpzEBvORRI41OmxjIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 7,
    transform: "translate(346.7 115.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAHCAYAAAAvZezQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAZUlEQVQIWzXIMQqDUBAG4dl96wtYWUlQyJE8Tc6Tu6TxDmnTKkIQAhHxt9AMfM3QvUZJ4s/rInF/f8SZl27ccvAYvgLwJjvZoM3Oc/4prkWiSs7FjMAwSfTzoiqcMI4BMK2bErADgfwlGUCJF8wAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 25,
    height: 23,
    transform: "translate(336.7 127.4) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAXCAYAAAD+4+QTAAAACXBIWXMAAC4jAAAuIwF4pT92AAADF0lEQVRIS5WWzYtcVRDFf1V1+2NmL9GYiAguFDGg4kcgQkQkQQy4EERBEP8AwY07N+50J+5cCS7iRtEYEhIJCIISULOJoCAqOBBwGaM9/d6tclHvvZ6J6Xnjhcvrbu6tU3XqnHpNRLCf/ezVP2PszLotEcHYOvH9tRAV+n32gdtk7M7ONQryzLdbKwATogaiAiacO3JgX2Bl7EBzo6VsFsQhFhWxBJMQTl65FlHh/MO37wm2ZyXHL/wafQWiiqgQ3vGsgk4UmRq+TPALjx68JdhakGOf/hxI0qRTgxpg/fcE9Na7BGR4hgcXjx7aBXZLkMc/uhpigk0tgzUOKpSNgqhQlxU1RTcMHMJjEAVCAorw5ZOHBdb0pP7TUjYn+NLzkgAIdbsSTUXnea39qx0qgw7MBN+uoMJTl35PNm6u5KH3vgspihalfyKAgHaU9JXZrKxoah2dF8Kd8EAnqxi7QI68czlsaisTmXZqUmxuiAi+rNhGgYjMXATraPTqIJJnLfv21cl7ZBddddHiTSpFp5YUNA4eNIsWnRo2taSj4x6SXnppm1D/bocEYUfj73/r6xgy79Tiy4rNC7SOFCWCIZDNCigQIEUIz0RFu0pU+eal+2QAufeNS4OrbVbS1SWD4YHNS6ccGbLzxpEimYQHOOiGDSq7/NqDg4wLgC96nqG9vgQFnRfUs8lRk/+yOQEBr46aAkpzfZl9mSeNIpIV7lj24dYTAQyBUBDJGdUu2qSt8eG3umhTcUB0CUZAtKkqAn54/ZFdZiwRWSoEdeFdPzQbr1BvNGmUGYgHvvSOKsVmBhFQg+ysc+XNx/4zWobG3/3quUg/rLyQDbbByd44Ni+ZMQwCsbnlPYEf3z62HqRfd71yNsLTeN6PCxNsYmnKPnj/uVdkEX569/j/G5CHX/4iEIg20JkRjQ/yxDt6JOcbJvzy/tNrx/3oS+vQi2eCCOikGTVWrtZU0m8fnFgLAPt4af1x+jkBuPOFzwMJvE0P1e1IGe8ZPtdoJTevO57/LHUaSePWx6fGYcb+aazbB059EmNn+v0vzNcGe3ePVyUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 16,
    height: 26,
    transform: "translate(335.5 124.8) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAaCAYAAAC+aNwHAAAACXBIWXMAAC4jAAAuIwF4pT92AAABvElEQVQ4T42UwZHTQBBF3xhnYAIhBg5QsDoRAikQARmQAElQBQVFQQpcUQ6ry2Jb0ow0n0OPRmNL8u6vcpU1o9/9+3e3kMRjv7u/99q62/FE3P1ptHb+aICqbqQW6Nfvbwao6kYEINrz299LFZsBqtpe1gB40Hn9vdslRKADBXvUEd58uVSxX6FZdj8TCUZWeZawUFDVjejTjYd4SkQSOcDrz7OKVQWKwNkIzlkAfLoMoHZ+90JBdr0D9WTpMGdHwACvPpmKrGBynSEdjKZEWjmL5LlwkuYAHnSas03Z48nIeNCDlaAAGmUKqroRXVHbteu9qdARm4sCu6puhJJUQOcr11NHNBbBB8v+6+NztwdQhxk3TZvHJAPEFPCIRQU0GBlgjxKZJK8zNeosG6ml7hnEB8tcYq8u/WvJY6up576ou5jAKTvA7uuLg9MZ6ztkmfjtuikwT6LH2pMWiBFoZ9fLukvsAL69PDhI5BEzLiQxgcUClcgKcn+n+nughdhZTWvZodiF7+8OjiHV+o+Lhdkiw/U6B2wLk6HXU7eGiwA/3psXRJO+ZVyJxQclt47b0icsAvz8cHCTcU/Bf6BcY/qPQ5reAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 19,
    transform: "translate(337.6 124.8) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAATCAYAAAB/TkaLAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB1UlEQVQ4T62UP2sUURTFf+e+eW9mN9HAghgEtfOb2NrYiJWIpY122lha+wH8BoKVjZ9AP4Cg+AdEbUTWJAY3bEiuxZ3Z3bgbshs9MMx7w9zzzjn38nTt3Q83xPMrA/GfYEJUgpsfhn7r408/qWAZyN258X7o2USteCqDJ5c3Tq3cALKJLJDABBXw4MuOP/q6cyrlco+6O5+2vBjUJpJETayLQZG4v7m+tPKqW9QGibCfgGIATsIoEk+//3YJbp/rn0g+UQpw7/O21yZ6JmqBCLWGWEsRUVG8rw96x5JXzKBpyYqm+0YGOAZUgqw46MXWnhfB1Y1mjtxmN48vnlX3RzbIEoc4pT0soUlBaskX4QgpxCQkgYiC3NoFqAU9E/KIISFe7Y7nJmSO9OGFM0qK5oSQqMmCqvXRETrTb7OYIwVaq1ChSc5qi03QT0I4TWv/zWj/iNqFpHfPr6lI9FObm6L7jWkSS0xFdDr/VX9kpBbh2XDkYR2yrJ2OuC96JmqLGBrBpbrSUqQdXm7veSOj0rTzfQvdCeib2CxpNdIOr3fH3rTWs7pZbhtoYlCZVibt8Ha071lxN2QihixYT/9A2uHb+MBriybiTpZWt38cfh0cejFRgD/51m4AoCvZZAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 6,
    transform: "translate(350.3 132.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfklEQVQIW03DwQnCMBSA4T9N4sG6gFc38Sb05F6u4wDdQSh4NSpYRKFJWyMvz6sffKgqTderqvLfAeT3h+b00HRJFBFcvcAe13u13jL3I2UWsIZ2tzFOpi+v7olmwa08FABwMQyYylByQa+CXXoAqvNha1KITPdIuo2kMADwA8E2RkDOEmFHAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 7,
    transform: "translate(349.9 132.5) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAHCAYAAAAvZezQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAX0lEQVQIWyXHMQ4BQQAF0DeTTeg5kU72VK6k0LnERuEAGskKxS4SMV/hdU8S/XlMEklU+F7Y7m+B0p/GtCufgTyi05GJAoui5k6byYv2jponmf857talHjarYqIuC/gBxugvj4zp5+kAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 4,
    transform: "translate(350.1 132.5) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAWUlEQVQIW23DMQ5AQBRF0ftmxiiYSHQShcom7MGCdJZkOXqVqLTCV+mc5DCuh5kZfwOIaTutywJ1EE30DCkKwC19rQxxY1RBRMF+PQbgAOY2qfQil6Pw4vMCztEgx0NiIa8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 10,
    transform: "translate(343.6 122.4) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAACXBIWXMAAC4jAAAuIwF4pT92AAABEklEQVQYV22RO0oDYQCEv938m83GaFDRNGnsRU8hFqIHsNe7eBI7Ky08gUh6TxAQVAyJG93/ORYhGMWBaYYp5oEk/uPRw1gnT69a1TJJABxcPcqUhnJQ0dmuKPolWZ5hqhZ3+7sZgNm7uFfRb2O6BaZbQAQ3aZAXxUabVGQskStESEJBRBuxU4sEMUSCC/g6cDx6FkAOGXZikUTzMidMLX7m8DMHgvAZUEwAi8zD81t1NkvyylDtdIk2sjbsUayXmF6bVpmTFy1yACSaty8URPPeIISvPSkmUoy42pFiWpjH16fZInMg1g75hK89fuYI8wAJJDDLpimBm1jKrQ5KQkn4D8fo8vBnjtXRB2c3v074y28BgdMpjppkwwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 8,
    transform: "translate(343.6 121.2) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAkElEQVQYV22MMQrCQBRE35cvWNnEQ1nkHp7B0vt4AsWDpBYLiyUoRsV1dyyyGpBMMzC8NyaJsdRNEIA68P8RQBcggx6AClQ3QWoLcC994xcHyKf+lvKVuwJewebgy22Q4mCpBd6gV9+7VWX+BXQGxQJEsOkgej4CCfJTTGaGMigJJThsFgbgJFDqjf26MkbyAU9XSfBKDO+CAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 13,
    transform: "translate(345.3 121.2) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAANCAYAAABhPKSIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAApElEQVQYV02PQUrDYBSEv3n/S0IitKXFG/ROXqY77+LWpWeRLsVtwZYSoTHj4m/EgdkMH8yMbPN0PLkIXvZbASTAKoMWsSgAWolNisPH2QD5/HnxOkUnaKPSOZQg55mU2GXUMIFNFoYCBl5Po/OxETYI0QjWGcg2b1/fLkAg+lCd9KAg/xXJNgDv482NxGRXEmAoolMw2WD7z9ef2bbro0X9/ekvT/g619SMGuQAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 7,
    transform: "translate(345.8 129.3) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAjElEQVQIW03OsQ7BQADH4d+JBzF7A4nYxWC2ezcbm3gDq0QiDAZD0wYpOdXr9dr7m4jh2z8k8TVanzVcniSJLsB4l8mljhhawABgJse7gvXUtibkniqveOxvdJoioFZE11I/PWViiSFiJDFYHFQmb1xWoEYUlxcdgO2sb4L1EIW7lqSrqfmNevON/ocfMXNqUSxwXj4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 5,
    transform: "translate(345.1 129.8) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAYUlEQVQIWz3GoQ3CUBQAwHufIAiKNIEROggSJqphqUoGoQZBAqroYn5fBYFTF6fbmPOT+qI+uHZNQOnbb6yI4HgZEyIznYd31oF6JyfmTyrQt02UPXHwV36JHWVLbIh1WACbhR2gm/coxQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 3,
    transform: "translate(345.1 129.3) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAADCAYAAABfwxXFAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUElEQVQIWzXJPQ5AQBRG0TvmRzIKlSitwCrsx7osS6lRSCQSMe9TiNMeJ4nfsl/qo2dIFV3yBIB5PdR4x5gDJnGayMW+LIIH2G4jAlNbO4AXXrEYp+SxFpsAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 7,
    transform: "translate(355.1 121.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAj0lEQVQIWz2OMQ7BYABGX+t3AgcQgziFwWISZ7A5gFOZLCwSZjcQFiTE0jTpr6r9/7afRb3kJW98SKJxtLuq6ZAf48NDPnUMV2cBmMkxUhEXVK6k1TbkNgPAEAZQC28dVeaxp5jefKtwPegEeZThE0d6sfiXR2WNAXjfLBK4pODzTLkvp8H/qL/Yqzvb/K++0otfRSqMtX8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 4,
    transform: "translate(354.4 122.4) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAACXBIWXMAAC4jAAAuIwF4pT92AAAATUlEQVQIW03LoRHCUBAFwL0zTAbFDI6OSFUpDDRdgEXEI+C/CBCs30pivq153xkPxisuy7Ea6kDvqYnaFagk4Hxd83l+Vwbtp09/q9kArsAaHyYr16UAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 4,
    transform: "translate(354.4 121.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAY0lEQVQIWzXMMQrCMABA0Z+0QUpHwUnwSE4uXsgb9TClsw6iKDpoo/kOkr8++EGlNtxepgib1LBetMQKh+PDdxGFWXh+/eN+upqVUy7cP4VZWaUY2u14sYuBc5a+kd2yD/X2A6quKrlBWaCjAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 14,
    height: 14,
    transform: "translate(350.1 126.2) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAC4jAAAuIwF4pT92AAABZ0lEQVQoU3WSwa0TQRBEX8/42yYLkiAGJA5EQQaERQIEwQGRA0JCQh/5297dme4uDjO24cDeZjXVVfV6TBL/+95++SGlIIVSqCUCJNgBvPv2c6gNzMAvTnpSjjtA9HOn1EKsjlXDqg2hX53b5Hqsw64YsTi5BVaM2ILogbkB0xFmXIPteSNWRyGsGrkG5dUOIumXTn0qKKewn9rQCtJzzhLZxsD2vI5hKXTYgTSjXjo3RuoBQLQETSgxEZjhlwZMR18d8uEoCfUEMYQS7bRBQj1Uvn58YyPq7w2rBV8GtVycDFEPlX5udzgI/OUvx9wC2eiWq89YowJA9tkboPAQtlOjHCp+7tR9pV8aSlH2458iqcfdiD3hDUfPQdOgL33YIeLqd6Pt1wJlLP8u9GvH5oV0TSiJ/EY1MQbEf4UvnbIv+LVTnupYz4wa81WlC6tgs6O9/vBZtyUqEuVjBQrBPH//9P4WCoA/iGgilnh3reAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 18,
    transform: "translate(348.4 125.3) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAACXBIWXMAAC4jAAAuIwF4pT92AAABEUlEQVQoU32SPU7DQBCFv7EdcgBzByokzgDiVxE9F6DmAEiUHIGSPiWyQESIe+QOuERxYjuPYifejQJMs6Pd770ZPa1JYjKvxQKqo9L4o7JNI+Dqs9b/oIAGJLh8qXUx3RUE0Aean+rh/LnW2VMUREcHlPQs4fQxwNuOeXS1PApOHr5UANAx1ODYgLog+Ljft+BYBEC9O67AxmAFaB2EAWwCYLk77oEW7pil4JBm3BGAFtZN2CWbzGupjW9aBoDkDiBDDI7qvR9FwEbmoAGdQwvQCvTtwjWo9dHVQWk2BpbslCW7ZwDV4fav2QBK8h00r8elvV0HgXqPpvgF3NT7TWnIw07+0A4IMLstbXZXWprpD3nOcWlWZsNQAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 7,
    transform: "translate(348.7 125) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA/UlEQVQoU42RO04DQRBEX9Xszuwuss0nJ4OcmJiU03AMMi5BhjgLEYRklpAQAR/ZWjfBgAS2kSipo34qVVcrIviPbp4/Iguy4Wza6S9O5/dP0UpkwV5KFEOx6A27KTEkMRh6iezKDTank7zV1LfHB2qAzmJBYIti6C0siAiWKxgDFKKRKRZ3b8t4eF9unGeA66N9WaJIrCJYfGERsAqRDa2hddCqLscAJOaL8Zep1ju8eHyJaTKDoUh0NtNUE3cWvUVv06teNUmmdisGS2ZNl4czGZBMUFNWSIxAi2iARtCo1hjfExEbCX/qav4aM4vGMEsiyxSJSYKTne1P+QTHVkhCo4HnOgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 17,
    height: 18,
    transform: "translate(325.6 103.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAYAAAC9+TVUAAAACXBIWXMAAC4jAAAuIwF4pT92AAACHklEQVQ4T42UvWpVURCFvzWzz7nXxEs6EdFA2mDnT6eiRVq1Ehs7sfcBfAILGxEfQlQkhUGxEbSLtSmsFB/B3Jw9Y7HPvYmIkoG9OX+sWftbw1FmsqiN+29TLsrJjq+Pr4tjVjl6kzWwviCJzUcfU250s44vDy/9V/APETLJmmAiI/GpYWZceLqbZaVgU+fT3c2/BLU4zvq97fRpwVz4pOArHT51ympHN+spKx1+wpGLstLxYWtjKbZ0kgFZE00LKgLRHCVk5HJZ7yCx9fl7yoxurceWlgBJECA3ZGrPXMQQ7aNIzA0BOWRrlnkoEmMnMshMJDAXOa+tO4AECVETEqwYBE3k7J03aS4ggQa1ziuZzVXuV+pQm6sa+NRRZ8S8khELJznaM7Bm1criVWITp/TeuGWOnAIE2+dPyTh6PgQ2LkEMgXpHaoDjoEIkLRYhb1eHTA4CajR4nTW4pVmOIcgh8N5RcSIatxg4FIkAJDITIolfQ4t0nKHMccuWlrk1fG3DTt98mbJE3iwCWGfAwjZYL9SNCQExD+QtAAD7+fq2oA1a1NrgjlFmgHcNaBy0dMjGT4Kdy2cE48T+eHFrOcIbD3aySFgxfObNXIJNC8P+QNcbMQ+ixNLZEuyivj3f0t6TG7KJkTXaEA4VxtgzEtk43WPp6P/kX3Xx2W6W1R7rHZ8YZdbjvfPu6jnBMUWO1pVXe9mtTZDB+2vrAvgNBvEHL+aiYlkAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 13,
    transform: "translate(326.3 102) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAANCAYAAACtpZ5jAAAACXBIWXMAAC4jAAAuIwF4pT92AAABSElEQVQ4T62TzU3DQBCFv2d7HSvJLUWAOKSJSIAIDdAFV06IDiiACjgbIUDiTAN0ETdAsIbDjh0bbH4k5mSPx9+beTsrM2MsTl8rQ1AeLDRaNBIaA69fKiMFUtAMeANyKPd+JzIIPnmuzGpQABWeTIAASoBJTJX74yJfwMe3lZGBciLMgckMbOv5ZpJp/Gdoih746MbHnwACZUAG8pyCF6Yg75rgdT5ZI9KCD68dGnZA5GC3xOooorlDO99J/Hka81pdbYzEu8pigUIUIHWRFMhBorVHuTfRdO5TaArlcqHMaoPa/UuFAtg7cQtSB00671kExnpg683P4393y09WrC43rdmSet0qBzP6BxdotyOZxdz9eneIg+v2nUhrQwHU0XsKeDjrb8boBWmiEUkKxfG7m5HD4/nwLv8IbqI7BUShp4s/XJD/ig/zHGf6VtvMkQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 20,
    transform: "translate(328.7 103.2) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAACXBIWXMAAC4jAAAuIwF4pT92AAABW0lEQVQoU42SO24UQRRFz63urvlgC1kgAi/AObG34dQrIHVCSs4CWAZsxyAhJGQ5sS1GY8+n612CbsY9HjR2JZWcU++9W0+2eck5u7zx2iY9BwKc/7h1Fnw9eaNnhQ8/7zxOQhIA9T744tcfg5gmyOwRPv2eGSAnaCTWQOln3RE+X809SWCgCrHAjATqs9EwpS/X924xgSkGG2YRNBIfjw+1U2GUQCEkaIECvK4SD4NHt4ScOqm1KIZVwMIw1iOzEb7dPniaOrACikxrOKrEKh6NjTBJoqXrOwzF0NQQwPnbycbYCCMlMmaJkcAWNbCK7dUZVIBi0UjM+2SMydVggKGQk7pWgFqJecCB4P7Jcso23xeti00guhtWhmWY08O8VaKGLko7UeiGDXcf9xQG/q23GEtkQS2QxPtXzQ4MfUuzsNswa8O7Jv0X3BKWYRdgmrQXBkjut+8lMMBf7HOlxXhq7JAAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 4,
    transform: "translate(326.8 114.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAASUlEQVQIWwXBwQmAMBBFweeiCIIE7MCbLdqehdiAF4UQNJvkO9Nt+6GwLcxrwEbDSnJabZRcaFWYJOJ5IxfvlTB/PlSFx0w/DfxIByM6RI8KXAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 3,
    transform: "translate(326.8 114.5) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAYAAABbNsX4AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAOUlEQVQIWzXJMQ2AQBAEwLnkSjpM4QlV9NjABQIoPr8UhGmntuMOJFRRCz0uMqgmk3Nfq+cTfPF7AVZsEQTFAV11AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 6,
    transform: "translate(327.5 114.5) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAGCAYAAADpJ08yAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPElEQVQIWwXBwQmAMBBE0T/ZJbEKQbA8G/aUEjyKKDu+p2NeNiLXEXSJHGrsS6Dzfj2fj5bA1gOqyrb5AaQeEnHqprFxAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 10,
    transform: "translate(332.8 107.3) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA7UlEQVQYV12Pu0oDYRCFv/nv/66B3UTXS0TUMpDKytbOysLGykrwLXwLX8FWRAxiI4K1pQ/gUwgmOxZLwuoHB2aGw+EMqsp/7V89a3939Ni7fFJjhbhR9M+Y5bB78ajtXAnDjPGWyc27/jGNzx8UVcrxGuIMcT2Thpnju08FcFtn95pGGVc62p+WYrsk1glXOEKdABBV5eD6RfNmRpyh3BngB55QJcIoYaPtihsnuOxxpSdUEbGCBItLFvG2SwI4uv3QUCdClRARYpOxwTCbNrL6TkyX1s4XYAFVZtNGVp2WnLx+6eJ7ztvpodDjF0rOTtL0kGLJAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 7,
    transform: "translate(334 107.3) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAiElEQVQIW1WOuw4BYRCFvxkaUcmKLTQ6L0LnkTQaXkjJg3gAhYRYiVuy+f+jmM3idDP5zsVm67OsB1ZCpwQfw3ZaGI08v4VecegO+QiLw0UtAKAadIL8CEhXWvl+NTQlkauA6IKe3xSTIm2+iYdPwPtgA/BRUwGg9F9F/bMBYLcsTKndFqYbfAAeBzvRokm0VwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 4,
    transform: "translate(333.5 108.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAdklEQVQIW02NQQrCQBTF8v9UsFIQunAveLOeySv0JJ5GkClaLMX581yI0KxDYpLYMj7emkPkUnmGmIrIETRb6fZa1SfHVFmTI6tMRYyX3hqA+yeUS6V1Z6nBzo1DhQXjej4a8Cu2yZlD7E005iSCLhnDqbP/7Qs2NDPwP5xT4AAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 5,
    transform: "translate(328.5 110.6) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAb0lEQVQIW2P8//8/g+36W/85RLgYWHhZGLYbSDAyatYe/i+kL8rAIcLF8OfbHwYGxv8MLH9//GH4fPcDw6/3PxlY+dgYmDiYGRj////PoJy5+z8zFwsDCxcLw7VmW0aG////M/z//59B3G/dfxgbACKgK5PztipkAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 6,
    transform: "translate(328.3 109.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAS0lEQVQIWzWLoRGAMBDAUq5MwEpIFmIBlmKSOgyid3AY7DcIrlGJSFLpLOU2d2kn+ELuERXaATkKMIL13waAKBCP7OuUUJm3SxWVD/xhKzW0hBMfAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 6,
    transform: "translate(329 109.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAACXBIWXMAAC4jAAAuIwF4pT92AAAATElEQVQIWyXHsQ2DQBAAwb17ngA6gCLoxHW5J5ogpQISIhASQkLrwJMNn3VXRSWD4LudAuTUVZJgPm6boSZjW6gEobJcj33JfwBe9Qe6xh5s5lcWkgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 5,
    transform: "translate(336.2 116.4) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeklEQVQIWzXHPQ4BURiG0ee7uUbuVCLCFJagELEBO9BbhUVYj0IjNqA1K6AmkYj4y3zXq3K6Y5IAmO2OKjptLAa2k8pMEqPVXr3xgFBG1GRiahEA8sO51mc+lyf+drJ/iQD3043UL/FXQ9FNHJZTQxKSqOZrDRcb/f8Dpho167Hf8gsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 6,
    transform: "translate(336.2 115.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUUlEQVQIWzXHsRGCQAAEwP0fOtCqpCJC63KI1Q4wc4gxhoDnDBw3W0kk0U9LkqjQPz5pL6Bc7ksS9idZ6dJo8y9Q28zx5tjiNpxK/We8ngt8ARPvLYywmkL5AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 6,
    transform: "translate(336.7 115.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUElEQVQIW03IrQ2AMBgG4etXfoJEV7IP+7APWzBJNbaqglY0eRFAwiVnHtaYJIlvA8d2ZvFmy+iZDI5cBeAksadLYfCE3h4AiKVp7n4A0CTdeBon2JNZ7BsAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 11,
    transform: "translate(330.4 113.5) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAYAAACksgdhAAAACXBIWXMAAC4jAAAuIwF4pT92AAABUklEQVQoU12RMW4UQRBFX/X0zK4XrbEsREyMuAAZARISAafgHpyFiIDUSI5JHZscIURmljU7nunuqk8wxlj8tOrrvVKZJP7P8w9flNeZ/KCnPx4YjlecPX1kf+f25O25+ocDedOzPj2i22T67UC37sjbgeFkhZnRrRKfnj02gAxgyUBQx4q3oDvKWAHNQdw4aZUIvwOR1JxyNSEXaoElqNcFCSQxXd1QDw257pUCMKPuC/V3QbOjGtR9Yf45QQhFUK8Lry5+CCB9ff/a6qGCAoWY94V2qJgZZkAyCIgm5LGQWEBIgCCq482ZdxPRApWg7mZU4k4xA6gF9VchmsibjKUEgE+Ol4l+22O1YQd4+fmbEoACfG7Qbu/ZzdT9TBQHFgszQ4JwLXrfP76xcFjgQiEsd7SxgQe4aGPDxwoRix63y21sWE54q1hvXL578e859/IH8IDVREJDRLwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 9,
    transform: "translate(330.4 111.8) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAp0lEQVQYV4WQvQ3CMBSEP0sGCuhgJhpoGYQR2IJRKKBnBVZAioCC/BDFR+GXxAEJTrJk+e47P9tJ4p/Wl6wL+V+mcqABgq0UaIO6DXhUAMkQHmB1zqQ8CVX0zcmZmxgQrgykAtSGa2AUt4fN3EXgaWYBasDNgAC683WTX+4z0QyN8ADnbX6sZGoAZW8A6AVuDKoNLuOLj9uFA/Bdi32dglAJp10MfOoNWrRU60RAKhMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 16,
    transform: "translate(332.6 111.8) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAQCAYAAAA1Qw7OAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAz0lEQVQYV02QsU0DURBE3+z+O2P7nDiwaAAKohC6oAWaQEi0AxEREoktBOiEbG4I/vFhw3ma0dPKNgBXT3tLcH+xFUBhvl4Qol0DmxL0/JECcP385l76F0MAbItYh9h14ubl3a2xSbFO+DLkXCu3r59GkBa7DLqYQSLOSyJgnGp4tx9dlllVAZSQEgWQbR4Oo1dRrY6GIStkm8nJJgQLify1KoKzECExBHxM8xTA43h0J3GyuVx2ai9ZpZgsiqpJAwuJoQTjd11oUwC2LdXKD12qPq5phxWeAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 4,
    transform: "translate(364.5 134.6) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAASElEQVQIW2N0OfT4/9dnnxk+3nzP8On6WwamX59+MsAAuxAnAxMzJwsDtzQvAws7MwMDAwMDC7swB8Pf738Y2EW5GH5//c0AAGTHFKqtaijsAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 3,
    transform: "translate(364.3 135.3) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAYAAABbNsX4AAAACXBIWXMAAC4jAAAuIwF4pT92AAAANklEQVQIW2P8//8/g9uEt/8ZkACL1763/xnYGRgYBRgY/r+HCjKwMTCwGkI4/2UYGLbZCjMCABAkDSG/oX7IAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 6,
    transform: "translate(364.3 134.6) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAGCAYAAADpJ08yAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAOUlEQVQIWwXBMRKAIAxFwRcmM5yRq+tYWUtFIZjw3bX+pWoxyjWTkcLvGfRIfAlWbPx4AwNo5yNJ/ClfHVqMjt54AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 10,
    transform: "translate(357.5 140.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA5ElEQVQYV02PMUoDQRiFv1kX9A5WNp7Awkaw0CIIiofwAJ7I2iq1WgasU1nYKBI0JGGzwWx25p+deRZhJQ9e8b7iwYckdnv+8qHdXbCTy9FE5X7J2fBdPXOSGIynstooDvawhSc2kc33mvH9iSuv3uaSIKdMWiVS6IjrgLq8fbh4nYhO5JSxZcBWnubrlxwT7ayldA5Sl/GzBmsiYbpBCKs8ZFE8nx46qz0S2LwFB1YFchJ+4bcWo9tj56cNOQurA4oZW3p+hjeu7HV85UFgdaBrI5PHa/ev2efo7knqMp8PA9ezP2DypbZJ1ZD4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 6,
    transform: "translate(356.3 141.8) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGCAYAAAARx7TFAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAgUlEQVQIW02NIQ7CUBBE32xqGjDtT8DiehBkb4ThUnVcgCOgUKimhKDAsIv47U9HzSQvb9TfpogX+Aj+Bn8AAZdTEnNs6JLUgLZABaoBwfE8RYGWQg22Ae3zlKmABjB0SdbONsAO2bpEEcVKf32Gj7n/7hAf8G+s7gA1YLtsXN/+ARUqI+Tt9RNWAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 5,
    transform: "translate(356.3 140.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFCAYAAAB8ZH1oAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAhElEQVQIW13MsQ3CMBRF0fv9bRQBQkRI0LEB6zAAk7ARA7ALFXWQAlJS2H4UKBR57T16Jon57v2o1p1NgG101m6EObp1gyTIEmYGQAXiBK7PXo0bx4VT8i+vgmFU9ilaBLg8XjokJwneGdooiozTMtl0FAHGKrpcCRb4WIEcOO+aPwL4AgpMKwmMjMnUAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 5,
    transform: "translate(362.6 138.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfUlEQVQIWzXMsQnCQACG0e+OuyQeKCgWQiBL2KRPJTau4E6O4ABWFjZuIHb2sQpoYxIjXPFbiOVrHpKQRLE9arE56G8jieXuoqHpiW3k8xi479fGVedaoRiTTFPedYufJAA46yw+eLLZiHQeeN2eAL9qdW1knSF2kVOZG4AvUW0zeMKmxaMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 5,
    transform: "translate(363.1 139.2) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAS0lEQVQIWyXHsQmAMBRAwfdjQATB0hV0jzTiLA6he1m6g0PEGZ5FrrtQASjnZ5ogAZSrJWbonv4wjS15hRQDAOQFYgBUtru6v1WVH1fvF2c84ubjAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 5,
    transform: "translate(362.6 139.2) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAACXBIWXMAAC4jAAAuIwF4pT92AAAASklEQVQIWz3IsRFAQBCG0W8vEulKn/pQgA4kQuGJmOHmdt0vMV74rEkyMD5pLcFyh/7I3thqMOZLACaJ6Siaz8ruIgEMfWcueIAX3FMjaP2HngIAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 5,
    transform: "translate(354.7 133.2) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAbElEQVQIW2P4//8/w////xlkY7f8h7EZ////z2A48cz/n2+/M/x6+5Ph9+dfDIwOu+////fzL8PPt98Zvj/9wvD7+x8GJhZ2FgZGJiYGLlk+Bj4NIQYGBgaIds8LL/7/+fyH4c/33wz73RQZAfpSOEzkb+E/AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 5,
    transform: "translate(355.1 133.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAS0lEQVQIWz3HMQ2AMBRF0fv62w2ShhIEsDGBB/SgAVNoQA0eHgMJZzuyDcB+Po5R5D+T0ABx18OpCVUoGyQA9VBWAMgxg7ov19L0Avy8DK4qv5pnAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 5,
    transform: "translate(354.7 133.7) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAACXBIWXMAAC4jAAAuIwF4pT92AAAARUlEQVQIWz3KMQ6AIBAF0VlO7kU8FL2JFYWUFESyZL+FhClfxkKSgbFK1zvJ3bWhevB4cNYugDQkhCg+ATDpv4/SdI/gA6whJNJBoMSbAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 12,
    transform: "translate(358.7 134.4) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAACXBIWXMAAC4jAAAuIwF4pT92AAABTElEQVQoU3WRsW5UMRBFz50Z+7232bBaKQVFJCS+IQ0FDS0VFSU1XT6KD0AUSEkK/oASUadJQ4VEksfaawonj21i6cqyNPd45o5aazx1Xn68bPWuUO8L9b5y8/mdAOKx4NWnH233e6bOlXK7o9wWAGQGEsgWWLz5dt3qXFA2YpPhT6HcFWRg4VgYMmh/58VkjwAfvROBvBnwVWI4GZEbmOFTcPr+SwMwMyOGIMZEJCcf58XMw+XZUOoCsKvXp7LRe6+bjGUnraODpkQcBTY6abWMjwHIha8Cufq8ErFOvdVnA7IehCfnxYevLaAnJG89KROWjP3OiHViP1fSOmNRqXOBUvtPF2fPFVMQUzBsR/LxQDoKeFjhvjbkIm8HFM4SvkxdEjY5NnSAZ2fcDksocLBcuVAI7QW7/wUIvp+fHViA1tqitz9/tcP3U/oH8ZZwTLfmsAoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 9,
    transform: "translate(359 136.5) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAuElEQVQYV3WQQQrCMBBF35+molXQWjyD3kNw4cIreQUPI7jzRLoruCgyLjLWojibkLz/MsnI3flX2+PNZQIDpXyWhnAYtrH4Lk0GAoBMUIAKQFDUwh1kQAEkkLuzO93dnxEEtARv+cgJKAGLDloBLagEJkAHWoAU0jhfdDk08RUDm0dbA01jrcC7kMospf317jbLIe8CWAgjEPTvB0iq8uYNVWfAI0IJzpumH1lSnaHKgOvmd56DegEYGyNRzO0LcgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 16,
    transform: "translate(358.3 134.9) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAQCAYAAAA1Qw7OAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA10lEQVQYV1WPO07EQBBE3wzelQwiQCKAlANxAY5BwmW4AlfgDmTERKAF7a7swb+pIvDYQEsttfqpuquCbQAG2dsYAqUqgMMkG9jGdU8ESDJJ5m3I/qdIMgHY/FW8pNHZ5pDNx5h/QSuzm0wr02bzfOwNUCUZG4wxsCnGKmEaQZZRgQDh6TO5kZGhjmAgL6cGQW/TKdBZiEC8uzwNI2YyfOVMI6Mlxz6LNs8m6pPA/dVZiAAP1+dhKl/fB82ulkDHyXQWdUm/gt7mW+bx5mImtte+fd15mX8AlhCW4KnoMDYAAAAASUVORK5CYII="
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPaper);
export default __webpack_public_path__ + "static/media/about-paper.e4e96bd9721e2ee67fedd8e7371edf35.svg";
export { ForwardRef as ReactComponent };